import React, { useState, useEffect, useRef, useMemo } from 'react';

import { initializeApp } from 'firebase/app';
import { getAuth, GoogleAuthProvider, signInWithPopup, signInWithRedirect, getRedirectResult, getIdToken } from 'firebase/auth';

const firebaseConfig = {
  apiKey: "AIzaSyDlx-fjKX3XZyECCfbz7-wl1kyfZSElI6Q",
  authDomain: "sistemapp.firebaseapp.com",
  projectId: "sistemapp",
  storageBucket: "sistemapp.firebasestorage.app",
  messagingSenderId: "412733274428",
  appId: "1:412733274428:web:394977e1390b4d016ec639",
  measurementId: "G-DMP5MRMP5P"
};

const firebaseApp = initializeApp(firebaseConfig);
const auth = getAuth(firebaseApp);
const googleProvider = new GoogleAuthProvider();


import { 
  LayoutDashboard, LogOut, ChevronRight, X, Search, 
  Link as LinkIcon, ExternalLink, Lock, FileSpreadsheet, Plus, Trash2,
  BookOpen, Calculator, FlaskConical, Languages, 
  Trophy, Users, Palette, Utensils, Bus, Library, 
  MonitorPlay, Code2, GraduationCap, ShieldCheck, 
  Briefcase, Globe, AlertCircle, Save, Info, Edit3, CheckSquare, Square, XCircle, CheckCircle, User, Loader2, Calendar, ChevronLeft, Flag, MapPin, CalendarDays, ClipboardList, Clock, AlertTriangle, FileText, Printer, Check, Settings, LogIn, UserCheck, PieChart, Filter, HelpCircle, Award, RotateCcw, History, RefreshCw, List, CalendarClock, QrCode, Copy, Camera, ChevronDown, Activity, BarChart3, Download, Share, Megaphone, CalendarCheck, Bell, BellRing, BellOff, Send, PanelLeftClose, PanelLeft
} from 'lucide-react';

// --- API CONFIGURATION ---
        const API_BASE = '/api';
        let _jwtToken = null;
        const setToken = (t) => { _jwtToken = t; };
        const api = async (path, opts = {}) => {
            const headers = { 'Content-Type': 'application/json', ...opts.headers };
            if (_jwtToken) headers['Authorization'] = `Bearer ${_jwtToken}`;
            const res = await fetch(`${API_BASE}${path}`, { ...opts, headers });
            if (!res.ok) {
                const err = await res.json().catch(() => ({ error: res.statusText }));
                throw new Error(err.error || 'API Error');
            }
            return res.json();
        };


// --- STUDENT KEY HELPER ---
// Attendance records from Firestore use Firebase string IDs as keys.
// Students table uses MySQL integer IDs. We need firebase_id to match.
// If a student has firebase_id, use it; otherwise fall back to integer id.
const studentKey = (s) => s.firebase_id || String(s.id);

// --- ICONS & DATA ---
const ICONS = {
  umum: { dashboard: { i: LayoutDashboard, color: 'text-blue-600', bg: 'bg-blue-50' }, portal: { i: Globe, color: 'text-emerald-600', bg: 'bg-emerald-50' }, admin: { i: ShieldCheck, color: 'text-slate-600', bg: 'bg-slate-100' } },
  akademik: { buku: { i: BookOpen, color: 'text-emerald-600', bg: 'bg-emerald-50' }, math: { i: Calculator, color: 'text-violet-600', bg: 'bg-violet-50' }, sains: { i: FlaskConical, color: 'text-teal-600', bg: 'bg-teal-50' }, bahasa: { i: Languages, color: 'text-rose-600', bg: 'bg-rose-50' } },
  koko: { sukan: { i: Trophy, color: 'text-orange-600', bg: 'bg-orange-50' }, seni: { i: Palette, color: 'text-pink-600', bg: 'bg-pink-50' }, kelab: { i: Users, color: 'text-cyan-600', bg: 'bg-cyan-50' } },
  fasiliti: { kantin: { i: Utensils, color: 'text-yellow-600', bg: 'bg-yellow-50' }, bas: { i: Bus, color: 'text-blue-800', bg: 'bg-blue-100' }, ps: { i: Library, color: 'text-amber-700', bg: 'bg-amber-50' } }
};
const ALL_ICONS = {}; Object.values(ICONS).forEach(cat => Object.assign(ALL_ICONS, cat));

const KPM_EVENTS = [
    { start: '2026-01-12', end: '2026-03-20', type: 'school', title: 'Sesi Persekolahan Penggal 1' },
    { start: '2026-03-21', end: '2026-03-29', type: 'holiday', title: 'Cuti Penggal 1' },
    { start: '2026-03-30', end: '2026-05-22', type: 'school', title: 'Sambungan Penggal 1' },
    { start: '2026-05-23', end: '2026-06-07', type: 'holiday', title: 'Cuti Pertengahan Tahun' },
    { start: '2026-06-08', end: '2026-08-28', type: 'school', title: 'Sesi Persekolahan Penggal 2' },
    { start: '2026-08-29', end: '2026-09-06', type: 'holiday', title: 'Cuti Penggal 2' },
    { start: '2026-09-07', end: '2026-12-04', type: 'school', title: 'Sesi Persekolahan Penggal 3' },
    { start: '2026-12-05', end: '2026-12-31', type: 'holiday', title: 'Cuti Akhir Persekolahan' },
];

const DEFAULT_TASKS = {
    pentadbiran: ["Guru Besar", "GPK Pentadbiran", "GPK HEM", "GPK Kokurikulum", "Guru Data", "Guru Bimbingan & Kaunseling", "Penyelaras ICT", "Guru Perpustakaan & Media (GPM)", "Penyelaras Prasekolah", "Penyelaras PPKI", "Penyelaras Bestari / Delima", "Pegawai Aset"],
    kurikulum: ["Setiausaha Kurikulum", "Setiausaha Peperiksaan / UASA", "Penyelaras PBD", "Penyelaras Jadual Waktu", "Penyelaras Transisi Tahun 1", "Penyelaras Pemulihan Khas", "Penyelaras TS25 / PAK21", "Penyelaras KBAT / i-Think", "Penyelaras HIP", "Penyelaras PLAN", "Penyelaras SPLKPM", "KP Bahasa Melayu", "KP Bahasa Inggeris", "KP Matematik", "KP Sains", "KP Pendidikan Islam", "KP Pendidikan Moral / B. Arab", "KP Sejarah", "KP RBT", "KP PSV / Muzik", "KP PJPK"],
    hem: ["Setiausaha HEM", "Penyelaras APDM / IDME", "Penyelaras SPBT", "Penyelaras RMT & Susu (PSS)", "Penyelaras Kantin", "Penyelaras 3K (Kebersihan, Kesihatan, Keselamatan)", "Penyelaras Disiplin & Pengawas", "Penyelaras BAP / KWAPM", "Penyelaras PPDa", "Penyelaras Kebajikan & Bantuan", "Penyelaras Penempatan (Ting 1 / SBP)"],
    kokurikulum: ["Setiausaha Kokurikulum", "Setiausaha Sukan", "Penyelaras PAJSK", "Penyelaras Unit Beruniform", "Penyelaras Kelab & Persatuan", "Penyelaras Sukan & Permainan", "Penyelaras Rumah Sukan", "Guru Penasihat Pengakap", "Guru Penasihat TKRS", "Guru Penasihat PPIM", "Guru Penasihat Tunas Puteri", "Guru Penasihat B. Melayu / Kebudayaan", "Guru Penasihat B. Inggeris", "Guru Penasihat Agama Islam", "Guru Penasihat STEM / Doktor Muda", "Guru Penasihat Rukun Negara", "Guru Penasihat Bola Sepak", "Guru Penasihat Bola Jaring", "Guru Penasihat Bola Baling", "Guru Penasihat Ping Pong", "Guru Penasihat Olahraga"],
    kelas: ["Guru Kelas Tahun 1", "Guru Kelas Tahun 2", "Guru Kelas Tahun 3", "Guru Kelas Tahun 4", "Guru Kelas Tahun 5", "Guru Kelas Tahun 6", "Guru Kelas Prasekolah", "Guru Kelas PPKI"]
};

// --- HELPER: DATE FORMATTER (DD/MM/YYYY) ---
const formatDate = (dateString) => {
    if (!dateString) return "-";
    let cleanDate = dateString;
    // Handle ISO format: 2026-06-19T03:20:22.000Z
    if (typeof dateString === 'string' && dateString.includes('T')) {
        cleanDate = dateString.split('T')[0];
    }
    // Handle MariaDB DATETIME format: 2026-06-19 03:20:22
    if (typeof dateString === 'string' && dateString.includes(' ')) {
        cleanDate = dateString.split(' ')[0];
    }
    // Already DD/MM/YYYY
    if (typeof cleanDate === 'string' && cleanDate.match(/^\d{2}\/\d{2}\/\d{4}$/)) return cleanDate;
    // YYYY-MM-DD → DD/MM/YYYY
    if (typeof cleanDate === 'string' && cleanDate.match(/^\d{4}-\d{2}-\d{2}$/)) {
        const [y, m, d] = cleanDate.split('-');
        return `${d}/${m}/${y}`;
    }
    const d = new Date(cleanDate);
    if (isNaN(d.getTime())) return dateString; 
    const day = d.getDate().toString().padStart(2, '0');
    const month = (d.getMonth() + 1).toString().padStart(2, '0');
    const year = d.getFullYear();
    return `${day}/${month}/${year}`;
};

// --- HELPER: GET MALAYSIA DATE (YYYY-MM-DD) ---
// Memastikan tarikh sentiasa mengikut Zon Masa Malaysia (GMT+8)
// Mengelakkan masalah tarikh 'backdated' jika dibuka antara 12:00 AM - 8:00 AM
const getTodayDate = () => {
    return new Date().toLocaleDateString('en-CA', { timeZone: 'Asia/Kuala_Lumpur' });
};

// --- 1. UTILITY COMPONENTS ---

function AccessDenied() { 
    return (
        <div className="h-full flex flex-col items-center justify-center text-slate-400 font-bold">
            <Lock className="w-12 h-12 mb-4 opacity-50"/>
            <p>Akses Terhad</p>
        </div>
    ); 
}

function ConfirmModal({ title, msg, onConfirm, onCancel }) { 
    return (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-[100] animate-fade-in" onClick={onCancel}>
            <div className="bg-white p-6 rounded-xl w-80 shadow-2xl" onClick={e => e.stopPropagation()}>
                <h3 className="font-bold text-lg mb-2 text-slate-800">{title}</h3>
                <p className="text-slate-500 mb-6 text-sm">{msg}</p>
                <div className="flex justify-end gap-2">
                    <button onClick={onCancel} className="px-4 py-2 rounded text-sm font-bold text-slate-600 bg-slate-100 hover:bg-slate-200">Batal</button>
                    <button onClick={onConfirm} className="px-4 py-2 rounded text-sm font-bold bg-red-600 text-white hover:bg-red-700">Ya, Padam</button>
                </div>
            </div>
        </div>
    ); 
}

// Universal confirm hook — guna di mana-mana komponen
function useConfirmModal() {
    const [confirmState, setConfirmState] = useState(null); // { title, msg, onConfirm }
    const confirm = (title, msg, onConfirm) => setConfirmState({ title, msg, onConfirm });
    const modal = confirmState ? (
        <ConfirmModal
            title={confirmState.title}
            msg={confirmState.msg}
            onConfirm={() => { confirmState.onConfirm?.(); setConfirmState(null); }}
            onCancel={() => setConfirmState(null)}
        />
    ) : null;
    return { confirm, modal };
}

function LoginScreen({ onGoogleLogin, loginLoading }) {
  const [popupBlocked, setPopupBlocked] = useState(false);

  const handleGoogleLogin = async () => {
    setPopupBlocked(false);
    try {
      const result = await signInWithPopup(auth, googleProvider);
      const idToken = await getIdToken(result.user);
      onGoogleLogin(idToken);
    } catch (err) {
      if (err.code === 'auth/popup-blocked' || err.code === 'auth/popup-closed-by-user' || err.code === 'auth/cancelled-popup-request') {
        // Fallback to redirect
        signInWithRedirect(auth, googleProvider);
      } else if (err.code === 'auth/unauthorized-domain') {
        setPopupBlocked(true);
      } else {
        console.error('[auth] Popup error:', err.code, err.message);
        setPopupBlocked(true);
      }
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#EEF2FF] p-4 animate-fade-in relative overflow-hidden">
         {/* Vector Blob Backgrounds */}
         <div className="absolute top-[-10%] left[-10%] w-[500px] h-[500px] bg-purple-200 rounded-full mix-blend-multiply filter blur-3xl opacity-50 animate-blob"></div>
         <div className="absolute top-[-10%] right[-10%] w-[500px] h-[500px] bg-yellow-200 rounded-full mix-blend-multiply filter blur-3xl opacity-50 animate-blob animation-delay-2000"></div>
         <div className="absolute bottom-[-20%] left-[20%] w-[500px] h-[500px] bg-pink-200 rounded-full mix-blend-multiply filter blur-3xl opacity-50 animate-blob animation-delay-4000"></div>

         <div className="max-w-5xl w-full bg-white/80 backdrop-blur-xl rounded-[2rem] shadow-2xl border border-white flex flex-col md:flex-row relative z-10 overflow-hidden">
            
             {/* Left Side: Vector Illustration Area */}
             <div className="w-full md:w-1/2 bg-emerald-600 p-12 flex flex-col justify-between text-white relative overflow-hidden">
                 {/* Abstract Patterns */}
                 <div className="absolute top-0 right-0 w-32 h-32 bg-white/10 rounded-full blur-2xl transform translate-x-10 -translate-y-10"></div>
                 <div className="absolute bottom-0 left-0 w-32 h-32 bg-white/10 rounded-full blur-2xl transform -translate-x-10 translate-y-10"></div>
                 
                 <div className="relative z-10">
                     <div className="flex items-center gap-3 mb-6">
                         <div className="p-2 bg-white/20 rounded-lg backdrop-blur-sm">
                             <BookOpen className="w-6 h-6 text-white"/>
                         </div>
                         <span className="font-bold tracking-wider text-sm opacity-90">SKOLAHUB 3.0</span>
                     </div>
                     <h2 className="text-4xl font-black mb-4 leading-tight">Pengurusan Sekolah <br/>Lebih Pintar.</h2>
                     <p className="text-emerald-100 text-sm leading-relaxed max-w-xs">Sistem berpusat untuk kehadiran, MMI, jadual waktu, guru ganti dan analisis data masa nyata.</p>
                 </div>

                 {/* Illustration Image */}
                 <div className="relative mt-8 flex justify-center">
                     <img 
                         src="/assets/img/online-school-learning.png" 
                         className="w-64 drop-shadow-2xl hover:scale-105 transition-transform duration-500"
                         alt="Vector Student"
                         onError={(e) => e.target.style.display = 'none'}
                     />
                 </div>
                 
                 <div className="mt-8 flex gap-2">
                     <div className="h-1 w-8 bg-white rounded-full"></div>
                     <div className="h-1 w-2 bg-white/30 rounded-full"></div>
                     <div className="h-1 w-2 bg-white/30 rounded-full"></div>
                 </div>
             </div>

             {/* Right Side: Login Form */}
             <div className="w-full md:w-1/2 p-10 md:p-16 flex flex-col justify-center items-center bg-white relative">
                 <div className="w-20 h-20 bg-emerald-50 rounded-2xl flex items-center justify-center mb-6 shadow-sm border border-emerald-100 transform -rotate-3 hover:rotate-0 transition-transform duration-300">
                     <img src="/assets/img/school-logo.png" alt="Logo Sekolah" className="w-12 h-12 object-contain"/>
                 </div>
                 
                 <h3 className="text-2xl font-bold text-slate-800 mb-2">Selamat Datang!</h3>
                 <p className="text-slate-400 mb-10 text-center text-sm font-medium">Sila log masuk menggunakan akaun Google Guru / Pentadbir.</p>
                 
                 {/* Custom Google Sign-In Button */}
                 <button 
                   onClick={handleGoogleLogin}
                   disabled={loginLoading}
                   className="flex items-center gap-3 px-6 py-3 rounded-xl border border-slate-300 bg-white hover:bg-slate-50 transition-all shadow-sm hover:shadow-md disabled:opacity-60 disabled:cursor-not-allowed"
                 >
                   {loginLoading ? (
                     <Loader2 className="w-5 h-5 animate-spin text-slate-500" />
                   ) : (
                     <svg className="w-5 h-5" viewBox="0 0 24 24">
                       <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"/>
                       <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/>
                       <path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"/>
                       <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"/>
                     </svg>
                   )}
                   <span className="font-semibold text-slate-700 text-sm">{loginLoading ? 'Sedang log masuk...' : 'Log masuk dengan Google'}</span>
                 </button>

                 {popupBlocked && (
                   <div className="mt-4 p-3 bg-amber-50 border border-amber-200 rounded-lg text-xs text-amber-700 max-w-xs text-center">
                     Pop-up disekat oleh pelayar. Sila benarkan pop-up untuk laman ini atau guna mod incognito.
                   </div>
                 )}
                 
                 <div className="mt-12 text-center">
                     <p className="text-[10px] text-slate-300 font-bold uppercase tracking-widest mb-2">Dibangunkan Oleh</p>
                     <div className="flex items-center justify-center gap-2 opacity-60 grayscale hover:grayscale-0 transition-all cursor-default">
                         <span className="text-xs font-bold text-slate-500">Unit ICT SK Masjid Tanah</span>
                     </div>
                 </div>
             </div>
         </div>
    </div>
  );
}

// --- 2. LAYOUT COMPONENTS (SIDEBAR & RESPONSIVE LOGIC) ---

function Sidebar({ userData, view, setView, logout, badges = {} }) {
  const [searchQuery, setSearchQuery] = useState('');
  const [mobileOpen, setMobileOpen] = useState(false);
  const menus = [
     { id: 'dashboard', l: 'Utama', i: LayoutDashboard },
     { id: 'mmi', l: 'MMI', i: QrCode },
     { id: 'timetable', l: 'Jadual Waktu', i: CalendarClock },
     { id: 'apps', l: 'Aplikasi', i: MonitorPlay },
     { id: 'takwim', l: 'Takwim', i: CalendarDays },
     { id: 'attendance', l: 'Kehadiran', i: UserCheck },
     { id: 'tasks', l: 'Tugasan', i: ClipboardList },
     { id: 'reports', l: 'Laporan', i: FileText },
     // UBAH: AGIHAN TUGAS DIBUANG DARI SIDEBAR
     // { id: 'agihan', l: 'Agihan Tugas', i: Briefcase, access: ['admin', 'pentadbir'] },
     { id: 'builder', l: 'Bina App', i: Code2 },
     { id: 'keberadaan', l: 'Keberadaan', i: CalendarCheck, access: ['admin', 'pentadbir'] },
     { id: 'relief', l: 'Guru Ganti', i: UserCheck, access: ['admin', 'pentadbir', 'guru'] },
     { id: 'students', l: 'Data Murid', i: GraduationCap, access: ['admin', 'pentadbir'] },
     { id: 'teachers', l: 'Data Guru', i: Users, access: ['admin', 'pentadbir'] },
  ];
  
  const adminMenus = [
      { id: 'logs', l: 'Log Sistem', i: Activity, access: ['admin'] },
      { id: 'stats', l: 'Statistik', i: BarChart3, access: ['admin'] },
      { id: 'settings', l: 'Tetapan Telegram', i: Settings, access: ['admin'] }
  ];

  // Filter menus by search query (sidebar search bar)
  const q = searchQuery.toLowerCase().trim();
  const filteredMenus = q ? menus.filter(m => m.l.toLowerCase().includes(q)) : menus;
  const filteredAdminMenus = q ? adminMenus.filter(m => m.l.toLowerCase().includes(q)) : adminMenus;

  // Render notification badge dot for relief / attendance
  const renderBadge = (id) => {
      const count = badges[id];
      if (!count || count <= 0) return null;
      return <span className="absolute top-1 right-1 flex min-w-[16px] h-4 px-1 items-center justify-center text-[9px] font-bold text-white bg-red-500 rounded-full shadow-sm border border-white">{count > 9 ? '9+' : count}</span>;
  };



  // --- PUSH NOTIFICATION LOGIC ---
  const [pushStatus, setPushStatus] = useState('unknown'); // 'enabled' | 'disabled' | 'unknown'
  const [pushLoading, setPushLoading] = useState(false);

  // Check notification permission on mount. If permission already granted,
  // re-send the browser subscription to server (PWA reinstall / DB empty case).
  useEffect(() => {
     if (!('Notification' in window) || !('serviceWorker' in navigator) || !('PushManager' in window)) {
        setPushStatus('disabled');
        return;
     }
     if (Notification.permission === 'granted') {
        subscribePush({ silent: true });
     } else if (Notification.permission === 'denied') {
        setPushStatus('disabled');
     } else {
        setPushStatus('unknown');
     }
  }, []);

  // Subscribe / repair subscription: browser subscription must also be saved in MariaDB.
  const subscribePush = async ({ silent = false } = {}) => {
     setPushLoading(true);
     try {
        const token = localStorage.getItem('skolahub_jwt');
        if (!token) throw new Error('Sesi login belum tersedia. Sila log masuk semula.');
        const reg = await navigator.serviceWorker.ready;
        const vapidRes = await fetch('/api/push/vapid-key', {
           headers: { 'Authorization': 'Bearer ' + token }
        });
        if (!vapidRes.ok) throw new Error('Gagal dapatkan VAPID key');
        const { publicKey } = await vapidRes.json();
        if (!publicKey) throw new Error('Pelayan tidak dikonfigurasi untuk push notifikasi');

        const convertedKey = urlBase64ToUint8Array(publicKey);
        let subscription = await reg.pushManager.getSubscription();
        if (!subscription) {
           subscription = await reg.pushManager.subscribe({
              userVisibleOnly: true,
              applicationServerKey: convertedKey,
           });
        }

        const subJson = subscription.toJSON ? subscription.toJSON() : subscription;
        const subscribeRes = await fetch('/api/push/subscribe', {
           method: 'POST',
           headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token },
           body: JSON.stringify({
              endpoint: subJson.endpoint,
              keys: subJson.keys,
           }),
        });
        if (!subscribeRes.ok) {
           const err = await subscribeRes.json().catch(() => ({ error: subscribeRes.statusText }));
           throw new Error(err.error || 'Gagal simpan subscription notifikasi');
        }

        setPushStatus('enabled');
        if (!silent) alert('Notifikasi guru ganti sudah aktif untuk peranti ini.');
     } catch (err) {
        console.error('Push subscribe error:', err);
        if (Notification.permission === 'denied') setPushStatus('disabled');
        else setPushStatus('unknown');
        if (!silent) alert('Notifikasi gagal diaktifkan: ' + err.message);
     } finally {
        setPushLoading(false);
     }
  };

  const togglePush = async () => {
     if (pushStatus === 'enabled') {
        // Unsubscribe
        setPushLoading(true);
        try {
           const reg = await navigator.serviceWorker.ready;
           const sub = await reg.pushManager.getSubscription();
           if (sub) {
              await sub.unsubscribe();
              await fetch('/api/push/unsubscribe', {
                 method: 'POST',
                 headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + localStorage.getItem('skolahub_jwt') },
                 body: JSON.stringify({ endpoint: sub.endpoint }),
              });
           }
           setPushStatus('disabled');
        } catch (err) { console.error('Unsubscribe error:', err); }
        finally { setPushLoading(false); }
     } else {
        // Request permission and subscribe
        const permission = await Notification.requestPermission();
        if (permission === 'granted') {
           await subscribePush();
        } else {
           setPushStatus('disabled');
           alert('Notifikasi telah disekat. Sila benarkan notifikasi dalam tetapan pelayar untuk menerima pemberitahuan guru ganti.');
        }
     }
  };

  const testPush = async () => {
     try {
        const res = await fetch('/api/push/test', {
           method: 'POST',
           headers: { 'Authorization': 'Bearer ' + localStorage.getItem('skolahub_jwt') },
        });
        if (!res.ok) throw new Error((await res.json().catch(() => ({}))).error || res.statusText);
        alert('Notifikasi ujian dihantar. Jika tidak keluar, semak permission notifikasi peranti/browser.');
     } catch (err) {
        console.error('Test push error:', err);
        alert('Ujian notifikasi gagal: ' + err.message);
     }
  };

  // Helper: convert base64 VAPID key to Uint8Array
  function urlBase64ToUint8Array(base64String) {
     const padding = '='.repeat((4 - base64String.length % 4) % 4);
     const base64 = (base64String + padding).replace(/\\-/g, '+').replace(/_/g, '/');
     const rawData = atob(base64);
     const outputArray = new Uint8Array(rawData.length);
     for (let i = 0; i < rawData.length; ++i) {
        outputArray[i] = rawData.charCodeAt(i);
     }
     return outputArray;
  }


  
  return (
     <>
     {/* Mobile Hamburger Button - hidden when sidebar open */}
     {!mobileOpen && (
     <button
        onClick={() => setMobileOpen(true)}
        className="md:hidden fixed top-3 left-3 z-[60] p-2 rounded-lg bg-white border border-slate-200 shadow-sm text-slate-600 hover:bg-slate-50 transition-colors no-print"
        aria-label="Buka menu"
     >
        <PanelLeft className="w-5 h-5" />
     </button>
     )}

     {/* Mobile Overlay - click to close */}
     {mobileOpen && (
        <div
           onClick={() => setMobileOpen(false)}
           className="md:hidden fixed inset-0 bg-black/40 z-[55] animate-fade-in no-print"
        />
     )}

     {/* Desktop Sidebar (tetap, sama macam sebelum) */}
     <aside className="hidden md:flex w-64 bg-white border-r border-slate-200 flex-col shrink-0 z-50 no-print h-full md:relative">
        {/* Desktop Logo */}
        <div className="hidden md:flex h-20 items-center justify-center md:justify-start md:px-6 border-b border-slate-100 gap-3"><img src="/assets/img/school-logo.png" className="w-10 h-10 object-contain"/><div className="hidden md:block"><span className="block font-bold text-lg text-slate-800 leading-tight">SkolaHub</span><span className="block text-[10px] font-bold text-slate-500 uppercase tracking-wide">SK Masjid Tanah</span></div></div>
        
        {/* Profile Block (Desktop Only) */}
        <div className="hidden md:flex p-4 border-b border-slate-100 items-center gap-3 relative group-user">
           <img src={userData.photo || "/api/avatar.php?name="+userData.name} className="w-10 h-10 rounded-full border border-slate-200"/><div className="hidden md:block overflow-hidden"><p className="text-sm font-bold text-slate-700 truncate">{userData.name}</p><p className="text-xs text-slate-500 uppercase font-bold tracking-wider">{userData.role}</p></div>
        </div>
        
        {/* Navigation Menu (Vertical Stack Desktop) */}
        <nav className="flex-1 flex flex-col items-stretch overflow-y-auto p-4 space-y-1 no-scrollbar">
            {/* Sidebar Search Bar (Desktop Only) */}
            <div className="hidden md:block relative mb-2">
                <Search className="absolute left-2.5 top-1/2 -translate-y-1/2 w-4 h-4 text-slate-400" />
                <input
                    type="text"
                    value={searchQuery}
                    onChange={(e) => setSearchQuery(e.target.value)}
                    placeholder="Cari menu..."
                    className="w-full pl-8 pr-3 py-2 text-sm rounded-lg border border-slate-200 bg-slate-50 text-slate-700 placeholder-slate-400 focus:outline-none focus:ring-2 focus:ring-emerald-500 focus:border-emerald-400 transition-all"
                />
            </div>
            {filteredMenus.map(m => (!m.access || m.access.includes(userData.role)) && <button key={m.id} onClick={() => { setView(m.id); setMobileOpen(false); }} title={m.l} className={`relative flex items-center justify-start gap-3 px-3 py-2 rounded-lg text-sm font-medium transition-all ${view === m.id ? 'bg-emerald-50 text-emerald-700 shadow-sm border border-emerald-100' : 'text-slate-500 hover:bg-slate-50 border border-transparent'}`}><m.i className={`w-5 h-5 ${view === m.id ? 'text-emerald-600' : 'text-slate-400'}`} /><span>{m.l}</span>{renderBadge(m.id)}</button>)}
            
            {userData.role === 'admin' && filteredAdminMenus.length > 0 && (
                <>
                    <div className="hidden md:block my-2 border-t border-slate-100 mx-2"></div>
                    {filteredAdminMenus.map(m => <button key={m.id} onClick={() => { setView(m.id); setMobileOpen(false); }} title={m.l} className={`relative flex items-center justify-start gap-3 px-3 py-2 rounded-lg text-sm font-medium transition-all ${view === m.id ? 'bg-emerald-50 text-emerald-700 shadow-sm border border-emerald-100' : 'text-slate-500 hover:bg-slate-50 border border-transparent'}`}><m.i className={`w-5 h-5 ${view === m.id ? 'text-emerald-600' : 'text-slate-400'}`} /><span>{m.l}</span>{renderBadge(m.id)}</button>)}
                </>
            )}
        </nav>
        
        {/* Bottom Actions (Desktop Only - Notification, Install & Logout) */}
        <div className="hidden md:block p-4 border-t border-slate-100 space-y-2">
            <button onClick={togglePush} disabled={pushLoading}
              className={`flex items-center justify-start gap-3 text-sm font-bold w-full px-3 py-3 rounded-lg transition-colors border ${pushStatus === 'enabled' ? 'text-emerald-600 hover:bg-emerald-50 border-emerald-100' : 'text-slate-500 hover:bg-slate-50 border-slate-100'}`}>
                {pushLoading ? <Loader2 className="w-5 h-5 animate-spin"/> : pushStatus === 'enabled' ? <BellRing className="w-5 h-5"/> : <Bell className="w-5 h-5"/>}
                <span>{pushStatus === 'enabled' ? 'Notifikasi Aktif' : 'Dayakan Notifikasi'}</span>
            </button>
            {pushStatus === 'enabled' && (
                <button onClick={testPush} className="flex items-center justify-start gap-3 text-xs text-slate-400 hover:text-emerald-600 w-full px-3 py-2 rounded-lg transition-colors">
                    <Megaphone className="w-4 h-4"/>
                    <span>Uji Notifikasi</span>
                </button>
            )}
            <button onClick={logout} className="flex items-center justify-start gap-3 text-slate-400 hover:text-red-600 hover:bg-red-50 text-sm font-medium w-full px-3 py-3 rounded-lg transition-colors"><LogOut className="w-5 h-5" /><span>Keluar</span></button>
        </div>
     </aside>

     {/* Mobile Slide-out Sidebar (kiri, dengan icon + nama) */}
     <aside className={`md:hidden fixed top-0 left-0 h-full w-72 bg-white border-r border-slate-200 flex flex-col z-[60] no-print transition-transform duration-300 ease-out ${mobileOpen ? 'translate-x-0' : '-translate-x-full'}`}>
        {/* Mobile Header dengan logo + close button */}
        <div className="flex items-center justify-between px-4 h-16 border-b border-slate-100 shrink-0">
            <div className="flex items-center gap-3">
                <img src="/assets/img/school-logo.png" className="w-8 h-8 object-contain"/>
                <div>
                    <span className="block font-bold text-base text-slate-800 leading-tight">SkolaHub</span>
                    <span className="block text-[9px] font-bold text-slate-500 uppercase tracking-wide">SK Masjid Tanah</span>
                </div>
            </div>
            <button
                onClick={() => setMobileOpen(false)}
                className="p-2 rounded-lg text-slate-400 hover:bg-slate-100 hover:text-slate-600 transition-colors"
                aria-label="Tutup menu"
            >
                <X className="w-5 h-5" />
            </button>
        </div>

        {/* Profile Block */}
        <div className="flex p-4 border-b border-slate-100 items-center gap-3 shrink-0">
            <img src={userData.photo || "/api/avatar.php?name="+userData.name} className="w-10 h-10 rounded-full border border-slate-200"/>
            <div className="overflow-hidden">
                <p className="text-sm font-bold text-slate-700 truncate">{userData.name}</p>
                <p className="text-xs text-slate-500 uppercase font-bold tracking-wider">{userData.role}</p>
            </div>
        </div>

        {/* Mobile Nav Menu - icon + nama, vertical scroll */}
        <nav className="flex-1 flex flex-col items-stretch overflow-y-auto p-4 space-y-1 no-scrollbar">
            {filteredMenus.map(m => (!m.access || m.access.includes(userData.role)) && <button key={m.id} onClick={() => { setView(m.id); setMobileOpen(false); }} className={`relative flex items-center justify-start gap-3 px-3 py-3 rounded-lg text-sm font-medium transition-all ${view === m.id ? 'bg-emerald-50 text-emerald-700 shadow-sm border border-emerald-100' : 'text-slate-500 hover:bg-slate-50 border border-transparent'}`}><m.i className={`w-5 h-5 shrink-0 ${view === m.id ? 'text-emerald-600' : 'text-slate-400'}`} /><span className="truncate">{m.l}</span>{renderBadge(m.id)}</button>)}
            
            {userData.role === 'admin' && filteredAdminMenus.length > 0 && (
                <>
                    <div className="my-2 border-t border-slate-100 mx-2"></div>
                    {filteredAdminMenus.map(m => <button key={m.id} onClick={() => { setView(m.id); setMobileOpen(false); }} className={`relative flex items-center justify-start gap-3 px-3 py-3 rounded-lg text-sm font-medium transition-all ${view === m.id ? 'bg-emerald-50 text-emerald-700 shadow-sm border border-emerald-100' : 'text-slate-500 hover:bg-slate-50 border border-transparent'}`}><m.i className={`w-5 h-5 shrink-0 ${view === m.id ? 'text-emerald-600' : 'text-slate-400'}`} /><span className="truncate">{m.l}</span>{renderBadge(m.id)}</button>)}
                </>
            )}
        </nav>

        {/* Mobile Bottom Actions */}
        <div className="p-4 border-t border-slate-100 space-y-2 shrink-0">
            <button onClick={togglePush} disabled={pushLoading}
              className={`flex items-center justify-start gap-3 text-sm font-bold w-full px-3 py-3 rounded-lg transition-colors border ${pushStatus === 'enabled' ? 'text-emerald-600 hover:bg-emerald-50 border-emerald-100' : 'text-slate-500 hover:bg-slate-50 border-slate-100'}`}>
                {pushLoading ? <Loader2 className="w-5 h-5 animate-spin"/> : pushStatus === 'enabled' ? <BellRing className="w-5 h-5"/> : <Bell className="w-5 h-5"/>}
                <span>{pushStatus === 'enabled' ? 'Notifikasi Aktif' : 'Dayakan Notifikasi'}</span>
            </button>
            {pushStatus === 'enabled' && (
                <button onClick={testPush} className="flex items-center justify-start gap-3 text-xs text-slate-400 hover:text-emerald-600 w-full px-3 py-2 rounded-lg transition-colors">
                    <Megaphone className="w-4 h-4"/>
                    <span>Uji Notifikasi</span>
                </button>
            )}
            <button onClick={logout} className="flex items-center justify-start gap-3 text-slate-400 hover:text-red-600 hover:bg-red-50 text-sm font-medium w-full px-3 py-3 rounded-lg transition-colors"><LogOut className="w-5 h-5" /><span>Keluar</span></button>
        </div>
     </aside>
     </>
  )
}

function Header({ userData, view }) {
   const titles = { mmi: "MMI", timetable: "Jadual Waktu Peribadi", logs: "Log Sistem", stats: "Statistik Penggunaan" };
   
   return (
      <header className="h-14 md:h-16 bg-white border-b border-slate-200 pl-14 pr-4 md:px-6 flex items-center justify-between shrink-0 shadow-sm z-10 no-print">
         <h2 className="font-bold text-base md:text-lg capitalize text-slate-800 flex items-center gap-2">{titles[view] || view}</h2>
         <div className="flex items-center gap-3">
             <span className="text-[10px] md:text-xs font-bold uppercase text-white bg-emerald-600 px-2 md:px-3 py-1 rounded-full tracking-wider shadow-sm">{userData.role}</span>
         </div>
      </header>
   )
}

// --- 3. FEATURE COMPONENTS ---

function SystemLogs() {
    const [logs, setLogs] = useState([]);
    useEffect(() => { api('/logs').then(d => setLogs(d)).catch(console.error); }, []);
    return (
        <div className="bg-white rounded-xl border border-slate-200 shadow-sm overflow-hidden">
            <div className="overflow-x-auto">
                <table className="w-full text-sm text-left">
                    <thead className="bg-slate-50 text-slate-500 font-bold uppercase text-xs">
                        <tr>
                            <th className="p-4 border-b">Nama Guru</th>
                            <th className="p-4 border-b">E-mel</th>
                            <th className="p-4 border-b">Peranan</th>
                            <th className="p-4 border-b text-right">Waktu Log Masuk</th>
                        </tr>
                    </thead>
                    <tbody className="divide-y divide-slate-100">
                        {logs.map(log => (
                            <tr key={log.id} className="hover:bg-slate-50">
                                <td className="p-4 font-bold text-slate-700">{log.name}</td>
                                <td className="p-4 text-slate-500">{log.email}</td>
                                <td className="p-4"><span className="uppercase text-[10px] bg-slate-100 px-2 py-1 rounded font-bold">{log.role}</span></td>
                                <td className="p-4 text-right font-mono text-xs text-slate-500">
                                    {formatDate(log.timestamp)} {new Date(log.timestamp).toLocaleTimeString('ms-MY', { timeZone: 'Asia/Kuala_Lumpur', hour: '2-digit', minute: '2-digit' })}
                                </td>
                            </tr>
                        ))}
                        {logs.length === 0 && <tr><td colSpan="4" className="p-8 text-center text-slate-400 italic">Tiada rekod log masuk.</td></tr>}
                    </tbody>
                </table>
            </div>
        </div>
    );
}

function UsageStats() {
    const [stats, setStats] = useState({ logs: 0, mmi: 0, reports: 0 });
    useEffect(() => { 
        api('/logs').then(d => setStats(p => ({...p, logs: d.length}))).catch(console.error); 
        api('/mmi').then(d => setStats(p => ({...p, mmi: d.length}))).catch(console.error); 
        api('/reports').then(d => setStats(p => ({...p, reports: d.length}))).catch(console.error); 
         
    }, []);
    
    return (
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            <div className="bg-white p-6 rounded-xl border border-slate-200 shadow-sm flex items-center gap-4">
                <div className="w-12 h-12 bg-blue-50 text-blue-600 rounded-full flex items-center justify-center"><Activity/></div>
                <div><p className="text-sm text-slate-500 font-bold">Jumlah Log Masuk</p><h3 className="text-2xl font-bold">{stats.logs}</h3></div>
            </div>
            <div className="bg-white p-6 rounded-xl border border-slate-200 shadow-sm flex items-center gap-4">
                <div className="w-12 h-12 bg-emerald-50 text-emerald-600 rounded-full flex items-center justify-center"><QrCode/></div>
                <div><p className="text-sm text-slate-500 font-bold">Rekod MMI</p><h3 className="text-2xl font-bold">{stats.mmi}</h3></div>
            </div>
            <div className="bg-white p-6 rounded-xl border border-slate-200 shadow-sm flex items-center gap-4">
                <div className="w-12 h-12 bg-emerald-50 text-emerald-600 rounded-full flex items-center justify-center"><FileText/></div>
                <div><p className="text-sm text-slate-500 font-bold">Laporan Harian</p><h3 className="text-2xl font-bold">{stats.reports}</h3></div>
            </div>
        </div>
    );
}

function MMIManager({ userData, currentUid, students, teachers }) {
    const [logs, setLogs] = useState([]);
    // UBAH: Guna getTodayDate() untuk waktu Malaysia
    const [date, setDate] = useState(getTodayDate());
    const [loading, setLoading] = useState(true);
    const [showScan, setShowScan] = useState(false);
    const [timetable, setTimetable] = useState({});
    const videoRef = useRef(null);
    const canvasRef = useRef(null);
    const reqRef = useRef(null);
    const [cameraActive, setCameraActive] = useState(false);
    const [selectedTeacherId, setSelectedTeacherId] = useState("");
    const isAdminOrPentadbir = ['admin', 'pentadbir'].includes(userData.role);
    const [showSlotSelection, setShowSlotSelection] = useState(false);
    const [detectedClass, setDetectedClass] = useState("");
    const [availableSlots, setAvailableSlots] = useState([]);
    const [manualWeek, setManualWeek] = useState("");
    const [selectedIds, setSelectedIds] = useState([]);
    const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);
    const [expandedWeeks, setExpandedWeeks] = useState({});
    const [isDownloading, setIsDownloading] = useState(false);
    
    // STATE BARU UNTUK MULTI-SELECT SLOT
    const [selectedSlotIndices, setSelectedSlotIndices] = useState([]);

    const getDay = (d) => { const days = ['Ahad','Isnin','Selasa','Rabu','Khamis','Jumaat','Sabtu']; return days[new Date(d).getDay()]; };
    const dayName = getDay(date);
    
    const selectedTeacher = teachers.find(t => t.id === selectedTeacherId);
    const targetUid = selectedTeacher ? (selectedTeacher.uid || "no_data") : currentUid;

    useEffect(() => {
        
        api(`/mmi?createdBy=${targetUid}`).then(d => { setLogs(d); setLoading(false); }).catch(() => setLoading(false));
        api(`/timetables/${targetUid}`).then(d => { setTimetable(d.schedule || {}); }).catch(() => setTimetable({}));
    }, [targetUid]);

    const groupedLogs = useMemo(() => { return logs.reduce((acc, log) => { const w = log.week || 'Tiada Minggu'; if (!acc[w]) acc[w] = []; acc[w].push(log); return acc; }, {}); }, [logs]);
    const sortedWeeks = Object.keys(groupedLogs).sort((a, b) => { return parseInt(b) || 0 - parseInt(a) || 0; });
    
    const scanTick = () => {
        if (videoRef.current && videoRef.current.readyState === videoRef.current.HAVE_ENOUGH_DATA) {
            const video = videoRef.current;
            const canvas = canvasRef.current;
            if (canvas) {
                canvas.height = video.videoHeight;
                canvas.width = video.videoWidth;
                const ctx = canvas.getContext("2d");
                ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
                const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
                
                if (window.jsQR) {
                    const code = window.jsQR(imageData.data, imageData.width, imageData.height, {
                        inversionAttempts: "dontInvert",
                    });
                    if (code && code.data) {
                        handleScan(code.data);
                        return;
                    }
                }
            }
        }
        reqRef.current = requestAnimationFrame(scanTick);
    };

    const startCamera = async () => { 
        setShowScan(true); 
        setCameraActive(true); 
        try { 
            const stream = await navigator.mediaDevices.getUserMedia({ video: { facingMode: "environment" } }); 
            if (videoRef.current) { 
                videoRef.current.srcObject = stream; 
                videoRef.current.setAttribute("playsinline", true);
                await videoRef.current.play();
                reqRef.current = requestAnimationFrame(scanTick);
            } 
        } catch (err) { console.error("Camera error:", err); alert("Gagal buka kamera: " + err.message); } 
    };

    const stopCamera = () => { 
        if (videoRef.current && videoRef.current.srcObject) { 
            videoRef.current.srcObject.getTracks().forEach(track => track.stop()); 
        } 
        if (reqRef.current) cancelAnimationFrame(reqRef.current);
        setCameraActive(false); 
        setShowScan(false); 
    };
    
    const handleScan = (cls) => { 
        setDetectedClass(cls); 
        stopCamera(); 
        const daySchedule = timetable[dayName] || {}; 
        const slots = []; 
        Object.entries(daySchedule).forEach(([time, data]) => { if (data.class && data.class.includes(cls)) { slots.push({ time, subject: data.subject, class: data.class }); } }); 
        setAvailableSlots(slots); 
        setSelectedSlotIndices([]); // Reset pilihan
        setShowSlotSelection(true); 
    };
    
    // FUNGSI TOGGLE PILIHAN SLOT
    const toggleSlotSelection = (index) => {
        setSelectedSlotIndices(prev => 
            prev.includes(index) ? prev.filter(i => i !== index) : [...prev, index]
        );
    };

    // FUNGSI SIMPAN BATCH (MULTI-SELECT) DENGAN SEMAKAN DUPLICATE
    const confirmBatchSlots = async () => { 
        if (!manualWeek) return alert("Sila masukkan nombor minggu."); 
        if (selectedSlotIndices.length === 0) return alert("Sila pilih sekurang-kurangnya satu slot.");

        let count = 0;
        let duplicates = [];
        const promises = [];

        selectedSlotIndices.forEach(idx => {
            const slot = availableSlots[idx];
            
            // Semak jika rekod sudah wujud dalam log semasa
            const isDuplicate = logs.some(log => 
                log.date === date && 
                log.time === slot.time && 
                log.class === slot.class && 
                log.subject === slot.subject
            );

            if (isDuplicate) {
                duplicates.push(`${slot.subject} (${slot.time})`);
            } else {
                promises.push(
                    api('/mmi', { method: 'POST', body: JSON.stringify({ date, day: dayName, class: slot.class, time: slot.time, subject: slot.subject,
                        week: manualWeek,
                        teacher: userData.name
                    }) }).catch(e => {
                        if (e.message?.includes('bertindih')) {
                            duplicates.push(`${slot.subject} (${slot.time}) — sedia ada`);
                            return null;
                        }
                        throw e;
                    })
                );
                count++;
            }
        });

        if (duplicates.length > 0) {
            alert(`Amaran: ${duplicates.length} slot berikut TIDAK disimpan kerana bertindih (sudah wujud):\n\n- ${duplicates.join('\n- ')}`);
        }

        if (count > 0) {
            try {
                await Promise.all(promises);
                // Refresh logs
                api(`/mmi?createdBy=${targetUid}`).then(d => setLogs(d)).catch(() => {});
                const savedCount = count - duplicates.filter(d => d.includes('sedia ada')).length;
                alert(`${savedCount} slot berjaya direkodkan!`);
                setShowSlotSelection(false); 
            } catch(e) {
                console.error(e);
                alert("Ralat semasa menyimpan.");
            }
        } else if (duplicates.length > 0 && count === 0) {
            // Jika semua duplicate
            setShowSlotSelection(false);
        }
    };
    
    // Fungsi Simpan Manual (Relief/Ganti - Single Record) DENGAN SEMAKAN DUPLICATE
    const saveManualMMI = async (cls, time, subject, weekVal) => { 
        // Semak duplicate
        const isDuplicate = logs.some(log => 
            log.date === date && 
            log.time === time && 
            log.class === cls && 
            log.subject === subject
        );

        if (isDuplicate) {
            return alert("Gagal Simpan: Rekod untuk slot, kelas dan subjek ini sudah wujud pada tarikh tersebut.");
        }

        try {
            await api('/mmi', { method: 'POST', body: JSON.stringify({ date, day: dayName, class: cls, time: time, subject: subject, week: weekVal, teacher: userData.name }) });
            const freshLogs = await api(`/mmi?createdBy=${targetUid}`);
            setLogs(freshLogs);
            alert(`MMI Direkod: ${cls} - ${subject} (${time})`);
        } catch(e) {
            alert(e.message || "Ralat semasa menyimpan.");
        }
    };
    
    const copyWeekToNext = async (weekNum, logsInWeek) => { 
        if (!confirm(`Salin semua rekod Minggu ${weekNum} ke minggu hadapan?`)) return; 
        const nextWeekNum = String(parseInt(weekNum) + 1);
        let copied = 0, skipped = 0, failed = 0;

        // Semak dulu mana yang dah wujud dalam destination week
        const existingDates = new Set(logs
            .filter(l => String(l.week) === nextWeekNum)
            .map(l => `${l.date}|${l.time}|${l.class}|${l.subject}`)
        );

        const promises = logsInWeek.map(log => { 
            const nextWeekDate = new Date(log.date); 
            nextWeekDate.setDate(nextWeekDate.getDate() + 7); 
            const nextDateStr = nextWeekDate.toISOString().split('T')[0];
            const key = `${nextDateStr}|${log.time}|${log.class}|${log.subject}`;

            // Skip jika dah ada di minggu destinasi (client-side dedup)
            if (existingDates.has(key)) {
                skipped++;
                return Promise.resolve(null);
            }

            const { id, created_at, created_by, ...logData } = log; 
            return api('/mmi', { method: 'POST', body: JSON.stringify({ ...logData, date: nextDateStr, day: getDay(nextDateStr), week: nextWeekNum }) })
                .then(() => { copied++; })
                .catch(e => { 
                    if (e.message?.includes('409') || e.message?.includes('bertindih')) { skipped++; }
                    else { failed++; console.error('MMI copy error:', e); }
                });
        }); 
        await Promise.all(promises);

        // Refresh logs
        api(`/mmi?createdBy=${targetUid}`).then(d => setLogs(d)).catch(() => {});

        const msg = [`Berjaya: ${copied}`, skipped > 0 && `Skip (sedia ada): ${skipped}`, failed > 0 && `Gagal: ${failed}`].filter(Boolean).join(', ');
        alert(`${msg} — Minggu ${nextWeekNum}`);
    };
    
    const toggleSelectLog = (id) => { setSelectedIds(prev => prev.includes(id) ? prev.filter(x => x !== id) : [...prev, id]); };
    const deleteSelectedLogs = async () => { await Promise.all(selectedIds.map(id => api(`/mmi/${id}`, { method: 'DELETE' }))); setSelectedIds([]); setShowDeleteConfirm(false); 
        // Refresh logs
        api(`/mmi?createdBy=${targetUid}`).then(d => setLogs(d)).catch(() => {});
    };
    
    // Padam semua rekod dalam satu minggu
    const [showDeleteWeekConfirm, setShowDeleteWeekConfirm] = useState(null); // { weekNum, logsInWeek }
    const deleteWeek = async () => {
        const { weekNum, logsInWeek } = showDeleteWeekConfirm;
        try {
            await Promise.all(logsInWeek.map(log => api(`/mmi/${log.id}`, { method: 'DELETE' })));
            api(`/mmi?createdBy=${targetUid}`).then(d => setLogs(d)).catch(() => {});
            alert(`${logsInWeek.length} rekod Minggu ${weekNum} dipadam.`);
        } catch(e) {
            alert('Ralat: ' + e.message);
        }
        setShowDeleteWeekConfirm(null);
    };
    const classList = [...new Set(students.map(s => s.class))].sort();

    const handleDateChange = (e) => {
        const val = e.target.value;
        setDate(val);
    };

    const downloadAllMMI = async () => {
        if (!confirm("Muat turun laporan Excel MMI untuk SEMUA guru & Pentadbir (kecuali Admin)?")) return;
        setIsDownloading(true);
        try {
            const allLogs = await api('/mmi');

            const teacherMap = {};
            teachers.forEach(t => { if (t.uid) teacherMap[t.uid] = t; });

            const filteredLogs = allLogs.filter(log => {
                const creator = teacherMap[log.createdBy];
                if (creator && creator.role === 'admin') return false;
                if (log.teacher === 'Iqbal Muhaider') return false;
                return true;
            });

            const headers = ["Tarikh", "Hari", "Minggu", "Nama Guru", "Kelas", "Masa", "Subjek", "Timestamp"];
            const csvRows = [headers.join(",")];

            filteredLogs.forEach(log => {
                const row = [
                    `"${log.date || ''}"`,
                    `"${log.day || ''}"`,
                    `"${log.week || ''}"`,
                    `"${log.teacher || ''}"`,
                    `"${log.class || ''}"`,
                    `"${log.time || ''}"`,
                    `"${log.subject || ''}"`,
                    `"${log.timestamp || ''}"`
                ];
                csvRows.push(row.join(","));
            });

            const blob = new Blob([csvRows.join("\n")], { type: 'text/csv;charset=utf-8;' });
            const url = URL.createObjectURL(blob);
            const link = document.createElement("a");
            link.setAttribute("href", url);
            // UBAH: Guna getTodayDate() untuk nama fail
            link.setAttribute("download", `Laporan_MMI_Keseluruhan_${getTodayDate()}.csv`);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            alert("Berjaya dimuat turun!");

        } catch (error) {
            console.error("Error downloading MMI:", error);
            alert("Gagal memuat turun data.");
        } finally {
            setIsDownloading(false);
        }
    };

    return (
        <div className="max-w-4xl mx-auto space-y-6 animate-fade-in">
            {isAdminOrPentadbir && (
                <div className="bg-white p-6 rounded-xl border border-emerald-100 shadow-sm mb-6">
                    <h3 className="font-bold text-slate-800 mb-2 flex items-center gap-2"><Search size={18}/> Semakan MMI Guru</h3>
                    <div className="flex gap-2">
                        <select className="w-full border p-2 rounded-lg" value={selectedTeacherId} onChange={(e) => setSelectedTeacherId(e.target.value)}>
                            <option value="">-- Paparan Saya (Diri Sendiri) --</option>
                            {teachers.map(t => <option key={t.id} value={t.id}>{t.name} {t.uid ? "" : "(Belum Login)"}</option>)}
                        </select>
                        <button onClick={downloadAllMMI} disabled={isDownloading} className="bg-emerald-600 text-white px-4 py-2 rounded-lg font-bold shadow-sm hover:bg-emerald-700 flex items-center gap-2 whitespace-nowrap disabled:bg-slate-400">
                            {isDownloading ? <Loader2 className="w-4 h-4 animate-spin"/> : <FileSpreadsheet className="w-4 h-4"/>} Excel
                        </button>
                    </div>
                    <p className="text-[10px] text-slate-400 mt-1 italic">*Muat turun Excel merangkumi semua guru & pentadbir (kecuali Admin).</p>
                </div>
            )}
            
            <div className="bg-white p-6 rounded-xl border shadow-sm">
                {(targetUid === currentUid) && (<div className="flex justify-between items-center mb-6"><div><label className="text-xs font-bold text-slate-500 uppercase block">Tarikh (Boleh Backdated)</label><input type="date" className="font-bold text-lg outline-none bg-transparent" value={date} onChange={handleDateChange} /><span className="text-sm text-slate-500 ml-2">({dayName})</span></div><button onClick={startCamera} className="bg-emerald-600 text-white px-6 py-3 rounded-xl font-bold shadow-lg hover:bg-emerald-700 flex items-center gap-2 transition-transform hover:scale-105"><QrCode className="w-6 h-6"/> Scan QR Kelas</button></div>)}
                
                <div className="flex justify-between items-center mb-4 border-b pb-2"><h3 className="font-bold text-slate-700">Sejarah MMI {targetUid !== currentUid ? `(${teachers.find(t=>t.id===selectedTeacherId)?.name})` : '(Saya)'}</h3>{selectedIds.length > 0 && (<button onClick={()=>setShowDeleteConfirm(true)} className="bg-red-50 text-red-600 px-3 py-1 rounded text-xs font-bold border border-red-200 hover:bg-red-100 flex items-center gap-1"><Trash2 size={14}/> Padam ({selectedIds.length})</button>)}</div>
                
                <div className="space-y-4">
                    {logs.length === 0 ? <p className="text-slate-400 italic text-center py-4">Tiada rekod MMI.</p> : sortedWeeks.map(weekNum => { 
                        const weekLogs = groupedLogs[weekNum]; 
                        const isOpen = expandedWeeks[weekNum];
                        
                        // --- LOGIK BARU: Group logs by Day ---
                        const logsByDay = weekLogs.reduce((acc, log) => {
                            const d = log.day || 'Lain-lain';
                            if(!acc[d]) acc[d] = [];
                            acc[d].push(log);
                            return acc;
                        }, {});
                        const dayOrder = ['Ahad', 'Isnin', 'Selasa', 'Rabu', 'Khamis', 'Jumaat', 'Sabtu', 'Lain-lain'];
                        const sortedDays = Object.keys(logsByDay).sort((a,b) => dayOrder.indexOf(a) - dayOrder.indexOf(b));

                        return (
                            <div key={weekNum} className="bg-white border rounded-xl shadow-sm overflow-hidden">
                                <div className={`p-4 flex justify-between items-center bg-slate-50 cursor-pointer ${isOpen ? 'border-b border-emerald-100' : ''}`} onClick={() => setExpandedWeeks(p => ({...p, [weekNum]: !p[weekNum]}))}>
                                    <div className="flex items-center gap-3">
                                        <span className="font-bold text-slate-700">Minggu {weekNum}</span>
                                        <span className="text-xs bg-slate-200 px-2 py-0.5 rounded-full text-slate-600">{weekLogs.length} Rekod</span>
                                    </div>
                                    <div className="flex items-center gap-2">
                                        {/* Butang Salin ke minggu hadapan */}
                                        {(targetUid === currentUid) && (
                                            <button 
                                                onClick={(e) => { e.stopPropagation(); copyWeekToNext(weekNum, weekLogs); }} 
                                                className="p-2 text-blue-600 bg-blue-50 hover:bg-blue-100 rounded-full border border-blue-200 transition-colors"
                                                title="Salin jadual minggu ini ke minggu hadapan"
                                            >
                                                <Copy size={14}/>
                                            </button>
                                        )}
                                        {/* Butang Padam Minggu Penuh */}
                                        {(targetUid === currentUid) && (
                                            <button 
                                                onClick={(e) => { e.stopPropagation(); setShowDeleteWeekConfirm({ weekNum, logsInWeek: weekLogs }); }} 
                                                className="p-2 text-red-600 bg-red-50 hover:bg-red-100 rounded-full border border-red-200 transition-colors"
                                                title={`Padam semua ${weekLogs.length} rekod Minggu ${weekNum}`}
                                            >
                                                <Trash2 size={14}/>
                                            </button>
                                        )}
                                        <ChevronDown className={`w-4 h-4 text-slate-400 transition-transform ${isOpen ? 'rotate-180' : ''}`}/>
                                    </div>
                                </div>
                                {isOpen && (
                                    <div className="bg-white">
                                        {sortedDays.map(day => (
                                            <div key={day}>
                                                {/* Header Hari */}
                                                <div className="px-4 py-2 bg-emerald-50/50 border-y border-emerald-100 text-xs font-bold text-emerald-900 uppercase tracking-wider flex justify-between items-center">
                                                    <span>{day}</span>
                                                    <span className="font-normal opacity-70 normal-case bg-white/50 px-2 rounded">{formatDate(logsByDay[day][0].date)}</span>
                                                </div>
                                                
                                                {/* Senarai Log Hari Tersebut */}
                                                <div className="divide-y divide-slate-100">
                                                    {logsByDay[day]
                                                        .sort((a,b) => (a.time || '').localeCompare(b.time || ''))
                                                        .map(log => (
                                                        <div key={log.id} className="p-3 flex items-center hover:bg-slate-50 transition-colors pl-6 border-b border-slate-50 last:border-0">
                                                            <div className="mr-4">
                                                                <input type="checkbox" checked={selectedIds.includes(log.id)} onChange={() => toggleSelectLog(log.id)} className="w-4 h-4 text-emerald-600 rounded cursor-pointer"/>
                                                            </div>
                                                            <div className="flex-1 grid grid-cols-12 gap-2 items-center">
                                                                {/* Masa */}
                                                                <div className="col-span-3 md:col-span-2">
                                                                    <span className="text-[10px] font-bold bg-slate-100 px-2 py-1 rounded text-slate-600 block text-center truncate">{log.time}</span>
                                                                </div>
                                                                {/* Kelas & Subjek */}
                                                                <div className="col-span-9 md:col-span-10">
                                                                    <div className="flex flex-col md:flex-row md:items-center gap-1 md:gap-3">
                                                                        <span className="font-bold text-emerald-700 text-sm w-16">{log.class}</span>
                                                                        <span className="text-xs text-slate-700 font-medium line-clamp-1 flex-1">{log.subject}</span>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    ))}
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                )}
                            </div>
                        )
                    })}
                </div>
            </div>

            {showScan && (<div className="fixed inset-0 bg-black/90 flex items-center justify-center z-50 animate-fade-in"><div className="w-full max-w-md bg-white rounded-2xl overflow-hidden relative"><button onClick={stopCamera} className="absolute top-4 right-4 text-white z-10 bg-black/50 rounded-full p-2"><X/></button><div className="relative bg-black h-64 flex items-center justify-center"><video ref={videoRef} className="absolute inset-0 w-full h-full object-cover"></video><canvas ref={canvasRef} className="hidden"></canvas><div className="border-2 border-white/50 w-48 h-48 rounded-lg relative z-10"></div><p className="absolute bottom-4 text-white text-xs bg-black/50 px-2 py-1 rounded">Halakan kamera pada QR Code Kelas</p></div><div className="p-6"><h3 className="font-bold text-lg mb-2 text-center">Atau Pilih Kelas (Simulasi)</h3><div className="grid grid-cols-3 gap-2 max-h-40 overflow-y-auto">{classList.map(c => (<button key={c} onClick={()=>handleScan(c)} className="bg-slate-100 text-slate-700 py-2 rounded font-bold text-xs hover:bg-emerald-100 hover:text-emerald-700 transition-colors">{c}</button>))}</div></div></div></div>)}
            
            {/* MODAL PILIHAN SLOT (MULTI-SELECT) */}
            {showSlotSelection && (
                <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 animate-fade-in">
                    <div className="bg-white p-6 rounded-xl w-96 shadow-2xl flex flex-col max-h-[80vh]">
                        <h3 className="font-bold text-lg mb-1 text-slate-800">Sahkan Keberadaan</h3>
                        <p className="text-sm text-slate-500 mb-4">Kelas: <b>{detectedClass}</b> pada <b>{dayName}</b></p>
                        
                        <div className="mb-4">
                            <label className="text-xs font-bold uppercase text-slate-500 block mb-1">Minggu Pengajaran</label>
                            <input autoFocus className="w-full border p-2 rounded text-sm font-bold focus:ring-2 focus:ring-emerald-500 outline-none" placeholder="Contoh: 1, 2, 3..." value={manualWeek} onChange={e=>setManualWeek(e.target.value)} />
                        </div>
                        
                        <div className="flex-1 overflow-y-auto mb-4 border rounded-lg p-2 bg-slate-50">
                            <p className="text-xs font-bold text-slate-400 uppercase mb-2 px-1">Pilih Slot Masa:</p>
                            {availableSlots.length > 0 ? (
                                <div className="space-y-2">
                                    {availableSlots.map((slot, idx) => {
                                        const isSelected = selectedSlotIndices.includes(idx);
                                        // Semak jika slot sudah wujud (Visual Indicator)
                                        const isDuplicate = logs.some(log => 
                                            log.date === date && 
                                            log.time === slot.time && 
                                            log.class === slot.class && 
                                            log.subject === slot.subject
                                        );

                                        return (
                                            <div 
                                                key={idx} 
                                                onClick={() => !isDuplicate && toggleSlotSelection(idx)}
                                                className={`flex items-center p-3 rounded-lg border transition-all ${isDuplicate ? 'bg-slate-100 border-slate-200 opacity-60 cursor-not-allowed' : 'cursor-pointer'} ${isSelected ? 'bg-emerald-50 border-emerald-500 shadow-sm' : 'bg-white border-slate-200 hover:border-slate-300'}`}
                                            >
                                                <div className={`w-5 h-5 rounded border mr-3 flex items-center justify-center transition-colors ${isSelected ? 'bg-emerald-600 border-emerald-600 text-white' : 'bg-white border-slate-300'}`}>
                                                    {isSelected && <Check size={14} strokeWidth={3}/>}
                                                    {isDuplicate && <X size={14} className="text-slate-400"/>}
                                                </div>
                                                <div>
                                                    <div className={`font-bold text-sm ${isSelected ? 'text-emerald-700' : 'text-slate-700'}`}>{slot.subject}</div>
                                                    <div className="text-xs text-slate-500">{slot.time} {isDuplicate && <span className="text-red-500 italic ml-1">(Sudah Rekod)</span>}</div>
                                                </div>
                                            </div>
                                        );
                                    })}
                                </div>
                            ) : (
                                <div className="text-center p-4 border border-dashed rounded text-slate-400 text-sm bg-white">
                                    Tiada jadual untuk kelas ini pada hari ini.
                                    <button onClick={() => { saveManualMMI(detectedClass, "Lain-lain", "Relief/Ganti", manualWeek); setShowSlotSelection(false); }} className="block w-full text-emerald-600 bg-emerald-50 py-2 rounded mt-2 font-bold hover:bg-emerald-100">
                                        Rekod Relief/Ganti (Single)
                                    </button>
                                </div>
                            )}
                        </div>
                        
                        <div className="flex gap-2 pt-2 border-t border-slate-100">
                            <button onClick={() => setShowSlotSelection(false)} className="flex-1 text-slate-500 py-3 text-sm font-bold bg-slate-100 rounded-lg hover:bg-slate-200 transition-colors">Batal</button>
                            {availableSlots.length > 0 && (
                                <button onClick={confirmBatchSlots} className="flex-[2] bg-emerald-600 text-white py-3 text-sm font-bold rounded-lg hover:bg-emerald-700 shadow-lg transition-colors flex items-center justify-center gap-2">
                                    <CheckCircle size={16}/> Simpan {selectedSlotIndices.length > 0 ? `(${selectedSlotIndices.length})` : ''}
                                </button>
                            )}
                        </div>
                    </div>
                </div>
            )}

            {showDeleteConfirm && (<div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 animate-fade-in"><div className="bg-white p-6 rounded-xl w-80 shadow-2xl"><h3 className="font-bold text-lg mb-2 text-red-600">Padam Rekod MMI?</h3><p className="text-slate-600 mb-4 text-sm">Anda pasti mahu memadam {selectedIds.length} rekod yang dipilih?</p><div className="flex justify-end gap-2"><button onClick={() => setShowDeleteConfirm(false)} className="px-4 py-2 rounded text-sm font-bold text-slate-600 bg-slate-100 hover:bg-slate-200">Batal</button><button onClick={deleteSelectedLogs} className="px-4 py-2 rounded text-sm font-bold bg-red-600 text-white hover:bg-red-700">Ya, Padam</button></div></div></div>)}
            {showDeleteWeekConfirm && (
                <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-[100] animate-fade-in" onClick={() => setShowDeleteWeekConfirm(null)}>
                    <div className="bg-white p-6 rounded-xl w-80 shadow-2xl" onClick={e => e.stopPropagation()}>
                        <h3 className="font-bold text-lg mb-2 text-red-600">Padam Minggu {showDeleteWeekConfirm.weekNum}?</h3>
                        <p className="text-slate-600 mb-4 text-sm">Anda pasti mahu memadam <b>SEMUA {showDeleteWeekConfirm.logsInWeek.length} rekod</b> dalam Minggu {showDeleteWeekConfirm.weekNum}? Tindakan ini tidak boleh diundur.</p>
                        <div className="flex justify-end gap-2">
                            <button onClick={() => setShowDeleteWeekConfirm(null)} className="px-4 py-2 rounded text-sm font-bold text-slate-600 bg-slate-100 hover:bg-slate-200">Batal</button>
                            <button onClick={deleteWeek} className="px-4 py-2 rounded text-sm font-bold bg-red-600 text-white hover:bg-red-700">Ya, Padam Semua</button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}

function TimetableManager({ userData, currentUid, students, teachers }) {
   const [schedule, setSchedule] = useState({});
   const [loading, setLoading] = useState(true);
   const [selectedSlots, setSelectedSlots] = useState([]);
   const [showModal, setShowModal] = useState(false);
   const [showDeleteConfirm, setShowDeleteConfirm] = useState(false); 
   const [formData, setFormData] = useState({ subject: '', class: '' });
   
   const [selectedTeacherId, setSelectedTeacherId] = useState("");
   const isAdminOrPentadbir = ['admin', 'pentadbir'].includes(userData.role);
   
   // COLOR-CODED SUBJECTS: mapping of common subjects to tailwind classes
   const SUBJECT_COLORS = {
      matematik: { bg: 'bg-blue-50', text: 'text-blue-700', border: 'border-blue-200', dot: 'bg-blue-500' },
      math: { bg: 'bg-blue-50', text: 'text-blue-700', border: 'border-blue-200', dot: 'bg-blue-500' },
      sains: { bg: 'bg-teal-50', text: 'text-teal-700', border: 'border-teal-200', dot: 'bg-teal-500' },
      science: { bg: 'bg-teal-50', text: 'text-teal-700', border: 'border-teal-200', dot: 'bg-teal-500' },
      english: { bg: 'bg-rose-50', text: 'text-rose-700', border: 'border-rose-200', dot: 'bg-rose-500' },
      'bahasa inggeris': { bg: 'bg-rose-50', text: 'text-rose-700', border: 'border-rose-200', dot: 'bg-rose-500' },
      melayu: { bg: 'bg-amber-50', text: 'text-amber-700', border: 'border-amber-200', dot: 'bg-amber-500' },
      'bahasa melayu': { bg: 'bg-amber-50', text: 'text-amber-700', border: 'border-amber-200', dot: 'bg-amber-500' },
      islamic: { bg: 'bg-emerald-50', text: 'text-emerald-700', border: 'border-emerald-200', dot: 'bg-emerald-500' },
      'pendidikan islam': { bg: 'bg-emerald-50', text: 'text-emerald-700', border: 'border-emerald-200', dot: 'bg-emerald-500' },
      pjk: { bg: 'bg-orange-50', text: 'text-orange-700', border: 'border-orange-200', dot: 'bg-orange-500' },
      'pendidikan jasmani': { bg: 'bg-orange-50', text: 'text-orange-700', border: 'border-orange-200', dot: 'bg-orange-500' },
      sejarah: { bg: 'bg-violet-50', text: 'text-violet-700', border: 'border-violet-200', dot: 'bg-violet-500' },
      'pendidikan moral': { bg: 'bg-cyan-50', text: 'text-cyan-700', border: 'border-cyan-200', dot: 'bg-cyan-500' },
      rbt: { bg: 'bg-pink-50', text: 'text-pink-700', border: 'border-pink-200', dot: 'bg-pink-500' },
      psv: { bg: 'bg-fuchsia-50', text: 'text-fuchsia-700', border: 'border-fuchsia-200', dot: 'bg-fuchsia-500' },
      muzik: { bg: 'bg-indigo-50', text: 'text-indigo-700', border: 'border-indigo-200', dot: 'bg-indigo-500' },
   };
   const getSubjectColor = (subject) => {
      if (!subject) return null;
      const key = subject.toLowerCase().trim();
      // Try exact key first, then partial match
      if (SUBJECT_COLORS[key]) return SUBJECT_COLORS[key];
      for (const k of Object.keys(SUBJECT_COLORS)) {
          if (key.includes(k)) return SUBJECT_COLORS[k];
      }
      return null;
   };
   
   // LOGIC TARGET UID: cari guru berdasarkan ID (pastikan type match — select return string)
   const selectedTeacher = teachers.find(t => String(t.id) === String(selectedTeacherId));
   const targetUid = selectedTeacher ? (selectedTeacher.uid || "no_data") : currentUid;

   const days = ['Isnin', 'Selasa', 'Rabu', 'Khamis', 'Jumaat'];
   const times = ["7:40 - 8:10", "8:10 - 8:40", "8:40 - 9:10", "9:10 - 9:40", "9:40 - 10:10", "10:10 - 10:30 (REHAT)", "10:30 - 11:00", "11:00 - 11:30", "11:30 - 12:00", "12:00 - 12:30", "12:30 - 1:00", "1:00 - 1:30"];
   const classList = useMemo(() => { if (!students || students.length === 0) return []; return [...new Set(students.map(s => s.class))].sort(); }, [students]);

   useEffect(() => {
      setLoading(true);
      api(`/timetables/${targetUid}`).then(d => { setSchedule(d.schedule || {}); setLoading(false); }).catch(() => { setSchedule({}); setLoading(false); });
   }, [targetUid]);

   const toggleSlot = (day, time) => {
       // Hanya benarkan edit jika sedang melihat jadual sendiri (targetUid == currentUid)
       if (targetUid !== currentUid) return; 

       if (time.includes("REHAT")) return;
       const slotId = `${day}|${time}`;
       setSelectedSlots(prev => { if (prev.includes(slotId)) return prev.filter(id => id !== slotId); return [...prev, slotId]; });
   };

   const saveBatch = async () => {
       if (selectedSlots.length === 0) return alert("Sila pilih slot.");
       const newSchedule = { ...schedule };
       selectedSlots.forEach(slotId => { const [d, t] = slotId.split('|'); if (!newSchedule[d]) newSchedule[d] = {}; newSchedule[d][t] = formData; });
       try { await api(`/timetables/${targetUid}`, { method: 'PUT', body: JSON.stringify({ schedule: newSchedule, teacherName: userData.name, updatedAt: new Date().toISOString() }) }); setSelectedSlots([]); setShowModal(false); alert("Berjaya!"); } catch(e) { alert("Ralat: " + e.message); }
   };
   
   const confirmDelete = () => { if (selectedSlots.length === 0) return alert("Pilih slot untuk dipadam."); setShowDeleteConfirm(true); };
   const clearSlots = async () => {
       const newSchedule = { ...schedule };
       selectedSlots.forEach(slotId => { const [d, t] = slotId.split('|'); if (newSchedule[d]) delete newSchedule[d][t]; });
       await api(`/timetables/${targetUid}`, { method: 'PUT', body: JSON.stringify({ schedule: newSchedule, teacherName: userData.name, updatedAt: new Date().toISOString() }) });
       setSelectedSlots([]); setShowDeleteConfirm(false);
   };

   if (loading) return <div className="flex justify-center p-12"><Loader2 className="animate-spin text-slate-400 w-8 h-8"/></div>;

   return (
      <div className="max-w-full mx-auto space-y-6">
         {isAdminOrPentadbir && (<div className="bg-white p-6 rounded-xl border border-emerald-100 shadow-sm no-print"><h3 className="font-bold text-slate-800 mb-2 flex items-center gap-2"><Search size={18}/> Semakan Jadual Guru</h3><select className="w-full border p-2 rounded-lg" value={selectedTeacherId} onChange={(e) => setSelectedTeacherId(e.target.value)}><option value="">-- Paparan Saya (Diri Sendiri) --</option>{teachers.map(t => <option key={t.id} value={t.id}>{t.name} {t.uid ? "" : "(Belum Login)"}</option>)}</select></div>)}
         
         <div className="flex justify-between items-center no-print"><h2 className="text-2xl font-bold text-slate-800 flex items-center gap-2"><CalendarClock className="w-6 h-6 text-emerald-600"/> Jadual Waktu {targetUid !== currentUid ? `(${teachers.find(t=>t.id===selectedTeacherId)?.name})` : 'Peribadi'}</h2><div className="flex gap-2"><button onClick={() => window.print()} className="bg-slate-100 text-slate-700 px-4 py-2 rounded-lg font-bold hover:bg-slate-200 flex items-center gap-2"><Printer className="w-4 h-4"/> Cetak</button></div></div>
         
         {targetUid === "no_data" ? (
            <div className="p-8 text-center border-2 border-dashed border-red-200 bg-red-50 rounded-xl text-red-500 font-bold">Guru ini belum mendaftar masuk ke dalam sistem (Tiada UID).</div>
         ) : (
         <div className="bg-white rounded-xl border border-slate-200 shadow-sm overflow-hidden print-container select-none"><div className="overflow-x-auto"><table className="w-full text-sm border-collapse"><thead><tr className="bg-slate-800 text-white"><th className="p-3 border border-slate-700 min-w-[100px]">Hari / Masa</th>{times.map(t => (<th key={t} className={`p-3 border border-slate-700 text-center whitespace-nowrap text-xs ${t.includes('REHAT') ? 'bg-amber-600' : ''}`}>{t}</th>))}</tr></thead><tbody>{days.map(day => (<tr key={day} className="hover:bg-slate-50"><td className="p-3 border border-slate-200 font-bold bg-slate-100 text-slate-700 text-center">{day}</td>{times.map(time => { const isRehat = time.includes('REHAT'); const slotId = `${day}|${time}`; const isSelected = selectedSlots.includes(slotId); const data = schedule[day]?.[time] || { subject: '', class: '' }; if (isRehat) return <td key={time} className="p-1 border border-slate-200 bg-amber-50 text-center font-bold text-amber-700 text-xs diagonal-stripe">REHAT</td>; return (<td key={time} onClick={() => toggleSlot(day, time)} className={`p-1 border border-slate-200 min-w-[100px] h-16 cursor-pointer transition-all text-center relative ${isSelected ? 'bg-emerald-100 ring-2 ring-inset ring-emerald-500' : (data.subject ? (getSubjectColor(data.subject)?.bg || '') : '')}`}>{data.subject ? (<div className="flex flex-col justify-center h-full"><span className={`font-bold text-xs ${isSelected ? 'text-slate-800' : (getSubjectColor(data.subject)?.text || 'text-slate-800')}`}>{data.subject}</span><span className="text-[10px] text-slate-500">{data.class}</span></div>) : (<span className="text-slate-300 text-[10px]">-</span>)}{isSelected && <div className="absolute top-1 right-1 w-2 h-2 bg-emerald-600 rounded-full"></div>}</td>) })}</tr>))}</tbody></table></div></div>
         )}
         
         {/* COLOR LEGEND */}
         <div className="no-print bg-white rounded-xl border border-slate-200 shadow-sm p-4">
            <h4 className="text-xs font-bold text-slate-500 uppercase tracking-wide mb-3">Legenda Warna Subjek</h4>
            <div className="flex flex-wrap gap-3">
               {Object.entries(SUBJECT_COLORS).filter(([k]) => !['math','science','melayu','islamic','pjk'].includes(k)).map(([key, c]) => (
                  <div key={key} className="flex items-center gap-2">
                     <span className={`w-3 h-3 rounded ${c.dot}`}></span>
                     <span className="text-xs font-medium text-slate-600 capitalize">{key === 'pendidikan islam' ? 'P. Islam' : key === 'bahasa melayu' ? 'B. Melayu' : key === 'bahasa inggeris' ? 'B. Inggeris' : key === 'pendidikan jasmani' ? 'PJK' : key === 'pendidikan moral' ? 'P. Moral' : key}</span>
                  </div>
               ))}
            </div>
         </div>
         
         {selectedSlots.length > 0 && (<div className="fixed bottom-6 right-6 z-50 animate-fade-in no-print flex gap-2"><button onClick={confirmDelete} className="bg-red-500 text-white px-4 py-3 rounded-full font-bold shadow-xl hover:bg-red-600 flex items-center gap-2"><Trash2 className="w-5 h-5"/> Padam</button><button onClick={() => { setFormData({subject:'', class:''}); setShowModal(true); }} className="bg-emerald-600 text-white px-6 py-3 rounded-full font-bold shadow-xl hover:bg-emerald-700 flex items-center gap-3 transition-transform hover:scale-105"><Edit3 className="w-5 h-5"/> Isi {selectedSlots.length} Slot</button></div>)}
         
         {showModal && (<div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 animate-fade-in no-print"><div className="bg-white p-6 rounded-xl w-80 shadow-2xl"><h3 className="font-bold text-lg mb-4 text-slate-800">Kemaskini Slot</h3><div className="space-y-3"><div><label className="lbl">Subjek</label><input className="inp w-full" autoFocus placeholder="Contoh: Matematik" value={formData.subject} onChange={e=>setFormData({...formData, subject: e.target.value})} /></div><div><label className="lbl">Kelas</label><select className="inp w-full" value={formData.class} onChange={e=>setFormData({...formData, class: e.target.value})}><option value="">-- Pilih Kelas --</option>{classList.length > 0 ? classList.map(c => <option key={c} value={c}>{c}</option>) : <option disabled>Tiada data kelas</option>}<option value="Lain-lain">Lain-lain / Manual</option></select>{formData.class === 'Lain-lain' && <input className="inp w-full mt-2" placeholder="Nama Kelas Manual" onChange={e=>setFormData({...formData, class: e.target.value})} />}</div></div><div className="flex justify-end gap-2 mt-6"><button onClick={() => setShowModal(false)} className="px-4 py-2 rounded text-sm font-bold text-slate-500 hover:bg-slate-100">Batal</button><button onClick={saveBatch} className="px-4 py-2 rounded text-sm font-bold bg-emerald-600 text-white hover:bg-emerald-700">Simpan</button></div></div></div>)}
         {showDeleteConfirm && (<div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 animate-fade-in no-print"><div className="bg-white p-6 rounded-xl w-80 shadow-2xl"><h3 className="font-bold text-lg mb-2 text-red-600">Padam Slot?</h3><p className="text-slate-500 mb-4 text-sm">Anda pasti mahu memadam {selectedSlots.length} slot terpilih?</p><div className="flex justify-end gap-2"><button onClick={() => setShowDeleteConfirm(false)} className="px-4 py-2 rounded text-sm font-bold text-slate-600 bg-slate-100 hover:bg-slate-200">Batal</button><button onClick={clearSlots} className="px-4 py-2 rounded text-sm font-bold bg-red-600 text-white hover:bg-red-700">Ya, Padam</button></div></div></div>)}
      </div>
   );
}

function TakwimManager({ canEdit, role, currentUid }) {
    const { confirm, modal: confirmModal } = useConfirmModal();
    const [date, setDate] = useState(new Date(2026, 0, 1)); 
    const [events, setEvents] = useState([]); 
    const [selectedDate, setSelectedDate] = useState(null); 
    // State baru untuk warna
    const [newEvent, setNewEvent] = useState({ title: '', unit: '', color: 'blue' });

    // Definisi warna label
    const EVENT_COLORS = {
        blue: { bg: 'bg-blue-100', text: 'text-blue-700', border: 'border-blue-200', dot: 'bg-blue-500' },
        green: { bg: 'bg-emerald-100', text: 'text-emerald-700', border: 'border-emerald-200', dot: 'bg-emerald-500' },
        red: { bg: 'bg-rose-100', text: 'text-rose-700', border: 'border-rose-200', dot: 'bg-rose-500' },
        orange: { bg: 'bg-orange-100', text: 'text-orange-700', border: 'border-orange-200', dot: 'bg-orange-500' },
        purple: { bg: 'bg-violet-100', text: 'text-violet-700', border: 'border-violet-200', dot: 'bg-violet-500' }
    };

    useEffect(() => { api('/events').then(d => setEvents(d)).catch(console.error); }, []);
    
    const allEvents = [...KPM_EVENTS, ...events];
    
    const handleCellClick = (d) => { if (canEdit) { setSelectedDate(d); setNewEvent({ title: '', unit: '', color: 'blue' }); } };
    
    const addEvent = async () => { 
        if(!newEvent.title) return alert("Isi nama program."); 
        await api('/events', { method: 'POST', body: JSON.stringify({ 
            title: newEvent.title, 
            unit: newEvent.unit, 
            color: newEvent.color, // Simpan warna
            start: selectedDate.toISOString().split('T')[0], 
            end: selectedDate.toISOString().split('T')[0], 
            type: 'event', 
            createdBy: currentUid 
        }) }); 
        setSelectedDate(null); 
    };

    const deleteEvent = async (id, e) => { e.stopPropagation(); if(confirm("Padam?")) await api(`/events/${id}`, { method: 'DELETE' }); }
    
    const renderMonth = (targetDate) => { 
        const year = targetDate.getFullYear(); 
        const month = targetDate.getMonth(); 
        const daysInMonth = new Date(year, month + 1, 0).getDate(); 
        const firstDay = new Date(year, month, 1).getDay(); 
        const blanks = Array(firstDay).fill(null); 
        const days = Array.from({length: daysInMonth}, (_, i) => i + 1); 
        
        return (
            <div className="bg-white p-6 rounded-xl border border-slate-200 shadow-sm animate-fade-in">
                <div className="flex justify-between mb-6 items-center">
                    <button onClick={()=>setDate(new Date(year, month-1, 1))} className="p-2 hover:bg-slate-100 rounded-full transition-colors"><ChevronLeft/></button>
                    <div className="text-center">
                        <h3 className="font-bold text-xl uppercase text-slate-800 tracking-wide">{targetDate.toLocaleDateString('ms-MY', { month: 'long', year: 'numeric' })}</h3>
                        <p className="text-xs text-slate-500 font-medium mt-1">Sila klik pada tarikh untuk tambah program</p>
                    </div>
                    <button onClick={()=>setDate(new Date(year, month+1, 1))} className="p-2 hover:bg-slate-100 rounded-full transition-colors"><ChevronRight/></button>
                </div>
                <div className="grid grid-cols-7 gap-3 mb-2 text-center text-xs font-bold text-slate-400 uppercase tracking-wider">{['Ahad','Isnin','Selasa','Rabu','Khamis','Jumaat','Sabtu'].map(d=><div key={d}>{d}</div>)}</div>
                <div className="grid grid-cols-7 gap-2">
                    {blanks.map((_,i)=><div key={i} className="min-h-[100px] bg-slate-50/50 rounded-lg"></div>)}
                    {days.map(d => { 
                        const currentDay = new Date(year, month, d); 
                        const dStr = currentDay.toISOString().split('T')[0]; 
                        const dailyEvents = allEvents.filter(e => dStr >= e.start && dStr <= (e.end || e.start)); 
                        const isSchool = dailyEvents.some(e => e.type === 'school'); 
                        const isHoliday = dailyEvents.some(e => e.type === 'holiday'); 
                        
                        return (
                            <div key={d} onClick={() => handleCellClick(currentDay)} className={`min-h-[100px] border rounded-lg p-2 text-xs relative cursor-pointer transition-all hover:shadow-md hover:-translate-y-1 ${isSchool ? 'bg-emerald-50/50 border-emerald-100' : (isHoliday ? 'bg-amber-50/50 border-amber-100' : 'bg-white border-slate-100 hover:border-emerald-300')}`}>
                                <span className={`font-bold block mb-2 text-center w-6 h-6 leading-6 rounded-full mx-auto ${isSchool ? 'bg-emerald-100 text-emerald-700' : (isHoliday ? 'bg-amber-100 text-amber-700' : 'text-slate-700 bg-slate-50')}`}>{d}</span>
                                <div className="space-y-1.5">
                                    {dailyEvents.map((ev, idx) => { 
                                        if (ev.type === 'school') return null; 
                                        const isHolidayItem = ev.type === 'holiday'; 
                                        const canDelete = ev.type === 'event' && (role === 'admin' || ev.createdBy === currentUid); 
                                        
                                        // Tentukan style berdasarkan warna pilihan
                                        let styleClass = 'bg-slate-100 text-slate-700 border-slate-200';
                                        if(isHolidayItem) styleClass = 'bg-amber-100 text-amber-800 border-amber-200';
                                        else if(ev.color && EVENT_COLORS[ev.color]) {
                                            const c = EVENT_COLORS[ev.color];
                                            styleClass = `${c.bg} ${c.text} ${c.border}`;
                                        } else {
                                            styleClass = 'bg-blue-100 text-blue-800 border-blue-200'; // Default legacy
                                        }

                                        return (
                                            <div key={idx} className={`px-2 py-1.5 rounded border text-[10px] font-bold leading-tight group relative shadow-sm ${styleClass}`}>
                                                {ev.title}
                                                {ev.unit && <span className="block font-normal opacity-75 text-[9px] mt-0.5">{ev.unit}</span>}
                                                {canDelete && (<button onClick={(e)=>deleteEvent(ev.id, e)} className="hidden group-hover:flex absolute -top-1 -right-1 bg-red-500 text-white rounded-full w-4 h-4 items-center justify-center shadow-sm hover:bg-red-600 transition-colors"><X size={8}/></button>)}
                                            </div>
                                        ) 
                                    })}
                                </div>
                            </div>
                        ) 
                    })}
                </div>
            </div>
        ) 
    };

    return (
        <div className="space-y-6">
            <div className="flex justify-between items-center">
                <h3 className="text-2xl font-bold text-slate-800 flex items-center gap-2"><CalendarDays className="w-7 h-7 text-emerald-600"/> Takwim Sekolah</h3>
                <div className="flex gap-2">
                     {/* Lagenda ringkas */}
                     <div className="hidden md:flex gap-3 text-xs font-medium bg-white px-3 py-1.5 rounded-lg border border-slate-200 shadow-sm">
                        <span className="flex items-center gap-1.5"><span className="w-2 h-2 rounded-full bg-emerald-500"></span> Persekolahan</span>
                        <span className="flex items-center gap-1.5"><span className="w-2 h-2 rounded-full bg-amber-500"></span> Cuti</span>
                        <span className="flex items-center gap-1.5"><span className="w-2 h-2 rounded-full bg-blue-500"></span> Program</span>
                     </div>
                </div>
            </div>
            
            {renderMonth(date)}
            
            {/* Modal Tambah Program */}
            {selectedDate && (
                <div className="fixed inset-0 bg-black/60 flex items-center justify-center z-50 animate-fade-in backdrop-blur-sm">
                    <div className="bg-white p-6 rounded-2xl w-full max-w-sm shadow-2xl">
                        <div className="flex justify-between items-center mb-4 border-b pb-3">
                            <div>
                                <h3 className="font-bold text-lg text-slate-800">Tambah Aktiviti</h3>
                                <p className="text-xs text-slate-500 font-medium">{selectedDate.toLocaleDateString('ms-MY', { weekday: 'long', day: 'numeric', month: 'long' })}</p>
                            </div>
                            <button onClick={()=>setSelectedDate(null)} className="text-slate-400 hover:text-red-500"><X size={20}/></button>
                        </div>
                        
                        <div className="space-y-4">
                            <div>
                                <label className="lbl">Nama Program</label>
                                <input autoFocus className="inp w-full" placeholder="Contoh: Mesyuarat Guru Bil 1" value={newEvent.title} onChange={e=>setNewEvent({...newEvent, title:e.target.value})}/>
                            </div>
                            <div>
                                <label className="lbl">Unit / Panitia (Pilihan)</label>
                                <input className="inp w-full" placeholder="Contoh: Kurikulum / Panitia BM" value={newEvent.unit} onChange={e=>setNewEvent({...newEvent, unit:e.target.value})}/>
                            </div>
                            
                            {/* Pilihan Warna */}
                            <div>
                                <label className="lbl mb-2">Pilih Label Warna</label>
                                <div className="flex justify-between gap-2">
                                    {Object.keys(EVENT_COLORS).map((colorKey) => {
                                        const c = EVENT_COLORS[colorKey];
                                        const isSelected = newEvent.color === colorKey;
                                        return (
                                            <button 
                                                key={colorKey}
                                                onClick={() => setNewEvent({...newEvent, color: colorKey})}
                                                className={`w-10 h-10 rounded-full flex items-center justify-center transition-all ${c.bg} ${isSelected ? 'ring-2 ring-offset-2 ring-slate-400 scale-110' : 'hover:scale-105 opacity-70 hover:opacity-100'}`}
                                                title={colorKey}
                                            >
                                                <div className={`w-4 h-4 rounded-full ${c.dot}`}></div>
                                            </button>
                                        )
                                    })}
                                </div>
                            </div>
                        </div>

                        <div className="flex gap-2 mt-8 pt-4 border-t">
                            <button onClick={()=>setSelectedDate(null)} className="flex-1 py-2.5 rounded-lg text-sm font-bold text-slate-600 bg-slate-100 hover:bg-slate-200 transition-colors">Batal</button>
                            <button onClick={addEvent} className="flex-[2] py-2.5 rounded-lg text-sm font-bold bg-emerald-600 text-white hover:bg-emerald-700 shadow-md transition-colors flex items-center justify-center gap-2">
                                <Plus size={16}/> Simpan
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    )
}

function TaskManager({ userData, tasks, currentUid }) {
    const isStaff = ['admin', 'pentadbir', 'guru'].includes(userData.role);
    // State dikemaskini untuk field description dan link
    const [form, setForm] = useState({ title: '', description: '', link: '', deadline: '', assignTo: 'Semua Guru' });
    const [customTarget, setCustomTarget] = useState(false);
    const [selectedTask, setSelectedTask] = useState(null); // Untuk paparan detail popup

    const addTask = async () => { 
        if(!form.title || !form.deadline) return alert("Sila isi Tajuk dan Tarikh Akhir."); 
        const assignedByRole = ['admin', 'pentadbir'].includes(userData.role) ? 'Guru Besar' : 'Guru';
        await api('/tasks', { method: 'POST', body: JSON.stringify({ 
            ...form, 
            assignedBy: userData.name, 
            assignedByRole, 
            createdAt: new Date().toISOString(), 
            createdBy: currentUid 
        }) }); 
        setForm({ title: '', description: '', link: '', deadline: '', assignTo: 'Semua Guru' }); 
        setCustomTarget(false);
        alert("Tugasan dihantar."); 
    };
    
    const deleteTask = async (id, e) => { 
        e.stopPropagation(); // Elak trigger popup bila tekan delete
        if(confirm("Padam tugasan?")) await api(`/tasks/${id}`, { method: 'DELETE' }); 
    }
    
    return (
        <div className="grid lg:grid-cols-3 gap-6 h-[calc(100vh-140px)]">
            {/* LIST SECTION */}
            <div className="lg:col-span-2 bg-white rounded-xl border border-slate-200 shadow-sm overflow-hidden flex flex-col">
                <div className="p-4 border-b border-slate-100 bg-slate-50 font-bold text-slate-700 flex justify-between items-center">
                    <span>Senarai Tugasan</span>
                    <span className="text-xs font-normal text-slate-500 italic">*Klik kad untuk butiran</span>
                </div>
                <div className="flex-1 overflow-y-auto p-4 space-y-3">
                    {tasks.length === 0 ? <p className="text-center text-slate-400 italic mt-10">Tiada tugasan aktif.</p> : tasks.map(task => { 
                        const isGB = task.assignedByRole === 'Guru Besar'; 
                        const canDelete = userData.role === 'admin' || task.createdBy === currentUid; 
                        return (
                            <div 
                                key={task.id} 
                                onClick={() => setSelectedTask(task)}
                                className={`p-4 rounded-xl border flex justify-between items-start cursor-pointer hover:shadow-md transition-all group ${isGB ? 'bg-emerald-50 border-emerald-100 hover:border-emerald-300' : 'bg-white border-slate-100 hover:border-slate-300'}`}
                            >
                                <div className="flex-1">
                                    <div className="flex items-center gap-2 mb-1">
                                        {isGB && <span className="bg-emerald-600 text-white text-[10px] px-2 py-0.5 rounded font-bold uppercase">PENTADBIR</span>}
                                        <span className="text-xs text-slate-500 font-medium bg-white/50 px-2 rounded border border-slate-200">Kepada: {task.assignTo}</span>
                                    </div>
                                    <h4 className="font-bold text-slate-800 text-lg group-hover:text-emerald-700 transition-colors">{task.title}</h4>
                                    {task.description && <p className="text-xs text-slate-500 line-clamp-1 mt-1">{task.description}</p>}
                                    <p className="text-[10px] text-slate-400 mt-2 flex items-center gap-2">
                                        <span>Oleh: {task.assignedBy}</span> • 
                                        <span className="font-bold text-slate-600">Due: {formatDate(task.deadline)}</span>
                                        {task.link && <LinkIcon size={10} className="text-blue-500"/>}
                                    </p>
                                </div>
                                {canDelete && (
                                    <button 
                                        onClick={(e)=>deleteTask(task.id, e)} 
                                        className="text-slate-300 hover:text-red-500 hover:bg-red-50 p-2 rounded-full transition-colors"
                                        title="Padam Tugasan"
                                    >
                                        <Trash2 className="w-4 h-4"/>
                                    </button>
                                )}
                            </div>
                        )
                    })}
                </div>
            </div>

            {/* FORM SECTION */}
            {isStaff && (
                <div className="bg-white rounded-xl border border-slate-200 shadow-sm p-6 h-fit overflow-y-auto">
                    <h3 className="font-bold text-slate-800 mb-4 flex items-center gap-2"><Plus className="w-5 h-5 text-emerald-600"/> Tambah Tugasan</h3>
                    <div className="space-y-4">
                        {/* Tajuk - Input Biasa */}
                        <div>
                            <label className="block text-xs font-bold text-slate-500 uppercase mb-1">Tajuk Tugasan</label>
                            <input 
                                className="w-full border border-slate-300 rounded-lg p-2 text-sm focus:ring-2 focus:ring-emerald-500 outline-none" 
                                value={form.title} 
                                onChange={e=>setForm({...form, title:e.target.value})} 
                                placeholder="Contoh: Hantar RPH Minggu 42"
                            />
                        </div>

                        {/* Deskripsi - Textarea */}
                        <div>
                            <label className="block text-xs font-bold text-slate-500 uppercase mb-1">Deskripsi / Arahan (Pilihan)</label>
                            <textarea 
                                className="w-full border border-slate-300 rounded-lg p-2 text-sm h-24 resize-none focus:ring-2 focus:ring-emerald-500 outline-none" 
                                value={form.description} 
                                onChange={e=>setForm({...form, description:e.target.value})} 
                                placeholder="Maklumat lanjut mengenai tugasan..."
                            />
                        </div>

                        {/* Link - Input */}
                        <div>
                            <label className="block text-xs font-bold text-slate-500 uppercase mb-1">Pautan / Link (Pilihan)</label>
                            <div className="flex items-center border border-slate-300 rounded-lg overflow-hidden focus-within:ring-2 focus-within:ring-emerald-500">
                                <div className="bg-slate-50 p-2 border-r border-slate-300"><LinkIcon size={14} className="text-slate-400"/></div>
                                <input 
                                    className="w-full p-2 text-sm outline-none" 
                                    value={form.link} 
                                    onChange={e=>setForm({...form, link:e.target.value})} 
                                    placeholder="https://..."
                                />
                            </div>
                        </div>

                        {/* Tarikh & Sasaran */}
                        <div className="grid grid-cols-2 gap-3">
                            <div>
                                <label className="block text-xs font-bold text-slate-500 uppercase mb-1">Tarikh Akhir</label>
                                <input type="date" className="w-full border border-slate-300 rounded-lg p-2 text-sm font-bold text-slate-700" value={form.deadline} onChange={e=>setForm({...form, deadline:e.target.value})}/>
                            </div>
                            <div>
                                <label className="block text-xs font-bold text-slate-500 uppercase mb-1">Sasaran</label>
                                <select className="w-full border border-slate-300 rounded-lg p-2 text-sm" value={customTarget ? 'manual' : form.assignTo} onChange={e=>{ 
                                    if(e.target.value === 'manual') { setCustomTarget(true); setForm({...form, assignTo: ''}); } 
                                    else { setCustomTarget(false); setForm({...form, assignTo: e.target.value}); } 
                                }}>
                                    <option>Semua Guru</option>
                                    <option>Pentadbir</option>
                                    <option>Ketua Panitia</option>
                                    <option value="manual">Lain-lain...</option>
                                </select>
                            </div>
                        </div>
                        {customTarget && <input className="w-full border border-slate-300 rounded-lg p-2 text-sm" placeholder="Nyatakan sasaran (Contoh: Guru Math)" value={form.assignTo} onChange={e=>setForm({...form, assignTo:e.target.value})} />}
                        
                        <button onClick={addTask} className="w-full bg-emerald-600 text-white py-2.5 rounded-lg font-bold shadow-md hover:bg-emerald-700 transition transform active:scale-95">Hantar Arahan</button>
                    </div>
                </div>
            )}

            {/* DETAIL POPUP MODAL */}
            {selectedTask && (
                <div className="fixed inset-0 bg-black/60 z-50 flex items-center justify-center p-4 animate-fade-in backdrop-blur-sm">
                    <div className="bg-white rounded-2xl w-full max-w-lg shadow-2xl flex flex-col max-h-[90vh]">
                        <div className="p-6 border-b border-slate-100 flex justify-between items-start bg-slate-50 rounded-t-2xl">
                            <div>
                                <span className="text-[10px] font-bold uppercase tracking-wider text-slate-500 bg-white border px-2 py-1 rounded">Arahan {selectedTask.assignedByRole}</span>
                                <h3 className="text-xl font-bold text-slate-800 mt-2 leading-tight">{selectedTask.title}</h3>
                            </div>
                            <button onClick={() => setSelectedTask(null)} className="text-slate-400 hover:text-red-500 bg-white p-1 rounded-full border hover:bg-red-50 transition-colors"><X size={20}/></button>
                        </div>
                        
                        <div className="p-6 overflow-y-auto space-y-6">
                            {/* Info Grid */}
                            <div className="grid grid-cols-2 gap-4 text-sm">
                                <div className="bg-slate-50 p-3 rounded-lg border border-slate-100">
                                    <span className="block text-xs text-slate-400 uppercase font-bold mb-1">Dihantar Oleh</span>
                                    <span className="font-bold text-slate-700">{selectedTask.assignedBy}</span>
                                </div>
                                <div className="bg-slate-50 p-3 rounded-lg border border-slate-100">
                                    <span className="block text-xs text-slate-400 uppercase font-bold mb-1">Tarikh Akhir</span>
                                    <span className={`font-bold ${new Date(selectedTask.deadline) < new Date() ? 'text-red-600' : 'text-emerald-600'}`}>{formatDate(selectedTask.deadline)}</span>
                                </div>
                                <div className="bg-slate-50 p-3 rounded-lg border border-slate-100 col-span-2">
                                    <span className="block text-xs text-slate-400 uppercase font-bold mb-1">Kepada</span>
                                    <span className="font-bold text-slate-700">{selectedTask.assignTo}</span>
                                </div>
                            </div>

                            {/* Description */}
                            {selectedTask.description ? (
                                <div>
                                    <h4 className="text-sm font-bold text-slate-700 uppercase mb-2 border-b pb-1">Butiran Tugasan</h4>
                                    <p className="text-slate-600 text-sm whitespace-pre-wrap leading-relaxed">{selectedTask.description}</p>
                                </div>
                            ) : (
                                <p className="text-slate-400 italic text-sm text-center">Tiada deskripsi tambahan.</p>
                            )}

                            {/* Link Button */}
                            {selectedTask.link && (
                                <a 
                                    href={selectedTask.link} 
                                    target="_blank" 
                                    rel="noopener noreferrer"
                                    className="flex items-center justify-center gap-2 w-full bg-blue-50 text-blue-600 border border-blue-200 py-3 rounded-xl font-bold hover:bg-blue-100 transition-colors"
                                >
                                    <LinkIcon size={18}/> Buka Pautan / Lampiran
                                </a>
                            )}
                        </div>

                        <div className="p-4 border-t border-slate-100 bg-slate-50 rounded-b-2xl">
                            <button onClick={() => setSelectedTask(null)} className="w-full bg-white border border-slate-300 text-slate-600 py-2 rounded-lg font-bold hover:bg-slate-100 text-sm">Tutup</button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    )
}

function WeeklyReportManager({ userData, reports, teachers, currentUid }) {
    const [mode, setMode] = useState('list'); 
    const [formData, setFormData] = useState(null);
    const [expandedWeeks, setExpandedWeeks] = useState({});
    const [reportToDelete, setReportToDelete] = useState(null);
    const [showSuggestions, setShowSuggestions] = useState(false);
    const [suggestionTab, setSuggestionTab] = useState('perhimpunan');
    const [copyWeekModal, setCopyWeekModal] = useState(null); // { fromWeek, reports }
    const [targetWeek, setTargetWeek] = useState('');
    const [copying, setCopying] = useState(false);

    const suggestions = {
        perhimpunan: ["Perhimpunan Rasmi Mingguan dijalankan.", "Nyanyian lagu Negaraku, Melaka Maju Jaya & Sekolah.", "Bacaan Doa dan Ikrar Rukun Negara.", "Ucapan Guru Bertugas Mingguan.", "Ucapan Guru Besar / Pentadbir."],
        koku: ["Latihan Rumah Sukan.", "Perjumpaan Unit Beruniform.", "Aktiviti Kelab & Persatuan.", "Pertandingan Bola Sepak MSSM.", "Latihan Kawad Kaki."],
        cuti: ["Cuti Peristiwa sempena Sukan.", "Cuti Berganti.", "Cuti Umum (Hari Raya).", "Cuti Sakit Beramai-ramai (Bencana).", "Sesi Persekolahan berjalan seperti biasa."]
    };
    
    // Helper to get day name
    const getDayFromDate = (dateStr) => {
        const d = new Date(dateStr);
        const days = ['Ahad', 'Isnin', 'Selasa', 'Rabu', 'Khamis', 'Jumaat', 'Sabtu'];
        return days[d.getDay()];
    };

    // UBAH: Guna getTodayDate() untuk waktu Malaysia
    const todayStr = getTodayDate();

    const initialForm = { 
        week: '', 
        date: todayStr, 
        day: getDayFromDate(todayStr), // AUTO DAY ON INIT
        teachersOnDuty: [{ name: userData.name, note: 'Hadir' }], 
        teachersAbsent: [], activities: '', 
        attendance: { d1: '', d2: '', d3: '', d4: '', d5: '', d6: '', pk: '', pra: '' }, 
        checks: { kantin: { level: 'Baik', comment: '' }, makanan: { level: 'Baik', comment: '' }, sekolah: { level: 'Baik', comment: '' }, tandas: { level: 'Baik', comment: '' } }, 
        health: '', other: '', adminRemarks: '', preparedBy: userData.name, verifiedBy: '', verifiedAt: null 
    };

    const groupedReports = reports.reduce((acc, r) => {
        const w = r.week ? r.week.toString() : 'Lain';
        if (!acc[w]) acc[w] = [];
        acc[w].push(r);
        return acc;
    }, {});

    const DAY_ORDER = ['Ahad', 'Isnin', 'Selasa', 'Rabu', 'Khamis', 'Jumaat', 'Sabtu'];
    const dayIndex = (d) => {
        const i = DAY_ORDER.indexOf(d);
        return i === -1 ? 99 : i;
    };

    const sortedWeeks = Object.keys(groupedReports).sort((a, b) => {
        if(a === 'Lain') return 1;
        if(b === 'Lain') return -1;
        return parseInt(b) - parseInt(a);
    });

    const toggleWeek = (weekNum) => {
        setExpandedWeeks(prev => ({...prev, [weekNum]: !prev[weekNum]}));
    };

    const handleAddNew = () => { setFormData(initialForm); setMode('form'); };

    const handleDuplicate = (originalReport) => {
        const { id, createdAt, createdBy, verifiedBy, verifiedAt, verifiedId, ...cleanData } = originalReport;
        const newData = {
            ...initialForm,
            ...cleanData,
            teachersOnDuty: Array.isArray(cleanData.teachersOnDuty) ? cleanData.teachersOnDuty : initialForm.teachersOnDuty,
            teachersAbsent: Array.isArray(cleanData.teachersAbsent) ? cleanData.teachersAbsent : [],
            checks: cleanData.checks || initialForm.checks,
            attendance: cleanData.attendance || initialForm.attendance,
            date: todayStr,
            day: getDayFromDate(todayStr),
            preparedBy: userData.name
        };
        setFormData(newData);
        setMode('form');
        alert("Laporan disalin. Sila kemaskini Tarikh dan Hari sebelum simpan.");
    };

    const openCopyWeekModal = (weekNum, reports) => {
        setCopyWeekModal({ fromWeek: weekNum, reports });
        setTargetWeek('');
    };

    const copyFullWeek = async () => {
        if (!targetWeek) return alert("Sila masukkan nombor minggu destinasi.");
        if (targetWeek === copyWeekModal.fromWeek) return alert("Minggu destinasi tak boleh sama dengan minggu asal.");
        if (!confirm(`Salin ${copyWeekModal.reports.length} laporan dari Minggu ${copyWeekModal.fromWeek} ke Minggu ${targetWeek}?`)) return;
        
        setCopying(true);
        let success = 0;
        let failed = 0;
        
        for (const r of copyWeekModal.reports) {
            try {
                // Map camelCase → snake_case untuk API
                const payload = {
                    week: targetWeek,
                    date: r.date || '',
                    day: r.day || '',
                    teacher_uid: currentUid,
                    teacher_name: userData.name,
                    activities: r.activities || r.other || r.note || '',
                    health: r.health || '',
                    other: r.other || '',
                    level: r.checks?.sekolah?.level || r.level || '',
                    comment: r.checks?.sekolah?.comment || r.comment || '',
                    kantin: r.checks?.kantin?.level || r.kantin || '',
                    makanan: r.checks?.makanan?.level || r.makanan || '',
                    tandas: r.checks?.tandas?.level || r.tandas || '',
                    d1: r.attendance?.d1 || r.d1 || '',
                    d2: r.attendance?.d2 || r.d2 || '',
                    d3: r.attendance?.d3 || r.d3 || '',
                    d4: r.attendance?.d4 || r.d4 || '',
                    d5: r.attendance?.d5 || r.d5 || '',
                    d6: r.attendance?.d6 || r.d6 || '',
                    pk: r.attendance?.pk || r.pk || '',
                    pra: r.attendance?.pra || r.pra || '',
                    prepared_by: userData.name,
                    teachers_on_duty: JSON.stringify(r.teachersOnDuty || []),
                    teachers_absent: JSON.stringify(r.teachersAbsent || []),
                    admin_remarks: '',
                    verified_by: '',
                    verified_at: null,
                    pengesahan: 'pending',
                    created_by: currentUid,
                };
                await api('/reports', { method: 'POST', body: JSON.stringify(payload) });
                success++;
            } catch (e) {
                console.error('Copy error:', e);
                failed++;
            }
        }
        
        setCopying(false);
        setCopyWeekModal(null);
        alert(`Selesai! ${success} laporan disalin ke Minggu ${targetWeek}.${failed > 0 ? ` ${failed} gagal.` : ''}`);
    };

    const handleSave = async () => {
        if(!formData.week || !formData.date) return alert("Sila isi Minggu dan Tarikh.");
        
        // Map frontend camelCase → DB snake_case
        const payload = {
            week: formData.week,
            date: formData.date,
            day: formData.day,
            teacher_uid: currentUid,
            teacher_name: userData.name,
            activities: formData.activities || '',
            health: formData.health || '',
            other: formData.other || '',
            level: formData.checks?.sekolah?.level || '',
            comment: formData.checks?.sekolah?.comment || '',
            kantin: formData.checks?.kantin?.level || '',
            makanan: formData.checks?.makanan?.level || '',
            tandas: formData.checks?.tandas?.level || '',
            d1: formData.attendance?.d1 || '',
            d2: formData.attendance?.d2 || '',
            d3: formData.attendance?.d3 || '',
            d4: formData.attendance?.d4 || '',
            d5: formData.attendance?.d5 || '',
            d6: formData.attendance?.d6 || '',
            pk: formData.attendance?.pk || formData.attendance?.ppki || '',
            pra: formData.attendance?.pra || '',
            // FIXED: Bila edit, kekal prepared_by dari DB (original creator). Bila create baru, set nama user login.
            ...(formData.id ? {} : { prepared_by: formData.preparedBy || userData.name }),
            teachers_on_duty: JSON.stringify(formData.teachersOnDuty || []),
            teachers_absent: JSON.stringify(formData.teachersAbsent || []),
            admin_remarks: formData.adminRemarks || '',
            verified_by: formData.verifiedBy || '',
            verified_at: formData.verifiedAt ? (typeof formData.verifiedAt === 'string' ? formData.verifiedAt.replace('T', ' ').replace(/\.\d+Z$/, '') : new Date(formData.verifiedAt).toISOString().slice(0,19).replace('T',' ')) : null,
            pengesahan: formData.pengesahan || 'pending',
        };
        
        if (formData.id) {
            await api(`/reports/${formData.id}`, { method: 'PUT', body: JSON.stringify(payload) });
            alert("Laporan dikemaskini.");
        } else {
            try {
                await api('/reports', { method: 'POST', body: JSON.stringify({ ...payload, created_by: currentUid }) });
                alert("Laporan disimpan!");
            } catch (e) {
                alert('Ralat: ' + e.message);
                return;
            }
        }
        setMode('list');
    };

    const handleVerify = async () => {
        if(confirm("Sahkan laporan ini sebagai Pentadbir?")) {
            const verifierName = userData.name || userData.email || "Pentadbir";
            const verifiedData = { verifiedBy: verifierName, verifiedAt: new Date().toISOString().slice(0,19).replace('T',' '), verifiedId: currentUid };
            setFormData(prev => ({ ...prev, ...verifiedData }));
            if (formData.id) {
                try {
                    await api(`/reports/${formData.id}`, { method: 'PUT', body: JSON.stringify(verifiedData) });
                    alert("Laporan telah disahkan oleh " + verifierName + ".");
                } catch (e) {
                    console.error("Ralat pengesahan:", e);
                    alert("Ralat sistem: Gagal mengemaskini status pengesahan.");
                }
            } else {
                alert("Status disahkan. Sila tekan butang 'Simpan Laporan' untuk merekodkan data baru ini.");
            }
        }
    };

    const requestDelete = (id, ownerId, e) => {
        if(e) e.stopPropagation();
        if(userData.role !== 'admin' && ownerId !== currentUid) return alert("Anda tiada hak memadam laporan ini.");
        setReportToDelete(id);
    };

    const executeDeleteReport = async () => {
        if (reportToDelete) {
            try {
                await api(`/reports/${reportToDelete}`, { method: 'DELETE' });
                setReportToDelete(null); 
            } catch (error) {
                console.error("Gagal memadam:", error);
                alert("Ralat semasa memadam laporan.");
            }
        }
    };

    const handlePrint = () => { window.print(); };
    
    // --- SYNC ATTENDANCE LOGIC (FIXED) ---
    const syncAttendance = async () => {
        if (!formData.date) return alert("Sila pilih tarikh dahulu.");
        try {
            const snap = await api(`/attendance?date=${formData.date}`);
            
            if(!snap || snap.length === 0) return alert("Tiada rekod kehadiran untuk tarikh ini.");
            
            // UBAH: Tukar 'pk' kepada 'ppki' dalam objek statistik
            const stats = { d1: {h:0, t:0}, d2: {h:0, t:0}, d3: {h:0, t:0}, d4: {h:0, t:0}, d5: {h:0, t:0}, d6: {h:0, t:0}, ppki: {h:0, t:0}, pra: {h:0, t:0} };
            
            snap.forEach(doc => {
                const d = doc; // REST API returns plain objects, not Firestore docs
                const cls = (d.className || "").toUpperCase(); 
                const h = parseInt(d.stats?.hadir)||0; 
                const t = parseInt(d.stats?.total)||0;

                if (!cls) return;
                
                // UBAH: Logik pengesanan PPKI kini termasuk nama kelas 'IXORA'
                if (cls.includes('PPKI') || cls.includes('IXORA')) { stats.ppki.h+=h; stats.ppki.t+=t; }
                else if (cls.includes('PRA')) { stats.pra.h+=h; stats.pra.t+=t; }
                else {
                     // Check for year numbers (1-6) or words
                     if (cls.includes('1') || cls.includes('SATU')) { stats.d1.h+=h; stats.d1.t+=t; }
                     else if (cls.includes('2') || cls.includes('DUA')) { stats.d2.h+=h; stats.d2.t+=t; }
                     else if (cls.includes('3') || cls.includes('TIGA')) { stats.d3.h+=h; stats.d3.t+=t; }
                     else if (cls.includes('4') || cls.includes('EMPAT')) { stats.d4.h+=h; stats.d4.t+=t; }
                     else if (cls.includes('5') || cls.includes('LIMA')) { stats.d5.h+=h; stats.d5.t+=t; }
                     else if (cls.includes('6') || cls.includes('ENAM')) { stats.d6.h+=h; stats.d6.t+=t; }
                }
            });
            
            const newAtt = {}; 
            Object.keys(stats).forEach(k => { newAtt[k] = `${stats[k].h}/${stats[k].t}`; });
            // Kekalkan data sedia ada (jika ada) dan gabungkan dengan data baru
            setFormData(prev => ({ ...prev, attendance: { ...prev.attendance, ...newAtt } })); 
            alert("Kehadiran berjaya diselaraskan! (PPKI termasuk kelas Ixora)");
        } catch (e) { console.error(e); alert("Ralat: " + e.message); }
    };

    const insertSuggestion = (text) => { setFormData(prev => ({ ...prev, activities: prev.activities ? prev.activities + '\n• ' + text : '• ' + text })); };
    const addBullet = () => { setFormData(prev => ({ ...prev, activities: prev.activities ? prev.activities + '\n• ' : '• ' })); };

    // AUTO DATE TO DAY (FIXED)
    const handleDateChange = (e) => {
        const val = e.target.value;
        const days = ['Ahad', 'Isnin', 'Selasa', 'Rabu', 'Khamis', 'Jumaat', 'Sabtu'];
        const d = new Date(val);
        const dayName = days[d.getDay()];
        setFormData(prev => ({ ...prev, date: val, day: dayName }));
    };

    if(mode === 'list') return (
        <div className="space-y-6 h-full flex flex-col relative">
            <div className="flex justify-between items-center">
                <h2 className="text-2xl font-bold text-slate-800 flex items-center gap-2"><FileText className="w-6 h-6 text-emerald-600"/> Arkib Laporan Mingguan</h2>
                <button onClick={handleAddNew} className="bg-emerald-600 text-white px-4 py-2 rounded-lg font-bold shadow-md hover:bg-emerald-700 flex items-center gap-2"><Plus className="w-4 h-4"/> Laporan Baru</button>
            </div>
            
            <div className="flex-1 overflow-y-auto pr-2 space-y-4">
                {sortedWeeks.length === 0 ? (
                    <div className="p-12 text-center border-2 border-dashed border-slate-200 rounded-xl text-slate-400">
                        <p className="mb-2">Tiada laporan direkodkan.</p>
                        <button onClick={handleAddNew} className="text-emerald-600 font-bold hover:underline">Buat Laporan Pertama</button>
                    </div>
                ) : (
                    sortedWeeks.map(weekNum => {
                        const weekReports = groupedReports[weekNum];
                        const isOpen = expandedWeeks[weekNum];
                        return (
                            <div key={weekNum} className="bg-white border border-slate-200 rounded-xl shadow-sm overflow-hidden transition-all">
                                <div onClick={() => toggleWeek(weekNum)} className={`p-4 flex justify-between items-center cursor-pointer hover:bg-slate-50 transition-colors ${isOpen ? 'bg-emerald-50/50 border-b border-emerald-100' : ''}`}>
                                    <div className="flex items-center gap-4">
                                        <div className={`w-10 h-10 rounded-full flex items-center justify-center font-bold text-lg shadow-sm ${isOpen ? 'bg-emerald-600 text-white' : 'bg-slate-100 text-slate-500'}`}>{weekNum === 'Lain-lain' ? '?' : weekNum}</div>
                                        <div><h3 className={`font-bold text-lg ${isOpen ? 'text-emerald-900' : 'text-slate-700'}`}>Minggu {weekNum === 'Lain-lain' ? 'Umum' : weekNum}</h3><p className="text-xs text-slate-500 font-medium">{weekReports.length} Laporan Harian</p></div>
                                    </div>
                                    <div className="flex items-center gap-2">
                                        <button onClick={(e) => { e.stopPropagation(); openCopyWeekModal(weekNum, weekReports); }} className="text-xs bg-blue-50 text-blue-600 px-3 py-1.5 rounded-lg font-bold border border-blue-100 hover:bg-blue-100 transition-colors flex items-center gap-1 no-print"><Copy className="w-3.5 h-3.5"/> Salin Minggu</button>
                                        <ChevronRight className={`w-5 h-5 text-slate-400 transition-transform duration-300 ${isOpen ? 'rotate-90' : ''}`}/>
                                    </div>
                                </div>
                                {isOpen && (
                                    <div className="bg-slate-50/50 divide-y divide-slate-100 animate-fade-in">
                                         {/* Desktop header - hidden on mobile */}
                                         <div className="hidden md:grid grid-cols-12 px-4 py-2 bg-slate-100/50 text-[10px] font-bold text-slate-500 uppercase tracking-wider">
                                            <div className="col-span-3">Hari - Tarikh</div>
                                            <div className="col-span-4">Guru Bertugas</div>
                                            <div className="col-span-2">Status</div>
                                            <div className="col-span-3 text-right">Tindakan</div>
                                         </div>
                                        {[...weekReports].sort((a, b) => {
                                            const di = dayIndex(a.day) - dayIndex(b.day);
                                            if (di !== 0) return di;
                                            return new Date(a.date || 0) - new Date(b.date || 0);
                                        }).map(r => (
                                            <div key={r.id} className="px-4 py-3 hover:bg-white transition-colors text-sm border-l-4 border-transparent hover:border-emerald-500">
                                                {/* Mobile layout: stacked rows */}
                                                <div className="flex md:hidden flex-col gap-1.5">
                                                    <div className="flex items-center justify-between">
                                                        <div>
                                                            <span className="block font-bold text-slate-700 text-sm">{r.day || '-'}</span>
                                                            <span className="text-xs text-slate-500 font-mono">{formatDate(r.date)}</span>
                                                        </div>
                                                        <div>{r.verifiedBy ? <span className="inline-flex items-center gap-1 px-2 py-0.5 rounded-full bg-emerald-100 text-emerald-700 text-[10px] font-bold border border-emerald-200"><CheckCircle className="w-3 h-3"/> Disahkan</span> : <span className="inline-flex items-center gap-1 px-2 py-0.5 rounded-full bg-amber-100 text-amber-700 text-[10px] font-bold border border-amber-200"><Clock className="w-3 h-3"/> Pending</span>}</div>
                                                    </div>
                                                    <div className="text-slate-600 text-xs line-clamp-2">{Array.isArray(r.teachersOnDuty) ? r.teachersOnDuty.map(t=>t.name).join(', ') : (r.preparedBy || r.teacher_name || '-')}</div>
                                                    <div className="flex justify-end gap-2 pt-1 border-t border-slate-100">
                                                        <button onClick={()=>handleDuplicate(r)} className="p-1.5 text-slate-500 hover:text-emerald-600 hover:bg-emerald-50 rounded" title="Salin"><ClipboardList className="w-4 h-4"/></button>
                                                        <button onClick={()=>{const editData = {...initialForm, ...r, teachersOnDuty: Array.isArray(r.teachersOnDuty) ? r.teachersOnDuty : initialForm.teachersOnDuty, teachersAbsent: Array.isArray(r.teachersAbsent) ? r.teachersAbsent : [], checks: r.checks || initialForm.checks, attendance: r.attendance || initialForm.attendance}; editData.preparedBy = r.preparedBy || r.prepared_by || r.teacher_name || initialForm.preparedBy; setFormData(editData); setMode('form');}} className="p-1.5 text-slate-500 hover:text-blue-600 hover:bg-blue-50 rounded" title="Edit"><Edit3 className="w-4 h-4"/></button>
                                                        {(userData.role === 'admin' || r.createdBy === currentUid) && (
                                                            <button onClick={(e)=>requestDelete(r.id, r.createdBy, e)} className="p-1.5 text-slate-500 hover:text-red-600 hover:bg-red-50 rounded" title="Padam"><Trash2 className="w-4 h-4"/></button>
                                                        )}
                                                    </div>
                                                </div>
                                                {/* Desktop layout: grid */}
                                                <div className="hidden md:grid grid-cols-12 items-center">
                                                    <div className="col-span-3"><span className="block font-bold text-slate-700">{r.day || '-'}</span><span className="text-xs text-slate-500 font-mono">{formatDate(r.date)}</span></div>
                                                    <div className="col-span-4 text-slate-600 text-xs line-clamp-2">{Array.isArray(r.teachersOnDuty) ? r.teachersOnDuty.map(t=>t.name).join(', ') : (r.preparedBy || r.teacher_name || '-')}</div>
                                                    <div className="col-span-2">{r.verifiedBy ? <span className="inline-flex items-center gap-1 px-2 py-0.5 rounded-full bg-emerald-100 text-emerald-700 text-[10px] font-bold border border-emerald-200"><CheckCircle className="w-3 h-3"/> Disahkan</span> : <span className="inline-flex items-center gap-1 px-2 py-0.5 rounded-full bg-amber-100 text-amber-700 text-[10px] font-bold border border-amber-200"><Clock className="w-3 h-3"/> Pending</span>}</div>
                                                    <div className="col-span-3 text-right flex justify-end gap-2">
                                                        <button onClick={()=>handleDuplicate(r)} className="p-1.5 text-slate-500 hover:text-emerald-600 hover:bg-emerald-50 rounded" title="Salin"><ClipboardList className="w-4 h-4"/></button>
                                                        <button onClick={()=>{const editData = {...initialForm, ...r, teachersOnDuty: Array.isArray(r.teachersOnDuty) ? r.teachersOnDuty : initialForm.teachersOnDuty, teachersAbsent: Array.isArray(r.teachersAbsent) ? r.teachersAbsent : [], checks: r.checks || initialForm.checks, attendance: r.attendance || initialForm.attendance}; editData.preparedBy = r.preparedBy || r.prepared_by || r.teacher_name || initialForm.preparedBy; setFormData(editData); setMode('form');}} className="p-1.5 text-slate-500 hover:text-blue-600 hover:bg-blue-50 rounded" title="Edit"><Edit3 className="w-4 h-4"/></button>
                                                        {(userData.role === 'admin' || r.createdBy === currentUid) && (
                                                            <button onClick={(e)=>requestDelete(r.id, r.createdBy, e)} className="p-1.5 text-slate-500 hover:text-red-600 hover:bg-red-50 rounded" title="Padam"><Trash2 className="w-4 h-4"/></button>
                                                        )}
                                                    </div>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                )}
                            </div>
                        );
                    })
                )}
            </div>
            {reportToDelete && (
                <ConfirmModal title="Padam Laporan?" msg="Adakah anda pasti mahu memadam laporan ini? Tindakan ini tidak boleh diundur." onConfirm={executeDeleteReport} onCancel={() => setReportToDelete(null)} />
            )}
            {copyWeekModal && (
                <div className="fixed inset-0 bg-black/50 z-50 flex items-center justify-center p-4 animate-fade-in" onClick={() => !copying && setCopyWeekModal(null)}>
                    <div className="bg-white rounded-xl w-full max-w-md p-6 shadow-2xl" onClick={e => e.stopPropagation()}>
                        <div className="flex justify-between items-center mb-4 border-b pb-2">
                            <h3 className="font-bold text-lg text-slate-800 flex items-center gap-2"><Copy className="w-5 h-5 text-blue-600"/> Salin Minggu Penuh</h3>
                            {!copying && <button onClick={() => setCopyWeekModal(null)} className="text-slate-400 hover:text-red-500"><X className="w-5 h-5"/></button>}
                        </div>
                        <div className="space-y-4">
                            <div className="bg-blue-50 border border-blue-100 rounded-lg p-3 text-sm text-slate-700">
                                <p className="font-bold">Dari: Minggu {copyWeekModal.fromWeek}</p>
                                <p className="text-xs text-slate-500 mt-1">{copyWeekModal.reports.length} laporan akan disalin</p>
                            </div>
                            <div>
                                <label className="text-xs font-bold uppercase text-slate-500 block mb-1">Salin Ke Minggu (nombor)</label>
                                <input type="number" className="w-full border border-slate-300 rounded-lg p-2.5 text-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-400 outline-none" placeholder="Contoh: 21" value={targetWeek} onChange={e => setTargetWeek(e.target.value)} disabled={copying} autoFocus/>
                            </div>
                            <div className="bg-amber-50 border border-amber-100 rounded-lg p-3 text-xs text-amber-700">
                                <p className="font-bold">Nota:</p>
                                <ul className="list-disc list-inside mt-1 space-y-0.5">
                                    <li>Tarikh & hari akan kekal sama macam laporan asal</li>
                                    <li>Status pengesahan direset (perlu sahkan semula)</li>
                                    <li>Ulasan pentadbir dikosongkan</li>
                                </ul>
                            </div>
                            <button onClick={copyFullWeek} disabled={copying} className="w-full bg-blue-600 text-white py-2.5 rounded-lg font-bold hover:bg-blue-700 transition-colors flex items-center justify-center gap-2 disabled:opacity-50">
                                {copying ? <><Loader2 className="w-4 h-4 animate-spin"/> Menyalin...</> : <><Copy className="w-4 h-4"/> Salin {copyWeekModal.reports.length} Laporan ke Minggu {targetWeek || '?'}</>}
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );

    // --- FULL FORM RENDER ---
    return (
        <div className="max-w-4xl mx-auto space-y-6">
            <div className="flex justify-between items-center no-print sticky top-0 bg-[#F8FAFC] py-4 z-20 border-b border-slate-200">
                <button onClick={()=>setMode('list')} className="text-slate-500 hover:text-emerald-600 font-bold flex items-center gap-1 bg-white border border-slate-300 px-3 py-1.5 rounded-lg shadow-sm"><ChevronLeft className="w-4 h-4"/> Kembali ke Senarai</button>
                <div className="flex gap-2">
                     {(userData.role === 'pentadbir' || userData.role === 'admin') && !formData.verifiedBy && (
                        <button onClick={handleVerify} className="bg-emerald-600 text-white px-4 py-2 rounded-lg font-bold shadow hover:bg-emerald-700 flex items-center gap-2 animate-pulse"><CheckCircle className="w-4 h-4"/> Sahkan</button>
                     )}
                    <button onClick={handlePrint} className="bg-slate-100 text-slate-700 px-4 py-2 rounded-lg font-bold hover:bg-slate-200 flex items-center gap-2"><Printer className="w-4 h-4"/> Cetak</button>
                    <button onClick={handleSave} className="bg-emerald-600 text-white px-6 py-2 rounded-lg font-bold shadow-lg hover:bg-emerald-700 flex items-center gap-2"><Save className="w-4 h-4"/> Simpan Laporan</button>
                </div>
            </div>

            <div className="bg-white p-8 md:p-12 shadow-lg border border-slate-200 print-container" id="report-print">
                <div className="text-center border-b-2 border-slate-800 pb-4 mb-6">
                    <h1 className="text-2xl font-bold uppercase tracking-wide">SK Masjid Tanah (Integ)</h1>
                    <p className="text-sm text-slate-600">78300 Masjid Tanah, Melaka</p>
                    <h2 className="text-xl font-bold mt-4 uppercase underline decoration-2 underline-offset-4">Laporan Harian Guru Bertugas</h2>
                </div>

                <div className="grid grid-cols-3 gap-4 mb-6 border border-slate-300 p-4 rounded-lg bg-slate-50/50">
                    <div><label className="text-xs font-bold uppercase text-slate-500 block mb-1">Tarikh</label><input type="date" className="w-full bg-transparent font-bold border-b border-slate-300 outline-none" value={formData.date} onChange={handleDateChange}/></div>
                    <div><label className="text-xs font-bold uppercase text-slate-500 block mb-1">Hari</label><input className="w-full bg-transparent font-bold border-b border-slate-300 outline-none text-slate-500" value={formData.day} onChange={e=>setFormData({...formData, day:e.target.value})} /></div>
                    <div><label className="text-xs font-bold uppercase text-slate-500 block mb-1">Minggu</label><input type="number" className="w-full bg-transparent font-bold border-b border-slate-300 outline-none" placeholder="Contoh: 41" value={formData.week} onChange={e=>setFormData({...formData, week:e.target.value})}/></div>
                </div>
                
                {/* GURU BERTUGAS */}
                <div className="mb-6">
                    <div className="flex justify-between items-center mb-2"><h3 className="font-bold text-sm uppercase bg-slate-100 px-2 py-1 inline-block">Guru Bertugas</h3><button onClick={()=>setFormData({...formData, teachersOnDuty: [...formData.teachersOnDuty, {name:'', note:''}]})} className="text-xs text-blue-600 hover:underline no-print">+ Tambah Guru</button></div>
                    {formData.teachersOnDuty.map((t, idx) => (
                        <div key={idx} className="flex gap-2 mb-2 items-center">
                            <span className="w-6 text-center font-bold text-slate-400">{idx+1}.</span>
                            <select className="flex-1 border p-1 rounded text-sm" value={t.name} onChange={(e)=>{const n=[...formData.teachersOnDuty];n[idx].name=e.target.value;setFormData({...formData,teachersOnDuty:n})}}>
                                <option value="">Pilih Guru</option>{teachers.map(x=><option key={x.id} value={x.name}>{x.name}</option>)}
                            </select>
                            <input className="flex-1 border p-1 rounded text-sm" placeholder="Catatan (Pagar/Kantin)" value={t.note} onChange={(e)=>{const n=[...formData.teachersOnDuty];n[idx].note=e.target.value;setFormData({...formData,teachersOnDuty:n})}}/>
                            <button onClick={()=>{const n=formData.teachersOnDuty.filter((_,i)=>i!==idx);setFormData({...formData,teachersOnDuty:n})}} className="text-red-500"><X size={16}/></button>
                        </div>
                    ))}
                </div>
                
                {/* GURU TIDAK HADIR */}
                <div className="mb-6">
                    <div className="flex justify-between items-center mb-2"><h3 className="font-bold text-sm uppercase bg-slate-100 px-2 py-1 inline-block text-red-600">Guru Tidak Hadir</h3><button onClick={()=>setFormData({...formData, teachersAbsent: [...(formData.teachersAbsent||[]), {name:'', note:''}]})} className="text-xs text-blue-600 hover:underline no-print">+ Tambah Guru Tidak Hadir</button></div>
                    {(!formData.teachersAbsent || formData.teachersAbsent.length===0) ? <p className="text-sm text-slate-400 italic mb-2 px-4">Tiada rekod guru tidak hadir.</p> : 
                        formData.teachersAbsent.map((t, idx) => (
                        <div key={idx} className="flex gap-2 mb-2 items-center">
                            <span className="w-6 text-center font-bold text-slate-400">{idx+1}.</span>
                            <select className="flex-1 border p-1 rounded text-sm" value={t.name} onChange={(e)=>{const n=[...formData.teachersAbsent];n[idx].name=e.target.value;setFormData({...formData,teachersAbsent:n})}}>
                                <option value="">Pilih Guru</option>{teachers.map(x=><option key={x.id} value={x.name}>{x.name}</option>)}
                            </select>
                            <input className="flex-1 border p-1 rounded text-sm" placeholder="Sebab (MC/CRK/Kursus)" value={t.note} onChange={(e)=>{const n=[...formData.teachersAbsent];n[idx].note=e.target.value;setFormData({...formData,teachersAbsent:n})}}/>
                            <button onClick={()=>{const n=formData.teachersAbsent.filter((_,i)=>i!==idx);setFormData({...formData,teachersAbsent:n})}} className="text-red-500"><X size={16}/></button>
                        </div>
                    ))}
                </div>

                {/* LAPORAN AKTIVITI */}
                <div className="mb-6">
                    <h3 className="font-bold bg-slate-100 p-2 mb-2 text-sm uppercase flex justify-between items-center">
                        <span>Laporan / Aktiviti</span> 
                        <div className="flex gap-2 no-print">
                            <button onClick={addBullet} className="bg-white border px-2 py-0.5 rounded text-xs hover:bg-slate-50 flex items-center gap-1"><Plus size={10}/> Bullet</button>
                            <button onClick={()=>setShowSuggestions(true)} className="bg-emerald-600 text-white px-2 py-0.5 rounded text-xs hover:bg-emerald-700 flex items-center gap-1"><List size={12}/> Cadangan</button>
                        </div>
                    </h3>
                    <textarea className="w-full border border-slate-300 rounded p-3 text-sm h-32 resize-none focus:ring-1 focus:ring-emerald-500 outline-none" placeholder="• Laporan aktiviti harian..." value={formData.activities} onChange={e=>setFormData({...formData,activities:e.target.value})}></textarea>
                    
                    {/* POPUP CADANGAN */}
                    {showSuggestions && (
                        <div className="fixed inset-0 bg-black/50 z-50 flex items-center justify-center no-print">
                            <div className="bg-white rounded-xl w-96 p-6 shadow-2xl animate-fade-in">
                                <h3 className="font-bold mb-4 flex justify-between items-center text-slate-800">
                                    Pilih Cadangan Laporan
                                    <button onClick={()=>setShowSuggestions(false)} className="text-slate-400 hover:text-red-500"><X size={18}/></button>
                                </h3>
                                <div className="flex gap-2 mb-4 border-b border-slate-100 pb-2">
                                    {Object.keys(suggestions).map(t => (
                                        <button key={t} onClick={()=>setSuggestionTab(t)} className={`px-3 py-1.5 rounded-lg text-xs font-bold capitalize transition-all ${suggestionTab===t?'bg-emerald-100 text-emerald-700':'text-slate-500 hover:bg-slate-50'}`}>
                                            {t}
                                        </button>
                                    ))}
                                </div>
                                <div className="space-y-2 max-h-60 overflow-y-auto pr-1">
                                    {suggestions[suggestionTab].map((s,i)=>(
                                        <button key={i} onClick={()=>{insertSuggestion(s);setShowSuggestions(false)}} className="w-full text-left text-xs p-2.5 hover:bg-emerald-50 border border-slate-100 rounded-lg text-slate-700 transition-colors">
                                            {s}
                                        </button>
                                    ))}
                                </div>
                            </div>
                        </div>
                    )}
                </div>
                
                {/* KEHADIRAN (BUTTON SELARAS) */}
                <div className="mb-6">
                    <h3 className="font-bold bg-slate-100 p-2 mb-2 text-sm uppercase flex justify-between items-center">
                        <span>Kehadiran Murid</span> 
                        <button onClick={syncAttendance} className="text-xs bg-white border border-slate-300 px-2 py-0.5 rounded flex items-center gap-1 hover:bg-emerald-50 hover:text-emerald-700 hover:border-emerald-200 transition-colors no-print"><RefreshCw size={10}/> Selaras Harian</button>
                    </h3>
                    <div className="grid grid-cols-4 md:grid-cols-8 border border-slate-300 text-center text-sm">
                        {/* UBAH: Tukar label 'PK' kepada 'PPKI' dalam array map */}
                        {['D1','D2','D3','D4','D5','D6','PPKI','PRA'].map(c=>(
                            <div key={c} className="border-r border-b md:border-b-0 border-slate-300 last:border-r-0 md:last:border-r-0">
                                <div className="bg-slate-50 font-bold p-1 border-b border-slate-300">{c}</div>
                                {/* UBAH: Logic value untuk handle 'ppki' baru atau fallback ke 'pk' lama jika data lama dibuka */}
                                <input className="w-full text-center p-1 outline-none text-xs md:text-sm" value={formData.attendance[c.toLowerCase()] || (c === 'PPKI' ? formData.attendance['pk'] : '')} onChange={e=>setFormData({...formData,attendance:{...formData.attendance,[c.toLowerCase()]:e.target.value}})}/>
                            </div>
                        ))}
                    </div>
                </div>
                
                {/* PEMANTAUAN KANTIN & 3K */}
                <div className="grid grid-cols-2 gap-6 mb-6">
                    {Object.entries({kantin:'Kantin', makanan:'Makanan', sekolah:'Sekolah', tandas:'Tandas'}).map(([key, label]) => (
                        <div key={key} className="border border-slate-300 rounded p-3">
                            <h4 className="font-bold text-xs uppercase mb-2 text-slate-700">{label}</h4>
                            <select className="w-full border border-slate-300 rounded p-1 text-sm mb-2 outline-none bg-white focus:border-emerald-500" value={formData.checks[key].level} onChange={e=>setFormData({...formData, checks: {...formData.checks, [key]: {...formData.checks[key], level: e.target.value}}})}><option>Baik</option><option>Sederhana</option><option>Lemah</option></select>
                            <input className="w-full text-xs border-b border-slate-200 outline-none py-1 italic text-slate-500" placeholder="Ulasan..." value={formData.checks[key].comment} onChange={e=>setFormData({...formData, checks: {...formData.checks, [key]: {...formData.checks[key], comment: e.target.value}}})}/>
                        </div>
                    ))}
                </div>

                <div className="grid grid-cols-2 gap-6 mb-8">
                    <div><h3 className="font-bold text-sm uppercase bg-slate-100 px-2 py-1 inline-block mb-2">Kesihatan / Sakit</h3><textarea className="w-full border border-slate-300 rounded p-2 text-sm h-20 resize-none outline-none" value={formData.health} onChange={e=>setFormData({...formData, health:e.target.value})} placeholder="Senarai murid sakit..."></textarea></div>
                    <div><h3 className="font-bold text-sm uppercase bg-slate-100 px-2 py-1 inline-block mb-2">Hal-hal Lain</h3><textarea className="w-full border border-slate-300 rounded p-2 text-sm h-20 resize-none outline-none" value={formData.other} onChange={e=>setFormData({...formData, other:e.target.value})} placeholder="Catatan tambahan..."></textarea></div>
                </div>

                {/* ULASAN PENTADBIR / GURU BESAR */}
                <div className="mb-8 p-5 bg-emerald-50/50 border border-emerald-100 rounded-xl no-print-bg">
                    <h3 className="font-bold text-sm uppercase text-emerald-800 mb-3 flex items-center gap-2">
                        <CheckCircle size={16}/> Ulasan Pentadbir / Guru Besar
                    </h3>
                    <textarea 
                        className={`w-full border rounded-lg p-3 text-sm h-24 resize-none outline-none transition-colors ${['admin', 'pentadbir'].includes(userData.role) ? 'bg-white border-emerald-200 focus:ring-1 focus:ring-emerald-500 shadow-sm' : 'bg-transparent border-transparent text-slate-700'}`} 
                        value={formData.adminRemarks || ''} 
                        onChange={e => setFormData({...formData, adminRemarks: e.target.value})} 
                        placeholder={['admin', 'pentadbir'].includes(userData.role) ? "Sila masukkan ulasan, teguran atau maklum balas di sini..." : "Tiada ulasan direkodkan."}
                        readOnly={!['admin', 'pentadbir'].includes(userData.role)}
                    ></textarea>
                    {!['admin', 'pentadbir'].includes(userData.role) && formData.adminRemarks && (
                        <p className="text-[10px] text-emerald-400 italic mt-1 no-print">* Ulasan ini ditinggalkan oleh pihak pentadbiran.</p>
                    )}
                </div>

                <div className="grid grid-cols-2 gap-12 mt-12 pt-4">
                    <div className="text-center">
                        <p className="text-sm font-bold border-b border-black mb-1 pb-1">{formData.preparedBy}</p>
                        <p className="text-xs text-slate-500 uppercase">Disediakan Oleh (Guru Bertugas)</p>
                    </div>
                    <div className="text-center">
                        <p className="text-sm font-bold border-b border-black mb-1 pb-1">{formData.verifiedBy || '.'}</p>
                        <p className="text-xs text-slate-500 uppercase">Disahkan Oleh (Pentadbir) {formData.verifiedAt && <span className="block text-[10px] normal-case mt-1 text-emerald-600">({formatDate(formData.verifiedAt)})</span>}</p>
                    </div>
                </div>
            </div>
        </div>
    );
}

function AppBuilder({ apps, userData }) { // TERIMA PROPS USERDATA
  const [form, setForm] = useState({ title: '', desc: '', iconKey: 'portal', iconUrl: '', category: 'umum', type: 'link', content: '' });
  const [confirmDel, setConfirmDel] = useState(null);
  const [editingId, setEditingId] = useState(null);
  
  const isAdmin = userData.role === 'admin';

  const handleSave = async () => { 
      if(!form.title) return alert("Sila isi tajuk aplikasi."); 
      
      try {
          const timestamp = new Date().toISOString();
          // Jika admin buat, terus approved. Jika guru, pending.
          const status = isAdmin ? 'approved' : 'pending';
          
          const payload = {
              ...form,
              updatedAt: timestamp
          };

          if (editingId) {
              await api(`/apps/${editingId}`, { method: 'PUT', body: JSON.stringify(payload) });
              alert("Aplikasi berjaya dikemaskini!");
          } else {
              // Tambah maklumat pembuat (ownership)
              await api('/apps', { method: 'POST', body: JSON.stringify({ 
                  ...payload, 
                  status: status,
                  createdBy: userData.uid,
                  authorName: userData.name,
                  createdAt: timestamp
              }) }); 
              alert(isAdmin ? "Aplikasi diterbitkan!" : "Aplikasi dihantar untuk kelulusan Admin.");
          }
          
          handleCancel();
      } catch (e) {
          alert("Ralat: " + e.message);
      }
  };

  const handleApprove = async (appId, e) => {
      e.stopPropagation();
      if (!confirm("Luluskan aplikasi ini supaya dapat dilihat oleh semua?")) return;
      try {
          await api(`/apps/${appId}`, { method: 'PUT', body: JSON.stringify({ status: 'approved' }) });
          alert("Aplikasi diluluskan!");
      } catch (e) {
          alert("Ralat: " + e.message);
      }
  };

  const handleEdit = (app) => {
      // Halang guru edit app orang lain (walaupun UI dah filter, security tambahan)
      if (!isAdmin && app.createdBy !== userData.uid) return alert("Anda tiada akses edit aplikasi ini.");
      
      setForm({ ...app, iconUrl: app.iconUrl || '' });
      setEditingId(app.id);
  };

  const handleCancel = () => {
      setForm({ title: '', desc: '', iconKey: 'portal', iconUrl: '', category: 'umum', type: 'link', content: '' });
      setEditingId(null);
  };

  const executeDelete = async () => { 
      if(confirmDel) { 
          await api(`/apps/${confirmDel}`, { method: 'DELETE' }); 
          setConfirmDel(null); 
          if (editingId === confirmDel) handleCancel(); 
      } 
  };
  
  const handleContentChange = (e) => {
      const val = e.target.value;
      const newForm = { ...form, content: val };
      if (val.includes("import React") || val.includes("from 'react'") || val.includes("export default")) {
          newForm.type = 'react';
      } else if (val.trim().startsWith('<') && !val.includes("import React")) {
          newForm.type = 'html';
      } else if (val.startsWith('http')) {
          newForm.type = 'link';
      }
      setForm(newForm);
  };

  // FILTER LIST: Admin nampak semua, Guru nampak app sendiri sahaja
  const visibleApps = apps.filter(a => isAdmin || a.createdBy === userData.uid);

  return (
    <div className="grid lg:grid-cols-12 gap-8 h-[calc(100vh-140px)]">
        <div className="lg:col-span-8 bg-white rounded-xl border border-slate-200 p-6 flex flex-col h-full overflow-hidden">
            <div className="flex justify-between items-center mb-4">
                <h3 className="font-bold text-lg text-slate-800 flex items-center gap-2">
                    {editingId ? <><Edit3 className="w-5 h-5 text-blue-600"/> Kemaskini Aplikasi</> : <><Plus className="w-5 h-5 text-emerald-600"/> Bina Aplikasi Baru</>}
                </h3>
                {editingId && (
                    <button onClick={handleCancel} className="text-xs bg-slate-100 text-slate-600 px-3 py-1 rounded-full font-bold hover:bg-slate-200">
                        Batal Edit
                    </button>
                )}
            </div>
            
            <div className="space-y-4 flex-1 overflow-y-auto pr-2">
                {/* Title Input */}
                <div>
                    <label className="block text-xs font-bold text-slate-500 uppercase mb-1">Tajuk Aplikasi</label>
                    <input 
                        className="w-full p-3 border border-slate-300 rounded-lg text-sm focus:ring-2 focus:ring-emerald-500 focus:border-emerald-500 outline-none transition-all" 
                        value={form.title} 
                        onChange={e=>setForm({...form, title:e.target.value})} 
                        placeholder="Contoh: Kuiz Matematik Tahun 6"
                    />
                </div>

                {/* Description Input */}
                <div>
                    <label className="block text-xs font-bold text-slate-500 uppercase mb-1">Deskripsi Ringkas</label>
                    <textarea 
                        className="w-full p-3 border border-slate-300 rounded-lg text-sm h-24 resize-none focus:ring-2 focus:ring-emerald-500 focus:border-emerald-500 outline-none transition-all" 
                        value={form.desc} 
                        onChange={e=>setForm({...form, desc:e.target.value})} 
                        placeholder="Penerangan pendek tentang fungsi aplikasi ini..."
                    />
                </div>

                <div className="flex flex-col gap-2">
                    <label className="block text-xs font-bold text-slate-500 uppercase">Jenis Kandungan</label>
                    <div className="flex gap-2">
                        <button onClick={()=>setForm({...form, type:'link'})} className={`flex-1 py-2 rounded-lg text-xs font-bold border transition-all ${form.type==='link'?'bg-emerald-600 text-white border-emerald-600 shadow-md':'bg-white text-slate-600 border-slate-200 hover:bg-slate-50'}`}>Pautan URL</button>
                        <button onClick={()=>setForm({...form, type:'html'})} className={`flex-1 py-2 rounded-lg text-xs font-bold border transition-all ${form.type==='html'?'bg-emerald-600 text-white border-emerald-600 shadow-md':'bg-white text-slate-600 border-slate-200 hover:bg-slate-50'}`}>Kod HTML</button>
                        <button onClick={()=>setForm({...form, type:'react'})} className={`flex-1 py-2 rounded-lg text-xs font-bold border transition-all ${form.type==='react'?'bg-emerald-600 text-white border-emerald-600 shadow-md':'bg-white text-slate-600 border-slate-200 hover:bg-slate-50'}`}>React (Beta)</button>
                    </div>
                </div>

                {/* Content Area */}
                <div>
                    <label className="block text-xs font-bold text-slate-500 uppercase mb-1">
                        {form.type === 'link' ? 'URL Pautan' : 'Kod Sumber'}
                    </label>
                    {form.type==='link' ? (
                        <input 
                            className="w-full p-3 border border-slate-300 rounded-lg text-sm font-mono text-blue-600 focus:ring-2 focus:ring-emerald-500 outline-none" 
                            value={form.content} 
                            onChange={e=>setForm({...form, content:e.target.value})} 
                            placeholder="https://..."
                        />
                    ) : (
                        <div className="relative border border-slate-300 rounded-lg overflow-hidden">
                            <textarea 
                                className="w-full h-64 p-4 font-mono text-xs bg-slate-900 text-green-400 outline-none resize-none" 
                                value={form.content} 
                                onChange={handleContentChange} 
                                placeholder={form.type === 'react' ? "function App() { return <div className='p-4'>Hello Cikgu!</div> }" : "<!-- Masukkan kod HTML di sini -->"}
                            />
                            {form.type === 'react' && <div className="absolute bottom-0 left-0 right-0 bg-slate-800 text-slate-400 text-[10px] p-2 text-center border-t border-slate-700">Paste kod React penuh. Sistem akan render secara automatik.</div>}
                        </div>
                    )}
                </div>

                {/* Custom Icon URL Input */}
                <div className="bg-slate-50 p-4 rounded-xl border border-slate-200">
                     <label className="block text-xs font-bold text-slate-500 uppercase mb-2 flex justify-between">
                         <span>Tetapan Ikon (Gambar)</span>
                         {form.iconUrl && <span className="text-emerald-600 text-[10px] normal-case">Gambar URL akan digunakan</span>}
                     </label>
                     <div className="flex gap-3 items-center mb-3">
                         {form.iconUrl ? (
                             <img src={form.iconUrl} className="w-12 h-12 rounded-lg object-cover bg-white border" onError={(e) => e.target.src = "/assets/img/placeholder.svg"} />
                         ) : (
                             <div className="w-12 h-12 rounded-lg bg-slate-200 flex items-center justify-center text-slate-400 text-[10px] text-center leading-tight">Tiada<br/>Gambar</div>
                         )}
                         <div className="flex-1">
                             <input 
                                 className="w-full p-2 border border-slate-300 rounded-lg text-sm outline-none focus:border-emerald-500" 
                                 value={form.iconUrl || ''} 
                                 onChange={e=>setForm({...form, iconUrl: e.target.value})} 
                                 placeholder="Tampal pautan gambar (https://...)"
                             />
                             <p className="text-[10px] text-slate-400 mt-1 italic">Jika URL diisi, ikon di bawah akan diabaikan.</p>
                         </div>
                     </div>

                     {/* Fallback Icon Selector */}
                     <div>
                        <label className="block text-[10px] font-bold text-slate-400 uppercase mb-2">Atau Pilih Ikon Lalai</label>
                        <div className={`flex gap-3 overflow-x-auto pb-2 scrollbar-thin ${form.iconUrl ? 'opacity-50 pointer-events-none grayscale' : ''}`}>
                            {Object.entries(ALL_ICONS).map(([k, d]) => (
                                <button 
                                    key={k} 
                                    onClick={() => setForm({...form, iconKey: k, iconUrl: ''})} 
                                    className={`p-3 rounded-xl border transition-all flex-shrink-0 ${form.iconKey === k ? 'border-emerald-600 bg-emerald-50 ring-2 ring-emerald-200 shadow-sm transform scale-110' : 'border-slate-200 bg-white hover:border-slate-300 hover:bg-slate-50'}`} 
                                    title={k}
                                >
                                    <d.i className={`w-6 h-6 ${d.color}`}/>
                                </button>
                            ))}
                        </div>
                     </div>
                </div>
            </div>

            <div className="pt-4 mt-2 border-t border-slate-100">
                <button 
                    onClick={handleSave} 
                    className={`w-full py-3 rounded-xl font-bold text-white shadow-lg transition-all transform hover:-translate-y-1 active:scale-95 ${editingId ? 'bg-blue-600 hover:bg-blue-700' : (isAdmin ? 'bg-emerald-600 hover:bg-emerald-700' : 'bg-amber-500 hover:bg-amber-600')}`}
                >
                    {editingId ? 'Kemaskini Aplikasi' : (isAdmin ? 'Terbitkan Aplikasi' : 'Hantar Untuk Kelulusan')}
                </button>
            </div>
        </div>

        {/* Sidebar List (Filtered by Role & Status) */}
        <div className="lg:col-span-4 bg-white rounded-xl border border-slate-200 flex flex-col h-full overflow-hidden">
            <div className="p-4 border-b border-slate-100 bg-slate-50">
                <h3 className="font-bold text-slate-700 text-sm">Aplikasi Saya & Status ({visibleApps.length})</h3>
            </div>
            <div className="flex-1 overflow-y-auto p-2 space-y-2">
                {visibleApps.length === 0 ? <p className="text-center text-slate-400 text-xs py-8">Tiada aplikasi dalam senarai.</p> : visibleApps.map(a=>{
                    // Logic status
                    const isPending = a.status === 'pending';
                    
                    return (
                    <div key={a.id} className={`group flex flex-col p-3 rounded-xl border transition-all hover:shadow-md ${editingId === a.id ? 'bg-blue-50 border-blue-200 ring-1 ring-blue-300' : 'bg-white border-slate-100 hover:border-emerald-200'}`}>
                        <div className="flex justify-between items-start w-full mb-2">
                            <div className="flex items-start gap-3 overflow-hidden">
                                <div className={`w-10 h-10 rounded-lg shrink-0 flex items-center justify-center overflow-hidden shadow-sm ${a.iconUrl ? 'bg-white border border-slate-100' : (ALL_ICONS[a.iconKey]?.bg || 'bg-slate-100')}`}>
                                    {a.iconUrl ? (
                                        <img src={a.iconUrl} className="w-full h-full object-cover" alt="icon" onError={(e) => {e.target.style.display='none'; e.target.parentNode.innerHTML='<span style="font-size:8px">Err</span>'}} />
                                    ) : (
                                        React.createElement(ALL_ICONS[a.iconKey]?.i || Globe, { className: `w-5 h-5 ${ALL_ICONS[a.iconKey]?.color || 'text-slate-600'}` })
                                    )}
                                </div>
                                <div className="min-w-0">
                                    <h4 className="font-bold text-sm text-slate-800 truncate">{a.title}</h4>
                                    <div className="flex gap-1 mt-0.5">
                                        <span className="text-[9px] uppercase font-bold text-slate-400 bg-slate-100 px-1.5 py-0.5 rounded">{a.type}</span>
                                        {isPending ? 
                                            <span className="text-[9px] uppercase font-bold text-amber-600 bg-amber-100 px-1.5 py-0.5 rounded border border-amber-200">Pending</span> : 
                                            <span className="text-[9px] uppercase font-bold text-emerald-600 bg-emerald-100 px-1.5 py-0.5 rounded border border-emerald-200">Live</span>
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                        
                        {isAdmin && a.authorName && (
                            <p className="text-[10px] text-slate-400 italic mb-2">Oleh: {a.authorName}</p>
                        )}

                        <div className="flex gap-2 border-t pt-2 mt-1">
                            {isAdmin && isPending && (
                                <button onClick={(e) => handleApprove(a.id, e)} className="flex-1 bg-emerald-600 text-white py-1.5 rounded text-xs font-bold hover:bg-emerald-700 flex justify-center items-center gap-1">
                                    <CheckCircle size={12}/> Approve
                                </button>
                            )}
                            <button onClick={()=>handleEdit(a)} className="p-1.5 text-slate-500 hover:text-blue-600 bg-slate-50 hover:bg-blue-50 rounded border border-slate-200" title="Edit">
                                <Edit3 className="w-3 h-3"/>
                            </button>
                            <button onClick={()=>setConfirmDel(a.id)} className="p-1.5 text-slate-500 hover:text-red-600 bg-slate-50 hover:bg-red-50 rounded border border-slate-200" title="Padam">
                                <Trash2 className="w-3 h-3"/>
                            </button>
                        </div>
                    </div>
                )})}
            </div>
        </div>
        {confirmDel && <ConfirmModal title="Padam Aplikasi?" msg="Tindakan ini tidak boleh diundur. Adakah anda pasti?" onConfirm={executeDelete} onCancel={()=>setConfirmDel(null)}/>}
    </div>
  );
}

function AppGallery({ apps }) {
  const [sel, setSel] = useState(null);
  
  // FILTER: Hanya tunjuk yang status 'approved' ATAU tiada status (legacy apps)
  const approvedApps = apps.filter(a => !a.status || a.status === 'approved');
  
  const generateReactHtml = (code) => {
      let modifiedCode = code;
      const exportMatch = code.match(/export\s+default\s+(\w+)/);
      if (exportMatch && exportMatch[1]) {
          modifiedCode = code.replace(/export\s+default\s+\w+;?/g, ''); 
          modifiedCode += `\n\n// Auto-assigned by System\nconst App = ${exportMatch[1]};`;
      }
      return `<!DOCTYPE html><html><head><meta charset="UTF-8" /><meta name="viewport" content="width=device-width, initial-scale=1.0" /><script src="https://cdn.tailwindcss.com"><\/script><script src="https://unpkg.com/@babel/standalone/babel.min.js"><\/script><script type="importmap">{"imports":{"react":"https://esm.sh/react@18.2.0","react-dom/client":"https://esm.sh/react-dom@18.2.0/client","lucide-react":"https://esm.sh/lucide-react@0.292.0"}}<\/script><style>body{font-family:sans-serif;background-color:#ffffff}</style></head><body><div id="root"></div><script type="text/babel" data-type="module">import React,{useState,useEffect,useRef}from'react';import{createRoot}from'react-dom/client';import*as LucideIcons from'lucide-react';window.LucideIcons=LucideIcons;try{${modifiedCode} if(typeof App!=='undefined'){const root=createRoot(document.getElementById('root'));root.render(<App />);}else{document.getElementById('root').innerHTML='<div style="color:red;padding:20px;font-weight:bold;">Ralat: Komponen utama tidak dijumpai. Pastikan anda menggunakan "export default NamaComponent" atau namakan komponen sebagai "App".</div>';}}catch(err){document.getElementById('root').innerHTML='<div style="color:red;padding:20px;">Ralat Sintaks: '+err.message+'</div>';}<\/script></body></html>`;
  };

  if(sel) return (<div className="h-[80vh] bg-white rounded-xl border border-slate-200 flex flex-col"><div className="p-4 border-b flex justify-between"><button onClick={()=>setSel(null)} className="flex items-center gap-1 font-bold text-slate-600"><ChevronRight className="rotate-180 w-4 h-4"/> Kembali</button><h3 className="font-bold">{sel.title}</h3></div><div className="flex-1 relative bg-white">{sel.type === 'link' ? <div className="w-full h-full flex items-center justify-center flex-col gap-4 bg-slate-50"><ExternalLink className="w-10 h-10 text-emerald-400"/><p className="text-sm text-slate-500 text-center max-w-xs">Aplikasi ini terbuka di laman web lain. Klik butang di bawah untuk buka.</p><a href={sel.content} target="_blank" rel="noopener noreferrer" className="bg-emerald-600 text-white px-6 py-2.5 rounded-lg font-bold text-sm hover:bg-emerald-700 flex items-center gap-2"><ExternalLink className="w-4 h-4"/> Buka {sel.title}</a></div> : <iframe srcDoc={sel.type === 'react' ? generateReactHtml(sel.content) : sel.content} className="w-full h-full border-none" sandbox="allow-scripts allow-same-origin allow-forms allow-popups"/>}</div></div>);
  
  return (
    <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
        {approvedApps.length === 0 ? (
            <div className="col-span-full p-10 text-center border-2 border-dashed border-slate-200 rounded-xl text-slate-400">
                <p>Tiada aplikasi tersedia.</p>
            </div>
        ) : approvedApps.map(a=>(
            <div key={a.id} onClick={()=>setSel(a)} className="bg-white p-4 rounded-xl border hover:shadow-md cursor-pointer flex flex-col h-40 justify-between group transition-all">
                <div className="flex justify-between items-start">
                    <div className={`w-12 h-12 rounded-xl flex items-center justify-center overflow-hidden shadow-sm ${a.iconUrl ? 'bg-white border border-slate-100' : (ALL_ICONS[a.iconKey]?.bg || 'bg-slate-100')}`}>
                        {a.iconUrl ? (
                            <img src={a.iconUrl} className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-300" alt={a.title} onError={(e) => {e.target.style.display='none'; e.target.parentNode.innerHTML='<span style="font-size:10px; font-weight:bold; color:#94a3b8">ERR</span>'}} />
                        ) : (
                            React.createElement(ALL_ICONS[a.iconKey]?.i || Globe, { className: `w-6 h-6 ${ALL_ICONS[a.iconKey]?.color || 'text-slate-600'}` })
                        )}
                    </div>
                </div>
                <div>
                    <h4 className="font-bold truncate text-slate-800 group-hover:text-emerald-600 transition-colors">{a.title}</h4>
                    <p className="text-xs text-slate-500 line-clamp-2 mt-1">{a.desc || a.description}</p>
                </div>
            </div>
        ))}
    </div>
  );
}

function AttendanceManager({ students, userData, preSelectedClass }) {
    const [selectedClass, setSelectedClass] = useState(preSelectedClass || "");
    const [attendanceData, setAttendanceData] = useState({});
    const [today, setToday] = useState(getTodayDate());
    const [loading, setLoading] = useState(false);
    const [showSummary, setShowSummary] = useState(false);
    const [summaryData, setSummaryData] = useState(null);
    const [history, setHistory] = useState([]);
    
    const [filterDate, setFilterDate] = useState(""); 
    const [showResetConfirm, setShowResetConfirm] = useState(false); 
    const [showHistoryResetConfirm, setShowHistoryResetConfirm] = useState(false); 
    const [statusMessage, setStatusMessage] = useState(""); 
    const [filterName, setFilterName] = useState("");
    const [showFrequency, setShowFrequency] = useState(false);
    const [freqFilterClass, setFreqFilterClass] = useState("");
    const [freqStartDate, setFreqStartDate] = useState(""); 
    const [freqEndDate, setFreqEndDate] = useState("");
    const [analysisData, setAnalysisData] = useState([]);
    const [analysisDone, setAnalysisDone] = useState(false);

    // Ref untuk elak reset borang secara tidak sengaja
    const loadRef = useRef(""); 

    const classList = [...new Set(students.map(s => s.class))].sort();
    
    const allClassStudents = useMemo(() => students.filter(s => s.class === selectedClass).sort((a,b) => a.name.localeCompare(b.name)), [students, selectedClass]);
    const filteredClassStudents = useMemo(() => allClassStudents.filter(s => s.name.toLowerCase().includes(filterName.toLowerCase())), [allClassStudents, filterName]);

    // UBAH: Tukar orderBy('submittedAt') kepada orderBy('date')
    // Penjelasan: Firestore akan menyembunyikan dokumen yang tiada field 'submittedAt'.
    // Field 'date' sentiasa wujud, jadi ini memastikan semua rekod lama & baru muncul.
    useEffect(() => { 
        api('/attendance').then(d => setHistory(d)).catch(console.error); 
    }, []);

    // --- SMART LOAD EFFECT (DIPERBAIKI: AUTO-MERGE & RELOAD BILA PELAJAR BERUBAH) ---
    useEffect(() => {
        if (!selectedClass) {
            setAttendanceData({});
            setStatusMessage("");
            loadRef.current = "";
            return;
        }

        // Masukkan bilangan pelajar dalam konteks supaya borang refresh jika data pelajar baru masuk
        const currentContext = `${today}_${selectedClass}_${allClassStudents.length}`;
        const existingRecord = history.find(h => h.date === today && h.className === selectedClass);

        // Helper: Gabungkan rekod sedia ada dengan senarai murid terkini
        // Ini memastikan tiada murid yang statusnya 'kosong' (tak isi)
        const getMergedData = (recordData = {}) => {
            const merged = {};
            allClassStudents.forEach(s => {
                // Ambil status dari DB, jika tiada (murid baru/error), default 'Hadir'
                merged[studentKey(s)] = recordData[studentKey(s)] || 'Hadir';
            });
            return merged;
        };

        // Hanya reset/load data baru jika KONTEKS berubah
        if (loadRef.current !== currentContext) {
            if (existingRecord) {
                setAttendanceData(getMergedData(existingRecord.records));
                setStatusMessage("Rekod Terdahulu Dijumpai (Mod Edit)");
            } else {
                setAttendanceData(getMergedData({})); // Default semua Hadir
                setStatusMessage("Rekod Baru (Default: Hadir)");
            }
            loadRef.current = currentContext; 
        } else {
            // Logic Sync: Update status message jika rekod wujud tapi user belum save
            if (existingRecord && !statusMessage.includes("Terdahulu")) {
                 setStatusMessage("Rekod Terdahulu Wujud (Sila Semak)");
            }
        }
    }, [selectedClass, today, allClassStudents, history]);

    const generateAnalysis = () => {
        if (!freqStartDate || !freqEndDate) return alert("Sila pilih Tarikh Mula dan Tarikh Akhir.");
        
        const map = {};
        students.forEach(s => { map[studentKey(s)] = { id: s.id, name: s.name, class: s.class, absent: 0, total: 0 }; });

        history.forEach(h => {
            if (h.date < freqStartDate || h.date > freqEndDate) return;
            if (h.records) {
                Object.entries(h.records).forEach(([sid, status]) => {
                    if (map[sid]) {
                        map[sid].total++; 
                        if (status === 'Tidak Hadir') map[sid].absent++;
                    }
                });
            }
        });

        let result = Object.values(map);
        if (freqFilterClass) { result = result.filter(s => s.class === freqFilterClass); } 
        else { result = result.filter(s => s.absent > 0); }
        result.sort((a, b) => b.absent - a.absent);
        setAnalysisData(result);
        setAnalysisDone(true);
    };

    const submitAttendance = async () => { 
        if(!selectedClass) return alert("Pilih kelas."); 
        setLoading(true); 
        try { 
            let h=0, th=0, l=0; 
            const absentNames = [];
            const cleanRecords = {}; // Data bersih untuk disimpan

            // Guna allClassStudents untuk pastikan tiada murid tertinggal
            allClassStudents.forEach(s => {
                // Jika status undefined/null, default kepada 'Hadir' (Safety Net)
                const st = attendanceData[studentKey(s)] || 'Hadir'; 
                cleanRecords[studentKey(s)] = st;

                if(st==='Hadir') h++; 
                else if(st==='Tidak Hadir') { 
                    th++; 
                    absentNames.push(s.name);
                }
                else l++;
            });
            
            const docId = `${today}_${selectedClass.replace(/\s+/g, '_')}`; 
            const payload = { 
                date: today, 
                className: selectedClass, 
                records: cleanRecords, // Simpan cleanRecords yg lengkap
                stats: { hadir:h, tidakHadir:th, lewat:l, total: allClassStudents.length }, 
                submittedBy: userData.name, 
                submittedAt: new Date().toISOString() 
            }; 
            
            await api('/attendance', { method: 'POST', body: JSON.stringify(payload) }); 
            
            // --- TELEGRAM NOTIFICATION LOGIC ---
            try {
                const settings = await api('/settings/telegram_config');
                if (settings) {
                    const { botToken, chatId, topicId } = settings;
                    if (botToken && chatId) {
                        const pct = Math.round((h / allClassStudents.length) * 100);
                        let msg = `🔔 *LAPORAN KEHADIRAN*\n`;
                        msg += `🏫 Kelas: *${selectedClass}*\n`;
                        msg += `📅 Tarikh: ${formatDate(today)}\n`;
                        msg += `👨‍🏫 Guru: ${userData.name}\n\n`;
                        msg += `✅ Hadir: ${h}/${allClassStudents.length} (${pct}%)\n`;
                        msg += `❌ Tidak Hadir: ${th}\n`;
                        
                        if (absentNames.length > 0) {
                            msg += `\n📋 *Senarai Tidak Hadir:*\n`;
                            absentNames.forEach((n, i) => msg += `${i+1}. ${n}\n`);
                        } else {
                            msg += `\n✨ Kehadiran Penuh!`;
                        }
                        
                        // Setup Payload (Support Topics)
                        const tgPayload = { chat_id: chatId, text: msg, parse_mode: 'Markdown' };
                        if (topicId) tgPayload.message_thread_id = topicId;

                        // Hantar ke Telegram API
                        await fetch(`https://api.telegram.org/bot${botToken}/sendMessage`, {
                            method: 'POST',
                            headers: { 'Content-Type': 'application/json' },
                            body: JSON.stringify(tgPayload)
                        });
                        console.log("Telegram dihantar.");
                    }
                }
            } catch (tgErr) {
                console.error("Gagal hantar Telegram:", tgErr);
                // Jangan block UI jika Telegram gagal, cuma log error
            }
            // -----------------------------------

            setSummaryData({ ...payload.stats, absentNames: absentNames, className: selectedClass }); 
            setShowSummary(true); 
        } catch(e){
            console.error(e);
            alert("Ralat semasa menyimpan data. Sila cuba lagi.");
        } 
        setLoading(false); 
    };
    
    const shareToWhatsapp = () => {
        if (!summaryData) return;
        const pct = Math.round((summaryData.hadir / summaryData.total) * 100);
        const dateStr = formatDate(today);
        
        let text = `*LAPORAN KEHADIRAN MURID*\n`;
        text += `🏫 Kelas: *${summaryData.className}*\n`;
        text += `📅 Tarikh: ${dateStr}\n\n`;
        text += `✅ Hadir: ${summaryData.hadir} / ${summaryData.total} (${pct}%)\n`;
        text += `❌ Tidak Hadir: ${summaryData.tidakHadir}\n`;
        
        if (summaryData.absentNames && summaryData.absentNames.length > 0) {
            text += `\n*Senarai Tidak Hadir:*\n`;
            summaryData.absentNames.forEach((name, index) => {
                text += `${index + 1}. ${name}\n`;
            });
        } else {
            text += `\n✨ Tahniah, Kehadiran Penuh! ✨\n`;
        }
        
        text += `\n_Jana automatik melalui SkolaHub_`;
        
        const url = `https://wa.me/?text=${encodeURIComponent(text)}`;
        window.open(url, '_blank');
    };

    const handleCloseSummary = () => {
        setShowSummary(false);
        setSelectedClass(""); // Clear class form
        setAttendanceData({});
        setStatusMessage("");
        window.scrollTo({top: 0, behavior: 'smooth'});
    };

    const resetAttendance = () => {
        const i = {};
        allClassStudents.forEach(s => { i[studentKey(s)] = 'Hadir'; });
        setAttendanceData(i);
        setShowResetConfirm(false);
        setStatusMessage("Rekod Direset Manual");
    };

    const resetAllHistory = async () => {
        setLoading(true);
        try {
            const snapshot = await api('/attendance');

            if (!snapshot || snapshot.length === 0) {
                setLoading(false);
                setShowHistoryResetConfirm(false);
                return alert("Tiada rekod sejarah untuk dipadam.");
            }

            await api('/attendance/reset', { method: 'POST' });
            
            alert("Semua sejarah kehadiran telah berjaya dipadam.");
            setShowHistoryResetConfirm(false);
        } catch (e) {
            console.error("Ralat padam sejarah:", e);
            alert("Gagal memadam sejarah. Sila cuba lagi.");
        }
        setLoading(false);
    };

    const handleEdit = (rec) => { setSelectedClass(rec.className); setToday(rec.date); setAttendanceData(rec.records); window.scrollTo({ top: 0, behavior: 'smooth' }); };
    
    // UBAH: Buang '.slice(0, 100)' supaya SEMUA rekod sejarah dipaparkan (termasuk Januari)
    const filteredHistory = filterDate ? history.filter(h => h.date === filterDate) : history;

    return (
        <div className="max-w-4xl mx-auto space-y-8 animate-fade-in">
            {/* --- HEADER & BUTTONS --- */}
            <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-4">
                <div>
                    <h2 className="text-2xl font-bold text-slate-800 flex items-center gap-2"><UserCheck className="w-6 h-6 text-emerald-600"/> Kehadiran Murid</h2>
                    <p className="text-sm text-slate-500 font-medium">
                        {showFrequency ? 'Analisis Kekerapan Tidak Hadir' : <>Tarikh Pilihan: <span className="font-bold text-slate-700">{formatDate(today)}</span></>}
                    </p>
                </div>
                <div className="flex gap-2 w-full md:w-auto">
                    {/* BUTTON TOGGLE ANALISIS KEKERAPAN */}
                    <button onClick={() => setShowFrequency(!showFrequency)} className={`flex-1 md:flex-none px-4 py-2 rounded-lg font-bold text-sm border shadow-sm flex items-center justify-center gap-2 transition-colors ${showFrequency ? 'bg-emerald-600 text-white border-emerald-600' : 'bg-white text-slate-600 border-slate-200 hover:bg-slate-50'}`}>
                        {showFrequency ? <><ChevronLeft className="w-4 h-4"/> Kembali</> : <><AlertCircle className="w-4 h-4" /> Rekod Tidak Hadir</>}
                    </button>
                </div>
            </div>

            {/* --- VIEW: ANALISIS KEKERAPAN (TIDAK HADIR) --- */}
            {showFrequency ? (
                <div className="bg-white p-6 rounded-xl border border-slate-200 shadow-sm animate-fade-in">
                    <div className="flex flex-col gap-4 mb-6">
                        <div className="flex justify-between items-center">
                            <h3 className="font-bold text-slate-700 flex items-center gap-2"><AlertCircle className="w-5 h-5 text-red-500"/> Analisis Rekod Tidak Hadir</h3>
                            <select className="border p-2 rounded-lg text-sm font-bold bg-slate-50" value={freqFilterClass} onChange={e => setFreqFilterClass(e.target.value)}>
                                <option value="">-- Semua Kelas --</option>
                                {classList.map(c => <option key={c} value={c}>{c}</option>)}
                            </select>
                        </div>
                        
                        {/* Date Range Filter & Generate Button */}
                        <div className="flex flex-col md:flex-row md:items-end gap-2 bg-slate-50 p-3 rounded-lg border border-slate-100">
                            <div className="flex-1">
                                <span className="text-xs font-bold text-slate-500 uppercase flex items-center gap-1 mb-1"><Calendar size={12}/> Julat Tarikh:</span>
                                <div className="flex items-center gap-2">
                                    <input type="date" className="border rounded px-2 py-2 text-sm font-bold text-slate-700" value={freqStartDate} onChange={e=>{setFreqStartDate(e.target.value); setAnalysisDone(false);}} />
                                    <span className="text-slate-400 font-bold">-</span>
                                    <input type="date" className="border rounded px-2 py-2 text-sm font-bold text-slate-700" value={freqEndDate} onChange={e=>{setFreqEndDate(e.target.value); setAnalysisDone(false);}} />
                                </div>
                            </div>
                            <button onClick={generateAnalysis} className="bg-emerald-600 text-white px-4 py-2 rounded-lg font-bold shadow-md hover:bg-emerald-700 text-sm flex items-center gap-2 h-10">
                                <RefreshCw size={14}/> Jana Analisis
                            </button>
                        </div>
                    </div>

                    {analysisDone ? (
                    <div className="overflow-x-auto rounded-lg border border-slate-200 animate-fade-in">
                        <div className="bg-emerald-50 p-2 text-center text-xs font-bold text-emerald-800 border-b border-emerald-100">
                            Laporan dari {formatDate(freqStartDate)} hingga {formatDate(freqEndDate)}
                        </div>
                        <table className="w-full text-sm text-left">
                            <thead className="bg-slate-50 text-xs uppercase text-slate-500 font-bold">
                                <tr>
                                    <th className="p-3 w-16 text-center">#</th>
                                    <th className="p-3">Nama Murid</th>
                                    <th className="p-3">Kelas</th>
                                    <th className="p-3 text-center">Jumlah TH</th>
                                    <th className="p-3 text-center">Jumlah Hari</th>
                                    <th className="p-3 text-center">% TH</th>
                                </tr>
                            </thead>
                            <tbody className="divide-y divide-slate-100">
                                {analysisData.length > 0 ? analysisData.map((s, idx) => {
                                    const pct = s.total > 0 ? Math.round((s.absent / s.total) * 100) : 0;
                                    return (
                                        <tr key={s.id} className="hover:bg-slate-50">
                                            <td className="p-3 text-center font-bold text-slate-500">{idx + 1}</td>
                                            <td className="p-3 font-bold text-slate-700">{s.name}</td>
                                            <td className="p-3"><span className="text-xs bg-slate-100 px-2 py-1 rounded font-bold text-slate-600">{s.class}</span></td>
                                            <td className="p-3 text-center font-bold text-red-600">{s.absent}</td>
                                            <td className="p-3 text-center text-slate-500">{s.total}</td>
                                            <td className="p-3 text-center">
                                                <span className={`text-xs font-bold px-2 py-1 rounded ${pct > 20 ? 'bg-red-100 text-red-700' : (pct > 10 ? 'bg-amber-100 text-amber-700' : 'bg-emerald-100 text-emerald-700')}`}>
                                                    {pct}%
                                                </span>
                                            </td>
                                        </tr>
                                    );
                                }) : (
                                    <tr><td colSpan="6" className="p-8 text-center text-slate-400 italic">Tiada rekod ketidakhadiran dijumpai dalam tempoh ini.</td></tr>
                                )}
                            </tbody>
                        </table>
                    </div>
                    ) : (
                        <div className="p-12 text-center text-slate-400 italic border-2 border-dashed border-slate-200 rounded-lg">
                            Sila pilih julat tarikh dan tekan butang "Jana Analisis".
                        </div>
                    )}
                    <p className="text-xs text-slate-400 mt-4 italic">* "Jumlah Hari" merujuk kepada bilangan hari rekod kehadiran kelas murid tersebut telah diisi dalam sistem (dalam julat tarikh yang dipilih).</p>
                </div>
            ) : (
                /* --- VIEW: NORMAL FORM (JIKA BUKAN KEKERAPAN) --- */
                <>
                    <div className="bg-white p-6 rounded-xl border border-slate-200 shadow-sm">
                        <div className="mb-6">
                            <label className="lbl text-base">Pilih Tarikh & Kelas (Isi Kehadiran)</label>
                            <div className="flex gap-2">
                                <input 
                                    type="date" 
                                    className="border border-emerald-200 bg-emerald-50 text-emerald-700 rounded-lg px-3 py-3 w-1/3 text-sm font-bold shadow-sm focus:ring-2 focus:ring-emerald-500 outline-none" 
                                    value={today} 
                                    onChange={e=>setToday(e.target.value)} 
                                />
                                <select 
                                    className="w-2/3 p-3 border rounded-lg font-bold bg-white text-slate-700 focus:ring-2 focus:ring-emerald-500 outline-none" 
                                    value={selectedClass} 
                                    onChange={(e) => { setSelectedClass(e.target.value); setFilterName(""); }}
                                >
                                    <option value="">-- Sila Pilih Kelas --</option>
                                    {classList.map(c => <option key={c} value={c}>{c}</option>)}
                                </select>
                            </div>
                            {selectedClass && (
                                <div className={`mt-3 text-xs font-bold px-3 py-1.5 rounded-md inline-block ${statusMessage.includes('Terdahulu') ? 'bg-amber-100 text-amber-700' : 'bg-emerald-100 text-emerald-700'}`}>
                                    {statusMessage.includes('Terdahulu') ? <History size={12} className="inline mr-1"/> : <Plus size={12} className="inline mr-1"/>}
                                    {statusMessage}
                                </div>
                            )}
                        </div>
                        
                        {selectedClass && <>
                            {/* NEW: SEARCH FILTER IN ATTENDANCE */}
                            <div className="mb-4 flex flex-col md:flex-row items-start md:items-center justify-between gap-3 bg-slate-50 p-3 rounded-lg border border-slate-100">
                                <h3 className="font-bold text-slate-700 flex items-center gap-2"><List size={16}/> Senarai Nama ({allClassStudents.length})</h3>
                                <div className="relative w-full md:w-64">
                                    <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-slate-400"/>
                                    <input 
                                        className="border p-2 pl-9 rounded-lg text-sm w-full outline-none focus:ring-2 focus:ring-emerald-500 shadow-sm" 
                                        placeholder="Cari nama murid..." 
                                        value={filterName} 
                                        onChange={e => setFilterName(e.target.value)}
                                    />
                                </div>
                            </div>

                            <div className="overflow-x-auto border rounded-lg mb-6 max-h-[500px]">
                                <table className="w-full text-sm text-left relative">
                                    <thead className="bg-slate-100 text-xs uppercase sticky top-0 z-10">
                                        <tr><th className="p-3 w-10">Bil</th><th className="p-3">Nama</th><th className="p-3 text-center">Status</th></tr>
                                    </thead>
                                    <tbody className="divide-y">
                                        {filteredClassStudents.length > 0 ? filteredClassStudents.map((s, i) => (
                                            <tr key={s.id} className="hover:bg-slate-50">
                                                <td className="p-3 text-center text-slate-500 font-mono text-xs">{i + 1}</td>
                                                <td className="p-3 font-bold text-slate-700">{s.name}</td>
                                                <td className="p-3 flex justify-center gap-2">
                                                    {['Hadir', 'Tidak Hadir', 'Lewat'].map(st => (
                                                        <button 
                                                            key={st} 
                                                            onClick={() => setAttendanceData(p => ({ ...p, [studentKey(s)]: st }))} 
                                                            className={`px-3 py-1.5 rounded text-xs font-bold border transition-all active:scale-95 ${attendanceData[studentKey(s)] === st ? (st==='Hadir'?'bg-emerald-100 border-emerald-300 text-emerald-700 shadow-inner':st==='Tidak Hadir'?'bg-red-100 border-red-300 text-red-700 shadow-inner':'bg-amber-100 border-amber-300 text-amber-700 shadow-inner') : 'bg-white hover:bg-slate-50 text-slate-400'}`}
                                                        >
                                                            {st}
                                                        </button>
                                                    ))}
                                                </td>
                                            </tr>
                                        )) : (
                                            <tr><td colSpan="3" className="p-8 text-center text-slate-400 italic">Tiada nama murid dijumpai.</td></tr>
                                        )}
                                    </tbody>
                                </table>
                            </div>
                    
                            <div className="flex gap-3">
                                <button onClick={() => setShowResetConfirm(true)} className="flex-1 bg-slate-100 text-slate-600 py-3 rounded-lg font-bold border border-slate-300 hover:bg-slate-200 transition-colors flex justify-center items-center gap-2"><RotateCcw size={18}/> Reset Status</button>
                                <button 
                                    onClick={submitAttendance} 
                                    disabled={loading}
                                    className={`flex-[3] bg-emerald-600 text-white py-3 rounded-lg font-bold shadow-lg flex items-center justify-center gap-2 transition-all ${loading ? 'opacity-75 cursor-not-allowed' : 'hover:bg-emerald-700'}`}
                                >
                                    {loading ? (
                                        <>
                                            <Loader2 className="w-5 h-5 animate-spin"/> Sedang Menyimpan...
                                        </>
                                    ) : 'Hantar Kehadiran'}
                                </button>
                            </div>
                        </>}
                    </div>
                    
                    {/* --- SEJARAH KEHADIRAN (DIKEMASKINI: PAPAR SEMUA LALAI) --- */}
                    <div className="bg-white p-6 rounded-xl border border-slate-200 shadow-sm mt-8">
                        <div className="flex flex-col md:flex-row justify-between items-start md:items-center mb-6 gap-4 border-b border-slate-100 pb-4">
                            {/* UBAH: Tambah label (Rekod Tahunan) untuk kepastian */}
                            <h3 className="font-bold text-slate-800 flex items-center gap-2"><History className="w-5 h-5 text-emerald-600"/> Semakan Sejarah (Rekod Tahunan)</h3>
                            
                            <div className="flex flex-col md:flex-row gap-3 w-full md:w-auto items-end md:items-center">
                                {/* Input Tarikh Utama */}
                                <div className="flex items-center gap-2 bg-slate-50 p-1.5 rounded-lg border border-slate-200">
                                    <span className="text-xs font-bold text-slate-500 uppercase px-2">Cari Tarikh:</span>
                                    <input 
                                        type="date" 
                                        className="bg-white border border-slate-300 text-slate-700 text-sm rounded px-2 py-1 outline-none focus:ring-2 focus:ring-emerald-500 font-bold" 
                                        value={filterDate} 
                                        onChange={e => setFilterDate(e.target.value)} 
                                    />
                                    {filterDate && <button onClick={()=>setFilterDate("")} className="text-xs bg-red-100 text-red-600 px-2 py-1 rounded hover:bg-red-200 font-bold"><X size={14}/></button>}
                                </div>

                                {/* Butang Padam Semua Sejarah (Admin Sahaja) */}
                                {userData.role === 'admin' && (
                                    <button onClick={() => setShowHistoryResetConfirm(true)} className="flex items-center gap-1 bg-red-50 text-red-600 border border-red-200 px-3 py-1.5 rounded-lg text-xs font-bold hover:bg-red-100 whitespace-nowrap ml-2">
                                        <Trash2 size={12}/> Padam DB
                                    </button>
                                )}
                            </div>
                        </div>

                        <div className="overflow-x-auto min-h-[150px]">
                            {!filterDate ? (
                                <div className="p-12 text-center border-2 border-dashed border-slate-200 rounded-lg">
                                    <CalendarDays className="w-12 h-12 mx-auto text-slate-300 mb-3"/>
                                    <p className="text-slate-400 font-bold mb-1">Pilih tarikh untuk semak sejarah kehadiran</p>
                                    <p className="text-xs text-slate-400">Gunakan ruang "Cari Tarikh" di atas untuk memilih tarikh.</p>
                                </div>
                            ) : (
                            <table className="w-full text-sm text-left animate-fade-in">
                                <thead className="bg-slate-50 text-slate-500 font-bold uppercase text-xs">
                                    <tr><th className="p-3">Tarikh</th><th className="p-3">Kelas</th><th className="p-3 text-center">Hadir</th><th className="p-3 text-center">TH</th><th className="p-3 text-center">Lewat</th><th className="p-3 text-right"></th></tr>
                                </thead>
                                <tbody className="divide-y divide-slate-100">
                                    {filteredHistory.length === 0 ? (
                                        <tr><td colSpan="6" className="p-8 text-center text-slate-400 italic bg-slate-50/30">
                                            Tiada rekod dijumpai pada tarikh {formatDate(filterDate)}.
                                        </td></tr>
                                    ) : (
                                        filteredHistory.map(rec => (
                                            <tr key={rec.id} className="hover:bg-emerald-50/30 transition-colors">
                                                <td className="p-3 font-mono text-slate-600">{formatDate(rec.date)}</td>
                                                <td className="p-3 font-bold text-slate-800">{rec.className}</td>
                                                <td className="p-3 text-center font-bold text-emerald-600 bg-emerald-50/50 rounded-lg">{rec.stats.hadir}</td>
                                                <td className="p-3 text-center font-bold text-red-600 bg-red-50/50 rounded-lg">{rec.stats.tidakHadir}</td>
                                                <td className="p-3 text-center font-bold text-amber-600 bg-amber-50/50 rounded-lg">{rec.stats.lewat}</td>
                                                <td className="p-3 text-right"><button onClick={() => handleEdit(rec)} className="bg-white border border-blue-200 text-blue-600 px-3 py-1 rounded-lg text-xs font-bold hover:bg-blue-50 shadow-sm">Lihat / Edit</button></td>
                                            </tr>
                                        ))
                                    )}
                                </tbody>
                            </table>
                            )}
                            {filterDate && filteredHistory.length > 0 && (
                                <p className="text-[10px] text-center text-slate-400 mt-2 italic">Menunjukkan {filteredHistory.length} rekod pada {formatDate(filterDate)}.</p>
                            )}
                        </div>
                    </div>
                </>
            )}

            {showSummary && summaryData && (
                <div className="fixed inset-0 bg-black/60 flex items-center justify-center z-50 animate-fade-in backdrop-blur-sm">
                    <div className="bg-white p-6 rounded-2xl w-full max-w-md text-center shadow-2xl m-4">
                        <div className="flex justify-center mb-4">
                            <div className="bg-emerald-100 p-3 rounded-full">
                                <CheckCircle className="w-8 h-8 text-emerald-600" />
                            </div>
                        </div>
                        <h3 className="font-bold text-xl mb-1 text-slate-800">Kehadiran Direkod!</h3>
                        <p className="text-slate-500 text-sm mb-6">{summaryData.className}</p>
                        
                        <div className="grid grid-cols-2 gap-3 mb-6">
                            <div className="bg-slate-50 p-4 rounded-xl border border-slate-100">
                                <div className="text-2xl font-bold text-slate-800">
                                    {Math.round((summaryData.hadir / summaryData.total) * 100)}%
                                </div>
                                <div className="text-xs font-bold text-slate-400 uppercase">Peratus Hadir</div>
                            </div>
                            <div className="bg-red-50 p-4 rounded-xl border border-red-100">
                                <div className="text-2xl font-bold text-red-600">
                                    {summaryData.tidakHadir}
                                </div>
                                <div className="text-xs font-bold text-red-400 uppercase">Tidak Hadir</div>
                            </div>
                        </div>

                        {/* List of Absent Students */}
                        <div className="mb-6 text-left">
                            <h4 className="text-xs font-bold text-slate-500 uppercase mb-2">Senarai Tidak Hadir:</h4>
                            <div className="bg-slate-50 rounded-lg p-3 max-h-40 overflow-y-auto border border-slate-100">
                                {summaryData.absentNames && summaryData.absentNames.length > 0 ? (
                                    <ul className="space-y-1">
                                        {summaryData.absentNames.map((name, idx) => (
                                            <li key={idx} className="text-sm font-bold text-slate-700 flex items-center gap-2">
                                                <span className="text-red-500">•</span> {name}
                                            </li>
                                        ))}
                                    </ul>
                                ) : (
                                    <p className="text-sm text-emerald-600 italic font-medium text-center">Semua Murid Hadir.</p>
                                )}
                            </div>
                        </div>

                        <div className="flex flex-col gap-2">
                            <button onClick={shareToWhatsapp} className="bg-emerald-500 text-white w-full py-3 rounded-xl font-bold shadow-md hover:bg-emerald-600 transition-colors flex items-center justify-center gap-2">
                                <Share size={20} /> Kongsi ke WhatsApp
                            </button>
                            <button onClick={handleCloseSummary} className="bg-slate-100 text-slate-600 w-full py-3 rounded-xl font-bold hover:bg-slate-200 transition-colors">
                                Tutup & Selesai
                            </button>
                        </div>
                    </div>
                </div>
            )}
            
            {/* Modal Pengesahan Reset Form (Kelas Semasa) */}
            {showResetConfirm && (
                <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 animate-fade-in">
                    <div className="bg-white p-6 rounded-xl w-80 shadow-2xl">
                        <h3 className="font-bold text-lg mb-2 text-slate-700 flex items-center gap-2"><RotateCcw size={20}/> Reset Status Murid?</h3>
                        <p className="text-slate-600 mb-6 text-sm">Semua status murid dalam senarai semasa akan dikembalikan kepada <b>'Hadir'</b>.</p>
                        <div className="flex justify-end gap-2">
                            <button onClick={() => setShowResetConfirm(false)} className="px-4 py-2 rounded text-sm font-bold text-slate-600 bg-slate-100 hover:bg-slate-200">Batal</button>
                            <button onClick={resetAttendance} className="px-4 py-2 rounded text-sm font-bold bg-slate-700 text-white hover:bg-slate-800">Ya, Reset</button>
                        </div>
                    </div>
                </div>
            )}

            {/* Modal Pengesahan Reset SEJARAH (Database) */}
            {showHistoryResetConfirm && (
                <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 animate-fade-in">
                    <div className="bg-white p-6 rounded-xl w-96 shadow-2xl border-2 border-red-100">
                        <div className="flex flex-col items-center text-center mb-4">
                            <div className="w-12 h-12 bg-red-100 text-red-600 rounded-full flex items-center justify-center mb-3">
                                <Trash2 size={24}/>
                            </div>
                            <h3 className="font-bold text-xl text-red-600">Padam Semua Sejarah?</h3>
                            <p className="text-slate-500 text-sm mt-2">Tindakan ini akan memadam <b>SEMUA</b> rekod kehadiran yang pernah disimpan dalam pangkalan data. Data tidak boleh dikembalikan.</p>
                        </div>
                        <div className="flex gap-3">
                            <button onClick={() => setShowHistoryResetConfirm(false)} className="flex-1 px-4 py-2 rounded-lg font-bold bg-slate-100 text-slate-700 hover:bg-slate-200" disabled={loading}>Batal</button>
                            <button onClick={resetAllHistory} className="flex-1 px-4 py-2 rounded-lg font-bold bg-red-600 text-white hover:bg-red-700 flex justify-center items-center gap-2" disabled={loading}>
                                {loading ? <Loader2 className="w-4 h-4 animate-spin"/> : "Ya, Padam Semua"}
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}

function AgihanTugasManager({ teachers, canEdit }) {
    const [activeTab, setActiveTab] = useState('pentadbiran'); const [assignments, setAssignments] = useState({}); const [taskStructure, setTaskStructure] = useState(DEFAULT_TASKS); const [loading, setLoading] = useState(true); const [editMode, setEditMode] = useState(false); const [showAddModal, setShowAddModal] = useState(false); const [newTaskName, setNewTaskName] = useState(""); const [showDeleteModal, setShowDeleteModal] = useState(false); const [taskToDelete, setTaskToDelete] = useState(null);
    useEffect(() => { api('/assignments').then(d => { const obj = {}; d.forEach(a => { obj[`${a.category}_${a.task_name}`.replace(/[^a-zA-Z0-9]/g,'_')] = a; }); setAssignments(obj); }).catch(console.error); const f = async () => { const s = await api('/settings/agihan_tugas_structure'); if (s && s.structure) setTaskStructure(s.structure); setLoading(false); }; f(); }, []);
    const saveStructure = async (ns) => { setTaskStructure(ns); await api(`/settings/agihan_tugas_structure`, { method: 'PUT', body: JSON.stringify({ structure: ns }) }); };
    const handleAssign = async (cat, task, tid) => { if (!canEdit) return; const t = teachers.find(x => x.id === tid); const did = `${cat}_${task.replace(/[^a-zA-Z0-9]/g, '_')}`; await api(`/assignments/${did}`, { method: 'PUT', body: JSON.stringify({ category: cat, taskName: task, teacherId: tid, teacherName: t ? t.name : '', updatedAt: new Date().toISOString() }) }); };
    return (<div className="space-y-6 h-full flex flex-col relative"><div className="flex justify-between items-center"><h2 className="text-2xl font-bold text-slate-800 flex items-center gap-2"><Briefcase className="w-6 h-6 text-emerald-600"/> Agihan Tugas</h2>{canEdit && <button onClick={() => setEditMode(!editMode)} className="text-xs bg-slate-100 px-3 py-1.5 rounded-lg font-bold">{editMode ? 'Selesai' : 'Edit Senarai'}</button>}</div><div className="flex gap-2 overflow-x-auto pb-2 border-b">{[{ id: 'pentadbiran', l: 'Pentadbiran' }, { id: 'kurikulum', l: 'Kurikulum' }, { id: 'hem', l: 'HEM' }, { id: 'kokurikulum', l: 'Koko' }, { id: 'kelas', l: 'Guru Kelas' }].map(c => <button key={c.id} onClick={() => setActiveTab(c.id)} className={`px-4 py-2 rounded-lg text-sm font-bold whitespace-nowrap ${activeTab === c.id ? 'bg-emerald-600 text-white' : 'bg-white border'}`}>{c.l}</button>)}</div><div className="bg-white border rounded-xl flex-1 overflow-y-auto p-6">{loading ? <Loader2 className="animate-spin" /> : <div className="grid grid-cols-2 gap-4">{(taskStructure[activeTab] || []).map((t, i) => { const did = `${activeTab}_${t.replace(/[^a-zA-Z0-9]/g, '_')}`; const ad = assignments[did] || {}; return (<div key={i} className="border-b pb-2"><div className="flex justify-between"><label className="text-sm font-bold text-slate-700">{t}</label>{editMode && <button onClick={() => { setTaskToDelete(t); setShowDeleteModal(true); }} className="text-red-500"><Trash2 size={14} /></button>}</div>{!editMode && <select className="w-full border p-2 rounded text-sm mt-1" value={ad.teacherId || ""} onChange={(e) => handleAssign(activeTab, t, e.target.value)} disabled={!canEdit}><option value="">-- Pilih --</option>{teachers.map(x => <option key={x.id} value={x.id}>{x.name}</option>)}</select>}</div>) })}{editMode && <button onClick={() => setShowAddModal(true)} className="col-span-2 border-2 border-dashed p-4 rounded text-emerald-500 font-bold">+ Tambah Jawatan</button>}</div>}</div>{showAddModal && <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50"><div className="bg-white p-6 rounded-xl w-96"><h3 className="font-bold mb-4">Tambah</h3><input className="inp mb-4" value={newTaskName} onChange={e => setNewTaskName(e.target.value)} /><div className="flex justify-end gap-2"><button onClick={() => { const ns = { ...taskStructure }; if (!ns[activeTab]) ns[activeTab] = []; ns[activeTab].push(newTaskName); saveStructure(ns); setShowAddModal(false); setNewTaskName(""); }} className="bg-emerald-600 text-white px-4 py-2 rounded font-bold">Simpan</button></div></div></div>}{showDeleteModal && <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50"><div className="bg-white p-6 rounded-xl w-80"><h3 className="font-bold text-red-600 mb-4">Padam?</h3><p className="mb-4 text-sm">{taskToDelete}</p><div className="flex justify-end gap-2"><button onClick={() => setShowDeleteModal(false)} className="px-4 py-2 rounded bg-slate-100 font-bold">Batal</button><button onClick={() => { const ns = { ...taskStructure }; ns[activeTab] = ns[activeTab].filter(x => x !== taskToDelete); saveStructure(ns); setShowDeleteModal(false); }} className="px-4 py-2 rounded bg-red-600 text-white font-bold">Ya</button></div></div></div>}</div>);
}

function DataTable({ type, data, currentUserRole }) {
    const isReadOnly = currentUserRole === 'pentadbir'; const [newRec, setNewRec] = useState({}); const [editingId, setEditingId] = useState(null); const [selectedIds, setSelectedIds] = useState([]); const [filterClass, setFilterClass] = useState(""); const [sortOrder, setSortOrder] = useState('asc');
    // NEW: SEARCH QUERY STATE
    const [searchQuery, setSearchQuery] = useState("");

    const classList = type === 'student' ? [...new Set(data.map(d => d.class))].sort() : [];
    const processedData = useMemo(() => { 
        let r = [...data]; 
        // Filter by Class (Existing)
        if (type === 'student' && filterClass) r = r.filter(d => d.class === filterClass); 
        
        // NEW: Filter by Name (Search)
        if (searchQuery) {
            const lowerQ = searchQuery.toLowerCase();
            r = r.filter(d => (d.name || '').toLowerCase().includes(lowerQ));
        }

        r.sort((a, b) => { const nA = (a.name || '').toLowerCase(); const nB = (b.name || '').toLowerCase(); return sortOrder === 'asc' ? nA.localeCompare(nB) : nB.localeCompare(nA); }); 
        return r; 
    }, [data, filterClass, sortOrder, type, searchQuery]);
    
    // FIX: save function now correctly updates portal_users if teacher role is changed
    const save = async (e) => { 
        e.preventDefault(); 
        if (isReadOnly) return; 
        const col = type === 'student' ? 'portal_students' : 'portal_teachers'; 
        
        // Ensure role defaults to 'guru' if undefined (safety check)
        const finalRec = { ...newRec };
        if (type === 'teacher' && !finalRec.role) finalRec.role = 'guru';
        if (type === 'teacher' && !finalRec.position) finalRec.position = 'GAB';

        if (editingId) 
            await api(`${type === 'student' ? '/students' : '/teachers'}/${editingId}`, { method: 'PUT', body: JSON.stringify(finalRec) }); 
        else 
            await api(type === 'student' ? '/students' : '/teachers', { method: 'POST', body: JSON.stringify(finalRec) }); 

        // Role sync handled by backend PUT /teachers/:id

        setNewRec({}); setEditingId(null); alert("Disimpan!");
    };

    const del = async (id) => { if (confirm("Padam?")) { try { await api(`${type === 'student' ? '/students' : '/teachers'}/${id}`, { method: 'DELETE' }); alert('Dipadam.'); window.location.reload(); } catch(e) { alert('Ralat: ' + e.message); } } };
    const bulkDel = async () => { if (confirm(`Padam ${selectedIds.length}?`)) { try { await Promise.all(selectedIds.map(id => api(`${type === 'student' ? '/students' : '/teachers'}/${id}`, { method: 'DELETE' }))); setSelectedIds([]); alert('Dipadam.'); window.location.reload(); } catch(e) { alert('Ralat: ' + e.message); } } };
    
    // FUNGSI SELECT ALL
    const toggleSelectAll = () => {
        if (selectedIds.length === processedData.length && processedData.length > 0) {
            setSelectedIds([]);
        } else {
            setSelectedIds(processedData.map(d => d.id));
        }
    };

    const [csvFile, setCsvFile] = useState(null);
    const [uploading, setUploading] = useState(false);
    const handleCsvUpload = async () => {
      if (isReadOnly) return alert("Anda tiada akses untuk memuat naik data.");
      if (!csvFile) return alert("Sila pilih fail CSV dahulu.");
      setUploading(true);
      const reader = new FileReader();
      reader.onload = async (e) => {
          try {
              const text = e.target.result; const lines = text.split('\n'); const promises = []; let count = 0;
              lines.forEach((line, index) => {
                  if (index === 0 || !line.trim()) return; 
                  const cols = line.split(',').map(c => c.trim());
                  if (cols.length < 2) return; 
                  let data = {};
                  if (type === 'teacher') {
                      const name = cols[0]; const email = cols[1]; const roleRaw = cols[2] ? cols[2].toLowerCase() : 'guru'; const position = cols[3] || 'GAB';
                      if (!name || !email) return;
                      let sysRole = 'guru';
                      if (roleRaw.includes('admin')) sysRole = 'admin';
                      else if (roleRaw.includes('pentadbir')) sysRole = 'pentadbir';
                      data = { name, email, role: sysRole, position, createdAt: new Date().toISOString() };
                  } else {
                      const name = cols[0]; const className = cols[1] || 'Umum'; if (!name) return;
                      const rmt = cols[2] ? cols[2].trim() : 'Tidak';
                      data = { name, class: className, rmt, createdAt: new Date().toISOString() };
                  }
                  promises.push(api(type === 'student' ? '/students' : '/teachers', { method: 'POST', body: JSON.stringify(data) })); count++;
              });
              if (count > 0) { await Promise.all(promises); alert(`${count} rekod berjaya dimuat naik!`); setCsvFile(null); } else { alert("Tiada data sah ditemui."); }
          } catch (err) { console.error(err); alert("Ralat memproses fail."); }
          setUploading(false);
      };
      reader.readAsText(csvFile);
  };

    const title = type === 'student' ? 'Data Murid' : 'Data Guru';
    const Icon = type === 'student' ? GraduationCap : Users;
    const subtitle = type === 'student'
        ? 'Urus rekod murid, kelas dan status RMT dalam satu paparan ringkas.'
        : 'Urus rekod guru, emel, peranan sistem dan jawatan sekolah.';
    const rmtCount = type === 'student' ? data.filter(d => d.rmt === 'Layak').length : 0;
    const adminCount = type === 'teacher' ? data.filter(d => ['admin', 'pentadbir'].includes(d.role)).length : 0;

    return (
        <div className="max-w-7xl mx-auto space-y-6 animate-fade-in">
            <div className="bg-gradient-to-br from-emerald-600 via-emerald-600 to-violet-600 rounded-2xl p-5 md:p-6 text-white shadow-lg shadow-emerald-100 border border-emerald-500/20 overflow-hidden relative">
                <div className="absolute -right-10 -top-10 w-40 h-40 bg-white/10 rounded-full blur-2xl"></div>
                <div className="relative flex flex-col md:flex-row md:items-end md:justify-between gap-4">
                    <div className="flex items-start gap-4">
                        <div className="w-12 h-12 rounded-2xl bg-white/15 border border-white/20 flex items-center justify-center shadow-inner">
                            <Icon className="w-6 h-6" />
                        </div>
                        <div>
                            <p className="text-[11px] uppercase tracking-[0.2em] font-black text-emerald-100">Pengurusan Rekod</p>
                            <h2 className="text-2xl md:text-3xl font-black mt-1">{title}</h2>
                            <p className="text-sm text-emerald-100 mt-1 max-w-2xl">{subtitle}</p>
                        </div>
                    </div>
                    <div className="grid grid-cols-3 gap-2 min-w-[260px]">
                        <div className="bg-white/12 border border-white/15 rounded-xl p-3 backdrop-blur-sm">
                            <p className="text-[10px] uppercase font-bold text-emerald-100">Jumlah</p>
                            <p className="text-xl font-black">{data.length}</p>
                        </div>
                        <div className="bg-white/12 border border-white/15 rounded-xl p-3 backdrop-blur-sm">
                            <p className="text-[10px] uppercase font-bold text-emerald-100">Ditapis</p>
                            <p className="text-xl font-black">{processedData.length}</p>
                        </div>
                        <div className="bg-white/12 border border-white/15 rounded-xl p-3 backdrop-blur-sm">
                            <p className="text-[10px] uppercase font-bold text-emerald-100">{type === 'student' ? 'RMT' : 'Admin'}</p>
                            <p className="text-xl font-black">{type === 'student' ? rmtCount : adminCount}</p>
                        </div>
                    </div>
                </div>
            </div>

            <div className="grid lg:grid-cols-12 gap-6 items-start">
                {!isReadOnly && (
                    <aside className="lg:col-span-4 space-y-4">
                        <div className="bg-white/90 backdrop-blur rounded-2xl border border-slate-200 shadow-sm overflow-hidden">
                            <div className="p-5 border-b border-slate-100 bg-slate-50/70">
                                <h3 className="font-black text-slate-800 flex items-center gap-2">
                                    <Plus className="w-5 h-5 text-emerald-600"/> {editingId ? 'Edit Rekod' : 'Tambah Rekod'}
                                </h3>
                                <p className="text-xs text-slate-500 mt-1">Isi maklumat asas, kemudian tekan Simpan.</p>
                            </div>
                            <form onSubmit={save} className="p-5 space-y-3">
                                <input className="inp" placeholder="Nama penuh" value={newRec.name || ''} onChange={e => setNewRec({ ...newRec, name: e.target.value })} required />
                                {type === 'student' ? (
                                    <>
                                        <input className="inp" placeholder="Kelas, contoh: 4 Bestari" value={newRec.class || ''} onChange={e => setNewRec({ ...newRec, class: e.target.value })} required />
                                        <select className="inp" value={newRec.rmt || 'Tidak'} onChange={e => setNewRec({ ...newRec, rmt: e.target.value })}>
                                            <option value="Tidak">Bukan RMT</option>
                                            <option value="Layak">RMT Layak</option>
                                        </select>
                                    </>
                                ) : (
                                    <>
                                        <input className="inp" placeholder="Email rasmi" value={newRec.email || ''} onChange={e => setNewRec({ ...newRec, email: e.target.value })} required />
                                        <div className="grid grid-cols-2 gap-2">
                                            <select className="inp" value={newRec.role || 'guru'} onChange={e => setNewRec({ ...newRec, role: e.target.value })}>
                                                <option value="guru">Guru Biasa</option>
                                                <option value="pentadbir">Pentadbir</option>
                                                <option value="admin">Admin</option>
                                                <option value="akp">AKP (Pembantu)</option>
                                            </select>
                                            <select className="inp" value={newRec.position || 'GAB'} onChange={e => setNewRec({ ...newRec, position: e.target.value })}>
                                                <option value="GAB">GAB</option>
                                                <option value="GB">Guru Besar</option>
                                                <option value="GPK">GPK</option>
                                                <option value="Kaunselor">Kaunselor</option>
                                            </select>
                                        </div>
                                    </>
                                )}
                                <div className="flex gap-2 pt-1">
                                    {editingId && <button type="button" onClick={() => { setNewRec({}); setEditingId(null); }} className="px-4 py-2.5 rounded-xl font-bold text-sm bg-slate-100 text-slate-600 hover:bg-slate-200">Batal</button>}
                                    <button className="flex-1 bg-emerald-600 hover:bg-emerald-700 text-white py-2.5 rounded-xl font-bold shadow-md shadow-emerald-100 flex items-center justify-center gap-2">
                                        <Save size={16}/> Simpan
                                    </button>
                                </div>
                            </form>
                        </div>

                        <div className="bg-white rounded-2xl border border-slate-200 shadow-sm p-5">
                            <h3 className="font-black text-slate-800 flex items-center gap-2 mb-2"><FileSpreadsheet size={18} className="text-emerald-600"/> Import CSV</h3>
                            <div className="text-xs text-slate-500 mb-4 bg-emerald-50/70 p-3 rounded-xl border border-emerald-100">
                                <p className="font-bold text-emerald-700 mb-1">Format fail</p>
                                {type === 'student' ? (
                                    <><code className="block font-mono bg-white/80 p-2 rounded-lg border border-emerald-100 text-slate-600">Nama, Kelas, RMT</code><p className="mt-1 text-[10px] italic">RMT: Layak atau Tidak</p></>
                                ) : (
                                    <><code className="block font-mono bg-white/80 p-2 rounded-lg border border-emerald-100 text-slate-600">Nama, Email, Role, Jawatan</code><p className="mt-1 text-[10px] italic">Role: admin, pentadbir atau guru</p></>
                                )}
                            </div>
                            <input type="file" accept=".csv,text/csv" onChange={e => setCsvFile(e.target.files[0])} className="block w-full text-xs text-slate-500 file:mr-3 file:py-2 file:px-3 file:rounded-lg file:border-0 file:bg-slate-100 file:text-slate-600 file:font-bold mb-3" />
                            <button onClick={handleCsvUpload} disabled={uploading} className="w-full bg-emerald-600 hover:bg-emerald-700 disabled:opacity-60 text-white py-2.5 rounded-xl font-bold text-sm flex items-center justify-center gap-2">
                                {uploading ? <Loader2 className="w-4 h-4 animate-spin"/> : <FileSpreadsheet size={16}/>} {uploading ? 'Memuat naik...' : 'Upload CSV'}
                            </button>
                        </div>
                    </aside>
                )}

                <section className={`${isReadOnly ? 'lg:col-span-12' : 'lg:col-span-8'} bg-white rounded-2xl border border-slate-200 shadow-sm overflow-hidden`}>
                    <div className="p-4 md:p-5 border-b border-slate-100 bg-white">
                        <div className="flex flex-col gap-4">
                            <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-3">
                                <div>
                                    <h3 className="font-black text-slate-800 flex items-center gap-2"><List className="w-5 h-5 text-emerald-600"/> Senarai {title}</h3>
                                    <p className="text-xs text-slate-500 mt-1">Pilih rekod untuk tindakan pukal atau cari nama dengan pantas.</p>
                                </div>
                                {selectedIds.length > 0 && !isReadOnly && (
                                    <button onClick={bulkDel} className="bg-red-50 text-red-600 border border-red-100 px-4 py-2 rounded-xl text-xs font-black hover:bg-red-100 flex items-center gap-2 justify-center">
                                        <Trash2 size={14}/> Padam {selectedIds.length}
                                    </button>
                                )}
                            </div>
                            <div className="flex flex-col md:flex-row gap-2">
                                <div className="relative flex-1">
                                    <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-slate-400"/>
                                    <input
                                        className="w-full border border-slate-200 bg-slate-50 rounded-xl py-2.5 pl-10 pr-3 text-sm outline-none focus:ring-2 focus:ring-emerald-500 focus:bg-white"
                                        placeholder={`Cari nama ${type === 'student' ? 'murid' : 'guru'}...`}
                                        value={searchQuery}
                                        onChange={e => setSearchQuery(e.target.value)}
                                    />
                                </div>
                                {type === 'student' && (
                                    <select className="border border-slate-200 bg-slate-50 rounded-xl px-3 py-2.5 text-sm font-bold text-slate-600 outline-none focus:ring-2 focus:ring-emerald-500" value={filterClass} onChange={e => setFilterClass(e.target.value)}>
                                        <option value="">Semua Kelas</option>
                                        {classList.map(c => <option key={c} value={c}>{c}</option>)}
                                    </select>
                                )}
                                <button onClick={() => setSortOrder(p => p === 'asc' ? 'desc' : 'asc')} className="border border-slate-200 bg-slate-50 hover:bg-slate-100 rounded-xl px-4 py-2.5 text-sm font-black text-slate-600 flex items-center justify-center gap-2">
                                    <Filter size={15}/> {sortOrder === 'asc' ? 'A-Z' : 'Z-A'}
                                </button>
                            </div>
                        </div>
                    </div>

                    <div className="divide-y divide-slate-100 max-h-[650px] overflow-y-auto">
                        {processedData.length === 0 ? (
                            <div className="p-10 text-center text-slate-400">
                                <Search className="w-10 h-10 mx-auto mb-3 opacity-40"/>
                                <p className="font-bold text-slate-500">Tiada rekod dijumpai</p>
                                <p className="text-sm">Cuba ubah carian atau tapis kelas.</p>
                            </div>
                        ) : processedData.map((d, idx) => {
                            const selected = selectedIds.includes(d.id);
                            return (
                                <div key={d.id} className={`group p-4 md:px-5 hover:bg-emerald-50/40 transition-colors ${selected ? 'bg-emerald-50/70' : 'bg-white'}`}>
                                    <div className="flex items-center gap-3">
                                        <button type="button" onClick={() => setSelectedIds(p => p.includes(d.id) ? p.filter(x => x !== d.id) : [...p, d.id])} className="text-slate-300 hover:text-emerald-600 shrink-0" title="Pilih rekod">
                                            {selected ? <CheckSquare className="w-5 h-5 text-emerald-600"/> : <Square className="w-5 h-5"/>}
                                        </button>
                                        <div className={`w-10 h-10 rounded-2xl flex items-center justify-center font-black text-sm shrink-0 ${type === 'student' ? 'bg-emerald-50 text-emerald-700' : 'bg-emerald-50 text-emerald-700'}`}>
                                            {(d.name || '?').slice(0, 1).toUpperCase()}
                                        </div>
                                        <div className="min-w-0 flex-1">
                                            <div className="flex flex-col md:flex-row md:items-center md:gap-2">
                                                <p className="font-black text-slate-800 truncate">{d.name}</p>
                                                <span className="hidden md:inline text-xs text-slate-300">#{idx + 1}</span>
                                            </div>
                                            {type === 'student' ? (
                                                <div className="flex flex-wrap items-center gap-2 mt-1">
                                                    <span className="text-xs bg-emerald-50 text-emerald-700 border border-emerald-100 px-2 py-1 rounded-lg font-bold">{d.class || 'Tiada kelas'}</span>
                                                    <span className={`text-xs font-bold px-2 py-1 rounded-lg border ${d.rmt === 'Layak' ? 'bg-orange-50 text-orange-700 border-orange-100' : 'bg-slate-50 text-slate-400 border-slate-100'}`}>RMT: {d.rmt || 'Tidak'}</span>
                                                </div>
                                            ) : (
                                                <div className="flex flex-wrap items-center gap-2 mt-1 text-xs">
                                                    <span className="text-slate-500 truncate max-w-[260px]">{d.email || 'Tiada email'}</span>
                                                    <span className={`font-bold px-2 py-1 rounded-lg border ${d.role === 'admin' ? 'bg-red-50 text-red-600 border-red-100' : d.role === 'pentadbir' ? 'bg-violet-50 text-violet-700 border-violet-100' : d.role === 'akp' ? 'bg-teal-50 text-teal-600 border-teal-100' : 'bg-slate-50 text-slate-500 border-slate-100'}`}>{d.role || 'guru'}</span>
                                                    <span className="bg-emerald-50 text-emerald-600 border border-emerald-100 font-bold px-2 py-1 rounded-lg">{d.position || 'GAB'}</span>
                                                </div>
                                            )}
                                        </div>
                                        {!isReadOnly && (
                                            <div className="flex items-center gap-1 shrink-0 opacity-100 md:opacity-0 md:group-hover:opacity-100 transition-opacity">
                                                <button onClick={() => { setNewRec(d); setEditingId(d.id); window.scrollTo({ top: 0, behavior: 'smooth' }); }} className="w-9 h-9 rounded-xl bg-blue-50 text-blue-600 hover:bg-blue-100 flex items-center justify-center" title="Edit">
                                                    <Edit3 size={16} />
                                                </button>
                                                <button onClick={() => del(d.id)} className="w-9 h-9 rounded-xl bg-red-50 text-red-500 hover:bg-red-100 flex items-center justify-center" title="Padam">
                                                    <Trash2 size={16} />
                                                </button>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            );
                        })}
                    </div>

                    <div className="p-3 border-t border-slate-100 bg-slate-50/80 flex flex-col md:flex-row md:items-center md:justify-between gap-2 text-xs text-slate-500">
                        <button onClick={toggleSelectAll} className="font-bold text-emerald-600 hover:text-emerald-700 flex items-center gap-1">
                            {processedData.length > 0 && selectedIds.length === processedData.length ? <CheckSquare size={14}/> : <Square size={14}/>} {processedData.length > 0 && selectedIds.length === processedData.length ? 'Nyahpilih semua' : 'Pilih semua dipaparkan'}
                        </button>
                        <span>{processedData.length} daripada {data.length} rekod dipaparkan</span>
                    </div>
                </section>
            </div>
        </div>
    );
}

// --- 3. DASHBOARD & MAIN ---

function Dashboard({ userData, apps, students, teachers, tasks, setView, setTargetClass }) {
  const role = userData.role;
  const showStats = ['admin', 'pentadbir', 'guru'].includes(role);
  const stats = [ { l: 'Aplikasi', v: apps.length, i: LayoutDashboard, c: 'text-blue-600', b: 'bg-blue-50' }, { l: 'Murid', v: showStats ? students.length : '-', i: GraduationCap, c: 'text-emerald-600', b: 'bg-emerald-50' }, { l: 'Guru', v: showStats ? teachers.length : '-', i: Users, c: 'text-emerald-600', b: 'bg-emerald-50' } ];
  const [todayAttendance, setTodayAttendance] = useState([]);
  const [loadingAtt, setLoadingAtt] = useState(true);
  // UBAH: Guna getTodayDate() untuk dashboard juga
  const today = getTodayDate();
  
  // State for popup details
  const [viewClass, setViewClass] = useState(null);
  
  // --- ADMIN RESET STATES ---
  const [showResetConfirm, setShowResetConfirm] = useState(false);
  const [isResetting, setIsResetting] = useState(false);

  // NEW: EVENTS FOR TICKER
  const [events, setEvents] = useState([]);

  // --- GURU GANTI HARI INI ---
  const [todayRelief, setTodayRelief] = useState([]);
  const [loadingRelief, setLoadingRelief] = useState(true);

  // --- AKTIVITI TERKINI (Recent Activity Feed) ---
  const [recentLogs, setRecentLogs] = useState([]);
  const [loadingLogs, setLoadingLogs] = useState(true);

  useEffect(() => { api(`/attendance?date=${today}`).then(d => { setTodayAttendance(d); setLoadingAtt(false); }).catch(() => setLoadingAtt(false)); }, []);
  
  // Fetch Events for Ticker
  useEffect(() => {
      api('/events').then(d => setEvents(d)).catch(console.error);
  }, []);

  // Fetch today's relief assignments
  useEffect(() => {
      api(`/relief?date=${today}`).then(d => { setTodayRelief(d); setLoadingRelief(false); }).catch(() => setLoadingRelief(false));
  }, []);

  // Fetch recent activity logs (last 5)
  useEffect(() => {
      api('/logs').then(d => { setRecentLogs((d || []).slice(-5).reverse()); setLoadingLogs(false); }).catch(() => setLoadingLogs(false));
  }, []);

  // Reset target class on mount
  useEffect(() => { if(setTargetClass) setTargetClass(null); }, []);

  const allClasses = [...new Set(students.map(s => s.class))].sort();
  
  // Calculate overall percentage
  const totalSchoolStudents = todayAttendance.reduce((acc, curr) => acc + (curr.stats?.total || 0), 0);
  const totalSchoolPresent = todayAttendance.reduce((acc, curr) => acc + (curr.stats?.hadir || 0), 0);
  const overallPercentage = totalSchoolStudents > 0 ? ((totalSchoolPresent / totalSchoolStudents) * 100).toFixed(2) : "0.00";

  // Calculate RMT Stats
  const rmtStudents = students.filter(s => s.rmt === 'Layak');
  const rmtTotal = rmtStudents.length;
  let rmtPresent = 0;
  let rmtAbsentList = [];

  // Flatten attendance records for lookup
  const attendanceStatus = {};
  todayAttendance.forEach(record => {
      if(record.records) Object.assign(attendanceStatus, record.records);
  });

  rmtStudents.forEach(student => {
      const status = attendanceStatus[studentKey(student)];
      if(status === 'Hadir') rmtPresent++;
      if(status === 'Tidak Hadir') rmtAbsentList.push(student);
  });

  const rmtPercent = rmtTotal > 0 ? Math.round((rmtPresent / rmtTotal) * 100) : 0;

  // Logic untuk upcoming events
  const upcomingEvents = useMemo(() => {
      const todayStr = getTodayDate();
      const combined = [...KPM_EVENTS, ...events];
      // Filter acara yang tarikh tamat (atau mula) >= hari ini
      return combined.filter(e => {
          const endDate = e.end || e.start;
          return endDate >= todayStr;
      }).sort((a,b) => a.start.localeCompare(b.start));
  }, [events]);

  const getAbsentNames = (record) => {
      if (!record || !record.records) return [];
      // Filter status 'Tidak Hadir' strictly for absent list
      const strictAbsentIds = Object.entries(record.records)
          .filter(([id, status]) => status === 'Tidak Hadir')
          .map(([id]) => id);
          
      return students.filter(s => strictAbsentIds.includes(studentKey(s))).map(s => s.name);
  };

  // FUNGSI SHARE WHATSAPP DASHBOARD
  const shareDashboardWhatsapp = () => {
      if (!viewClass) return;
      const pct = Math.round((viewClass.stats.hadir / viewClass.stats.total) * 100);
      const absentNames = getAbsentNames(viewClass);
      const dateStr = formatDate(today);

      let text = `*LAPORAN KEHADIRAN (SEMASA)*\n`;
      text += `🏫 Kelas: *${viewClass.className}*\n`;
      text += `📅 Tarikh: ${dateStr}\n\n`;
      text += `✅ Hadir: ${viewClass.stats.hadir} / ${viewClass.stats.total} (${pct}%)\n`;
      text += `❌ Tidak Hadir: ${viewClass.stats.tidakHadir}\n`;

      if (absentNames.length > 0) {
          text += `\n*Senarai Tidak Hadir:*\n`;
          absentNames.forEach((name, index) => {
              text += `${index + 1}. ${name}\n`;
          });
      } else {
          text += `\n✨ Tahniah, Kehadiran Penuh! ✨\n`;
      }
      
      const url = `https://wa.me/?text=${encodeURIComponent(text)}`;
      window.open(url, '_blank');
  };

  // FUNGSI SHARE WHATSAPP DASHBOARD (KESELURUHAN KELAS + NAMA TH + RMT) - DIKEMASKINI
  const shareAllAttendanceWhatsapp = () => {
      const dateStr = formatDate(today);
      let text = `*LAPORAN KEHADIRAN HARIAN*\n`;
      text += `📅 Tarikh: ${dateStr}\n`;
      text += `🏫 Keseluruhan: *${overallPercentage}%* (${totalSchoolPresent}/${totalSchoolStudents})\n\n`;
      text += `*Perincian Kelas & Tidak Hadir:*\n`;

      allClasses.forEach((cls, index) => {
          const record = todayAttendance.find(a => a.className === cls);
          
          if (record && record.records) {
              const p = record.stats.total > 0 ? Math.round((record.stats.hadir / record.stats.total) * 100) : 0;
              text += `\n*${index + 1}. ${cls}*: ${record.stats.hadir}/${record.stats.total} (${p}%)`;
              
              // Cari senarai nama murid TH untuk kelas ini
              const classStudents = students.filter(s => s.class === cls);
              const absentNames = classStudents
                  .filter(s => record.records[studentKey(s)] === 'Tidak Hadir')
                  .map(s => s.name);

              if (absentNames.length > 0) {
                  text += `\n   ❌ TH: ${absentNames.join(', ')}`;
              } else {
                  text += `\n   ✅ Penuh`;
              }
          } else {
              text += `\n${index + 1}. ${cls}: - (Belum Isi)`;
          }
      });

      // --- TAMBAHAN: LAPORAN RMT DI BAWAH ---
      text += `\n\n━━━━━━━━━━━━━━\n`;
      text += `*STATUS RMT (LAYAK)*\n`;
      text += `🍽️ Kehadiran RMT: ${rmtPresent} / ${rmtTotal} (${rmtPercent}%)\n`;
      
      if (rmtAbsentList.length > 0) {
          text += `❌ TH RMT: ${rmtAbsentList.map(s => s.name).join(', ')}`;
      } else {
          text += `✅ Penuh (Semua Layak Hadir)`;
      }

      text += `\n\n_Jana automatik melalui SkolaHub_`;
      
      const url = `https://wa.me/?text=${encodeURIComponent(text)}`;
      window.open(url, '_blank');
  };

  // --- ADMIN FACTORY RESET LOGIC ---
  const performFactoryReset = async () => {
      setIsResetting(true);
      try {
          const collectionsToReset = [
              'portal_apps', 'portal_tasks', 'portal_reports', 
              'portal_assignments', 'portal_events', 'portal_attendance', 
              'portal_mmi', 'portal_timetables', 'portal_access_logs',
              'portal_students', 'portal_teachers', 'portal_settings'
          ];
          
          for (const colName of collectionsToReset) {
              /* Factory reset handled by backend */
          }
          alert("Sistem berjaya di-reset ke tetapan asal!");
          window.location.reload();
      } catch (error) {
          console.error("Reset failed: ", error);
          alert("Gagal melakukan reset: " + error.message);
      } finally {
          setIsResetting(false);
      }
  };

  // Utama hanya tunjuk guru ganti yang sudah ditugaskan, walaupun belum terima/tolak.
  const assignedTodayRelief = todayRelief.filter(r =>
      r.relief_teacher_name && ['assigned', 'accepted', 'completed', 'declined'].includes(r.status)
  );

  const reliefStatusLabel = (status) => {
      if (status === 'assigned') return 'Belum Terima/Tolak';
      if (status === 'declined') return 'Ditolak';
      if (status === 'completed') return 'Selesai';
      return status || '-';
  };

  // Accept/decline relief dari dashboard (untuk tugasan sendiri)
  const dashAcceptRelief = async (id) => {
      try { await api(`/relief/${id}/accept`, { method: 'PUT' }); setTodayRelief(prev => prev.map(r => r.id === id ? { ...r, status: 'completed' } : r)); }
      catch (e) { alert('Ralat: ' + e.message); }
  };
  const dashDeclineRelief = async (id) => {
      if (!confirm('Tolak tugasan guru ganti ini?')) return;
      try { await api(`/relief/${id}/decline`, { method: 'PUT' }); setTodayRelief(prev => prev.filter(r => r.id !== id)); }
      catch (e) { alert('Ralat: ' + e.message); }
  };

  const reliefStatusClass = (status) => {
      if (status === 'accepted') return 'bg-emerald-100 text-emerald-700';
      if (status === 'assigned') return 'bg-blue-100 text-blue-700';
      if (status === 'declined') return 'bg-red-100 text-red-700';
      if (status === 'completed') return 'bg-slate-100 text-slate-500';
      return 'bg-amber-100 text-amber-700';
  };

  return (
    <div className="space-y-6 animate-fade-in">
       {/* --- TICKER / MARQUEE ACARA TERKINI (UPDATED: CLICKABLE & ANIMATION FIX) --- */}
       {upcomingEvents.length > 0 && (
           <div 
               onClick={() => setView('takwim')} 
               className="bg-emerald-600 text-white p-3 rounded-xl shadow-md overflow-hidden relative flex items-center border border-emerald-700 cursor-pointer hover:bg-emerald-700 transition-colors group mb-6"
               title="Klik untuk lihat Takwim penuh"
           >
               <div className="bg-emerald-800 px-3 py-1.5 text-xs font-bold rounded uppercase mr-4 z-10 shrink-0 flex items-center gap-2 shadow-sm group-hover:bg-emerald-900 transition-colors">
                   <Megaphone size={14} className="animate-pulse"/> Info Terkini
               </div>
               <div className="flex-1 overflow-hidden relative h-6 mask-image-linear-gradient">
                   <div className="animate-marquee whitespace-nowrap absolute top-0 left-0 flex items-center h-full w-max">
                       {upcomingEvents.map((e, idx) => (
                           <span key={idx} className="mx-8 font-medium text-sm flex items-center gap-2">
                               <span className="text-emerald-200 font-bold bg-emerald-800/50 px-1.5 rounded text-[10px]">
                                   {new Date(e.start).toLocaleDateString('ms-MY', {day:'2-digit', month:'2-digit'})}
                               </span> 
                               {e.title}
                           </span>
                       ))}
                       {/* Duplicate content for seamless loop effect if needed, but CSS marquee handles simple translation */}
                   </div>
               </div>
               <div className="absolute right-3 z-10">
                   <ChevronRight size={16} className="text-emerald-300 group-hover:text-white group-hover:translate-x-1 transition-all"/>
               </div>
           </div>
       )}

       <div className="bg-white rounded-xl border border-slate-200 p-6 shadow-sm">
           <div className="flex justify-between items-center mb-4">
                <h3 className="font-bold text-slate-800 flex items-center gap-2"><UserCheck className="w-5 h-5 text-emerald-600"/> Status Kehadiran Hari Ini</h3>
                <div className="flex gap-2 items-center">
                    <button onClick={shareAllAttendanceWhatsapp} className="bg-emerald-50 text-emerald-600 px-3 py-1 rounded-lg text-xs font-bold border border-emerald-100 flex items-center gap-1 hover:bg-emerald-100 transition-colors">
                        <Share size={14}/> Kongsi Semua
                    </button>
                    <div className="bg-emerald-50 text-emerald-700 px-3 py-1 rounded-lg text-sm font-bold border border-emerald-100">
                        Peratus Sekolah: {overallPercentage}%
                    </div>
                </div>
           </div>
           
           {loadingAtt ? <div className="flex justify-center p-4"><Loader2 className="w-6 h-6 animate-spin text-slate-400"/></div> : 
           <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-6 gap-3">
               {allClasses.length === 0 ? <p className="col-span-full text-slate-400 italic text-sm text-center">Tiada data kelas.</p> : 
               allClasses.map(className => { 
                   const record = todayAttendance.find(a => a.className === className);
                   const isSubmitted = !!record;
                   let percentage = "0.00";
                   
                   if (isSubmitted && record.stats.total > 0) {
                       percentage = ((record.stats.hadir / record.stats.total) * 100).toFixed(2);
                   }

                   return (
                       <div 
                           key={className} 
                           onClick={() => {
                               if (isSubmitted) {
                                   setViewClass(record);
                               } else {
                                   // Navigate to attendance filler
                                   if (setTargetClass) setTargetClass(className);
                                   setView('attendance');
                               }
                           }}
                           className={`p-3 rounded-lg border flex flex-col items-center justify-center text-center transition-all cursor-pointer hover:shadow-md ${isSubmitted ? 'bg-emerald-100 border-emerald-200 text-emerald-800 shadow-sm' : 'bg-slate-100 border-slate-200 text-slate-400 hover:border-emerald-300 hover:text-emerald-500'}`}
                       >
                           <span className="font-bold text-sm">{className}</span>
                           {isSubmitted ? (
                               <div className="flex flex-col items-center mt-1">
                                   <span className="text-xs font-bold">{percentage}%</span>
                                   <span className="text-[10px] font-medium opacity-80">{record.stats.hadir}/{record.stats.total}</span>
                               </div>
                           ) : (
                               <span className="text-[10px] font-bold uppercase mt-1">Belum</span>
                           )}
                       </div>
                   ); 
               })}
           </div>}
       </div>

       {/* RMT ATTENDANCE SECTION */}
       <div className="bg-white rounded-xl border border-slate-200 p-6 shadow-sm mt-6">
            <div className="flex justify-between items-center mb-4">
                <h3 className="font-bold text-slate-800 flex items-center gap-2"><Utensils className="w-5 h-5 text-orange-600"/> Kehadiran RMT Keseluruhan</h3>
                <div className="bg-orange-50 text-orange-700 px-3 py-1 rounded-lg text-sm font-bold border border-orange-100">
                    Hadir: {rmtPresent} / {rmtTotal} ({rmtPercent}%)
                </div>
            </div>
            
            {rmtAbsentList.length > 0 ? (
                <div className="overflow-x-auto">
                     <h4 className="font-bold text-sm text-red-600 mb-2 border-b border-red-100 pb-1">Senarai Murid RMT Tidak Hadir ({rmtAbsentList.length})</h4>
                     <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-2">
                        {rmtAbsentList.map((s, i) => (
                            <div key={i} className="flex items-center gap-2 text-sm text-slate-700 bg-red-50 p-2 rounded border border-red-100">
                                <span className="font-bold text-red-500">{i+1}.</span>
                                <div>
                                    <span className="font-bold block">{s.name}</span>
                                    <span className="text-xs text-slate-500">{s.class}</span>
                                </div>
                            </div>
                        ))}
                     </div>
                </div>
            ) : (
                <p className="text-emerald-600 text-sm italic font-medium bg-emerald-50 p-3 rounded border border-emerald-100">Semua murid RMT hadir (berdasarkan data kehadiran kelas yang dihantar).</p>
            )}
        </div>

       {/* CLASS DETAILS MODAL */}
       {viewClass && (
           <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 animate-fade-in">
               <div className="bg-white p-6 rounded-xl w-80 md:w-96 shadow-2xl max-h-[80vh] flex flex-col">
                   <div className="flex justify-between items-center mb-4 border-b pb-2">
                       <h3 className="font-bold text-lg text-slate-800">{viewClass.className}</h3>
                       <button onClick={() => setViewClass(null)} className="text-slate-400 hover:text-red-500"><X size={20}/></button>
                   </div>
                   <div className="mb-4 text-center">
                       <div className="text-3xl font-bold text-emerald-600 mb-1">{Math.round((viewClass.stats.hadir / viewClass.stats.total) * 100)}%</div>
                       <div className="text-xs text-slate-500 font-bold uppercase tracking-wider">Kehadiran</div>
                   </div>
                   <div className="flex-1 overflow-y-auto">
                       <h4 className="font-bold text-sm text-red-600 mb-2 border-b border-red-100 pb-1">Senarai Tidak Hadir ({viewClass.stats.tidakHadir})</h4>
                       {getAbsentNames(viewClass).length > 0 ? (
                           <ul className="space-y-2">
                               {getAbsentNames(viewClass).map((name, idx) => (
                                   <li key={idx} className="text-sm text-slate-700 flex items-start gap-2">
                                       <span className="text-red-400 font-bold">•</span> {name}
                                   </li>
                               ))}
                           </ul>
                       ) : (
                           <p className="text-sm text-emerald-600 italic">Semua hadir / Tiada yang tidak hadir.</p>
                       )}
                   </div>
                   <div className="mt-6 flex flex-col gap-2">
                       <button onClick={shareDashboardWhatsapp} className="bg-emerald-500 text-white w-full py-2 rounded-lg font-bold shadow hover:bg-emerald-600 transition-colors flex items-center justify-center gap-2">
                           <Share size={18} /> Kongsi ke WhatsApp
                       </button>
                       <button onClick={() => setViewClass(null)} className="w-full bg-slate-100 text-slate-600 py-2 rounded-lg font-bold hover:bg-slate-200">Tutup</button>
                   </div>
               </div>
           </div>
       )}

       {/* GURU GANTI HARI INI */}
       <div className="bg-white rounded-xl border border-slate-200 p-6">
           <div className="flex justify-between items-center mb-4">
               <div>
                   <h3 className="font-bold text-slate-800 flex items-center gap-2"><UserCheck className="w-5 h-5 text-emerald-600"/> Guru Ganti Hari Ini</h3>
                   <p className="text-xs text-slate-400 mt-1">Memaparkan guru ganti yang sudah ditugaskan. Status menunjukkan terimaan guru.</p>
               </div>
               <button onClick={() => setView('relief')} className="text-xs text-emerald-600 hover:underline">Lihat Semua</button>
           </div>
           {loadingRelief ? <div className="flex justify-center p-4"><Loader2 className="w-6 h-6 animate-spin text-slate-400"/></div> :
            assignedTodayRelief.length === 0 ? <p className="text-slate-400 text-sm">Belum ada guru ganti yang ditugaskan hari ini.</p> :
            <div className="overflow-x-auto">
                <table className="w-full text-sm">
                    <thead>
                        <tr className="border-b border-slate-100 text-left text-xs text-slate-500 uppercase font-bold">
                            <th className="py-2 pr-3">Guru Tidak Hadir</th>
                            <th className="py-2 pr-3">Slot</th>
                            <th className="py-2 pr-3">Subjek</th>
                            <th className="py-2 pr-3">Kelas</th>
                            <th className="py-2 pr-3">Guru Ganti</th>
                            <th className="py-2">Status Terimaan</th>
                        </tr>
                    </thead>
                    <tbody>
                        {assignedTodayRelief.map(r => (
                            <tr key={r.id} className="border-b border-slate-50 hover:bg-slate-50">
                                <td className="py-2 pr-3 font-medium text-slate-700">{r.teacher_name_absent || '-'}</td>
                                <td className="py-2 pr-3 text-slate-600">{r.time_slot || '-'}</td>
                                <td className="py-2 pr-3 text-slate-600">{r.subject || '-'}</td>
                                <td className="py-2 pr-3 text-slate-600">{r.class_name || '-'}</td>
                                <td className="py-2 pr-3 font-bold text-slate-800">{r.relief_teacher_name || '-'}</td>
                                <td className="py-2">
                                    {r.relief_teacher_uid === userData.uid && r.status === 'assigned' ? (
                                        <div className="flex gap-1">
                                            <button onClick={() => dashAcceptRelief(r.id)} className="text-[10px] bg-emerald-600 text-white px-2 py-1 rounded font-bold hover:bg-emerald-700">Terima</button>
                                            <button onClick={() => dashDeclineRelief(r.id)} className="text-[10px] bg-red-50 text-red-600 px-2 py-1 rounded font-bold border border-red-200 hover:bg-red-100">Tolak</button>
                                        </div>
                                    ) : (
                                        <span className={`text-[10px] font-bold px-2 py-1 rounded ${reliefStatusClass(r.status)}`}>
                                            {reliefStatusLabel(r.status)}
                                        </span>
                                    )}
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
           }
       </div>

       {/* AKTIVITI TERKINI (Recent Activity Feed) */}
       <div className="bg-white rounded-xl border border-slate-200 p-6">
           <div className="flex justify-between items-center mb-4">
               <div>
                   <h3 className="font-bold text-slate-800 flex items-center gap-2"><Activity className="w-5 h-5 text-emerald-600"/> Aktiviti Terkini</h3>
                   <p className="text-xs text-slate-400 mt-1">5 log masuk guru terkini.</p>
               </div>
               {role === 'admin' && <button onClick={() => setView('logs')} className="text-xs text-emerald-600 hover:underline">Lihat Semua</button>}
           </div>
           {loadingLogs ? (
               <div className="flex justify-center p-4"><Loader2 className="w-6 h-6 animate-spin text-slate-400"/></div>
           ) : recentLogs.length === 0 ? (
               <p className="text-slate-400 text-sm">Tiada rekod aktiviti.</p>
           ) : (
               <div className="relative">
                   <div className="absolute left-[7px] top-2 bottom-2 w-0.5 bg-slate-100"></div>
                   <div className="space-y-4">
                       {recentLogs.map((log, idx) => (
                           <div key={idx} className="relative flex items-start gap-3 pl-6">
                               <div className={`absolute left-[3px] top-1 w-3.5 h-3.5 rounded-full border-2 border-white shadow-sm ${idx === 0 ? 'bg-emerald-500' : 'bg-slate-300'}`}></div>
                               <div className="flex-1 min-w-0">
                                   <div className="flex items-center gap-2 flex-wrap">
                                       <span className="text-sm font-bold text-slate-800">{log.name || 'Tidak diketahui'}</span>
                                       <span className="uppercase text-[9px] font-bold text-white bg-emerald-600 px-1.5 py-0.5 rounded">{log.role || '-'}</span>
                                   </div>
                                   <p className="text-xs text-slate-400 mt-0.5 flex items-center gap-1.5">
                                       <Clock className="w-3 h-3"/>
                                       {log.timestamp ? `${formatDate(log.timestamp)} ${new Date(log.timestamp).toLocaleTimeString('ms-MY', { hour: '2-digit', minute: '2-digit' })}` : '-'}
                                   </p>
                               </div>
                           </div>
                       ))}
                   </div>
               </div>
           )}
       </div>

    </div>
  );
}

function SettingsManager() {
    const [config, setConfig] = useState({ botToken: '', chatId: '', topicId: '' });
    const [reliefConfig, setReliefConfig] = useState({ botToken: '', chatId: '', topicId: '' });
    const [loading, setLoading] = useState(true);
    const [backupLoading, setBackupLoading] = useState(false);

    useEffect(() => {
        const fetchSettings = async () => {
            try {
                const snap = await api('/settings/telegram_config');
                if (snap && snap.botToken !== undefined) setConfig(snap);
                const snap2 = await api('/settings/telegram_relief_config');
                if (snap2 && snap2.botToken !== undefined) setReliefConfig(snap2);
            } catch (e) { console.error(e); }
            setLoading(false);
        };
        fetchSettings();
    }, []);

    const save = async (cfg, key, label) => {
        if (!cfg.botToken || !cfg.chatId) return alert("Sila isi Token dan Chat ID untuk " + label + ".");
        try {
            await api('/settings/' + key, { method: 'PUT', body: JSON.stringify(cfg) });
            alert("Tetapan " + label + " berjaya disimpan!");
        } catch (e) {
            alert("Ralat menyimpan: " + e.message);
        }
    };

    const testMessage = async (cfg, label) => {
        if (!cfg.botToken || !cfg.chatId) return alert("Sila simpan tetapan " + label + " dahulu.");
        try {
            const payload = { chat_id: cfg.chatId, text: `✅ Ujian Sambungan SkolaHub (${label}) Berjaya!`, parse_mode: 'Markdown' };
            if (cfg.topicId) payload.message_thread_id = cfg.topicId;

            const res = await fetch(`https://api.telegram.org/bot${cfg.botToken}/sendMessage`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(payload)
            });
            const data = await res.json();
            if (data.ok) alert("Mesej ujian " + label + " berjaya dihantar! Sila semak Telegram anda.");
            else alert("Gagal menghantar: " + data.description);
        } catch (e) {
            alert("Ralat sambungan: " + e.message);
        }
    };

    // FUNGSI BACKUP DATA (JSON)
    const handleBackup = async () => {
        if(!confirm("Adakah anda ingin memuat turun sandaran (backup) penuh pangkalan data? Fail ini mengandungi data murid, guru, kehadiran, dan laporan.")) return;
        setBackupLoading(true);
        try {
            const collections = ['portal_students', 'portal_teachers', 'portal_attendance', 'portal_reports', 'portal_mmi', 'portal_tasks', 'portal_events', 'portal_apps'];
            const backupData = { timestamp: new Date().toISOString(), system: "SkolaHub Backup", data: {} };

            for (const colName of collections) {
                const snap = await api('/' + colName.replace('portal_', ''));
                backupData.data[colName] = snap;
            }

            const blob = new Blob([JSON.stringify(backupData, null, 2)], { type: 'application/json' });
            const url = URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = `SKOLAHUB_BACKUP_${getTodayDate()}.json`;
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
            alert("Backup berjaya dimuat turun!");
        } catch (e) {
            console.error(e);
            alert("Gagal membuat backup: " + e.message);
        }
        setBackupLoading(false);
    };

    if (loading) return <div className="flex justify-center p-10"><Loader2 className="animate-spin"/></div>;

    const renderTelegramForm = (cfg, setCfg, key, label, icon, iconColor) => (
        <div className="bg-white p-6 rounded-xl border border-slate-200 shadow-sm">
            <div className="mb-6 bg-blue-50 p-4 rounded-lg border border-blue-100 text-sm text-slate-700">
                <h4 className="font-bold text-blue-700 mb-2 flex items-center gap-2"><Info size={16}/> Panduan Setup:</h4>
                <ol className="list-decimal pl-4 space-y-1">
                    <li>Cipta bot baru di Telegram melalui <b>@BotFather</b> dan dapatkan <b>Bot Token</b>.</li>
                    <li>Masukkan bot ke dalam Group atau Channel Telegram yang dikehendaki.</li>
                    <li>Jadikan bot sebagai <b>Admin</b> dalam group tersebut.</li>
                    <li>Dapatkan <b>Chat ID</b> group tersebut (boleh guna bot seperti @userinfobot atau @getidsbot).</li>
                    <li>Jika menggunakan <b>Topics</b>, masukkan ID Topik (biasanya nombor seperti 2, 42).</li>
                </ol>
            </div>

            <div className="space-y-4">
                <div>
                    <label className="lbl">Telegram Bot Token</label>
                    <input
                        className="inp font-mono text-xs"
                        placeholder="Contoh: 123456789:ABCdefGHIjklMNOpqrsTUVwxyz"
                        value={cfg.botToken}
                        onChange={e => setCfg({...cfg, botToken: e.target.value})}
                    />
                </div>
                <div>
                    <label className="lbl">Chat ID (Group / Channel)</label>
                    <input
                        className="inp font-mono text-xs"
                        placeholder="Contoh: -100123456789 (Mesti ada tanda negatif untuk Group)"
                        value={cfg.chatId}
                        onChange={e => setCfg({...cfg, chatId: e.target.value})}
                    />
                </div>
                <div>
                    <label className="lbl">Topic ID (Pilihan - Untuk Group Bertopik)</label>
                    <input
                        className="inp font-mono text-xs"
                        placeholder="Contoh: 42 (Biarkan kosong jika tiada)"
                        value={cfg.topicId || ''}
                        onChange={e => setCfg({...cfg, topicId: e.target.value})}
                    />
                </div>
            </div>

            <div className="flex gap-3 mt-8 pt-4 border-t border-slate-100">
                <button onClick={() => testMessage(cfg, label)} className="flex-1 bg-slate-100 text-slate-700 py-2.5 rounded-lg font-bold hover:bg-slate-200 flex justify-center items-center gap-2">
                    <Megaphone size={16}/> Uji Hantar Mesej
                </button>
                <button onClick={() => save(cfg, key, label)} className="flex-[2] bg-emerald-600 text-white py-2.5 rounded-lg font-bold shadow-md hover:bg-emerald-700 flex justify-center items-center gap-2">
                    <Save size={16}/> Simpan Tetapan
                </button>
            </div>
        </div>
    );

    return (
        <div className="max-w-2xl mx-auto space-y-8 animate-fade-in">
            {/* SEKSYEN TELEGRAM - KEHADIRAN */}
            <div>
                <h2 className="text-2xl font-bold text-slate-800 flex items-center gap-2 mb-4"><Settings className="w-6 h-6 text-emerald-600"/> Tetapan Notifikasi Telegram</h2>
                <div className="mb-3">
                    <span className="inline-flex items-center gap-2 text-sm font-bold text-emerald-700 bg-emerald-50 px-3 py-1.5 rounded-lg border border-emerald-100">
                        <UserCheck size={16} className="text-emerald-600"/> Kehadiran
                    </span>
                </div>
                {renderTelegramForm(config, setConfig, 'telegram_config', 'Kehadiran', UserCheck, 'text-emerald-600')}
            </div>

            {/* SEKSYEN TELEGRAM - GURU GANTI */}
            <div>
                <div className="mb-3">
                    <span className="inline-flex items-center gap-2 text-sm font-bold text-emerald-700 bg-emerald-50 px-3 py-1.5 rounded-lg border border-emerald-100">
                        <UserCheck size={16} className="text-emerald-600"/> Guru Ganti
                    </span>
                    <p className="text-xs text-slate-500 mt-2 ml-1">Notifikasi akan dihantar ke Telegram sekali bila pentadbir tekan Hantar Pilihan, dan apabila guru terima atau tolak tugasan.</p>
                </div>
                {renderTelegramForm(reliefConfig, setReliefConfig, 'telegram_relief_config', 'Guru Ganti', UserCheck, 'text-emerald-600')}
            </div>

            {/* SEKSYEN BACKUP DATA */}
            <div>
                <h2 className="text-2xl font-bold text-slate-800 flex items-center gap-2 mb-4"><ShieldCheck className="w-6 h-6 text-emerald-600"/> Pengurusan Data & Backup</h2>
                <div className="bg-white p-6 rounded-xl border border-slate-200 shadow-sm">
                    <div className="bg-emerald-50 p-4 rounded-lg border border-emerald-100 text-sm text-slate-700 mb-4">
                        <p>Sila lakukan sandaran data (backup) sekurang-kurangnya <b>sebulan sekali</b> untuk keselamatan data.</p>
                    </div>
                    <button
                        onClick={handleBackup}
                        disabled={backupLoading}
                        className={`w-full bg-emerald-600 text-white py-3 rounded-lg font-bold shadow-md flex justify-center items-center gap-2 transition-all ${backupLoading ? 'opacity-75 cursor-not-allowed' : 'hover:bg-emerald-700'}`}
                    >
                        {backupLoading ? <><Loader2 className="animate-spin w-5 h-5"/> Sedang Memproses Data...</> : <><Download size={18}/> Muat Turun Data Lengkap (JSON)</>}
                    </button>
                </div>
            </div>
        </div>
    );
}

// --- KEBERADAAN MANAGER (Guru isi hari tak hadir) ---

function KeberadaanManager({ userData, teachers }) {
    const [absences, setAbsences] = useState([]);
    const [loading, setLoading] = useState(true);
    const [showForm, setShowForm] = useState(false);
    const [formData, setFormData] = useState({ teacher_uid: '', date: getTodayDate(), reason: '', partialType: 'none', partialTime: '11:00' });
    const [filterFrom, setFilterFrom] = useState('');
    const [filterTo, setFilterTo] = useState('');

    const loadAbsences = async () => {
        try {
            const params = new URLSearchParams();
            if (filterFrom) params.append('from_date', filterFrom);
            if (filterTo) params.append('to_date', filterTo);
            if (!filterFrom && !filterTo) params.append('limit', '50'); // default: last 50
            const data = await api('/absences?' + params.toString());
            setAbsences(data);
        } catch (e) { console.error(e); }
        setLoading(false);
    };

    useEffect(() => { loadAbsences(); }, [filterFrom, filterTo]);

    const submitAbsence = async () => {
        if (!formData.teacher_uid) return alert('Sila pilih guru.');
        if (!formData.date) return alert('Sila pilih tarikh.');
        try {
            const resp = await api('/absences', {
                method: 'POST',
                body: JSON.stringify({
                    teacher_uid: formData.teacher_uid,
                    date: formData.date,
                    reason: formData.reason,
                    partial: formData.partialType !== 'none',
                    partial_type: formData.partialType !== 'none' ? formData.partialType : null,
                    partial_time: formData.partialType !== 'none' ? formData.partialTime : null
                })
            });
            if (resp.slotsGenerated > 0) {
                alert(`Berjaya! ${resp.slotsGenerated} slot guru ganti dijana. Sila pilih guru ganti di tab "Guru Ganti".`);
            } else {
                alert('Berjaya direkodkan, tetapi tiada slot kelas pada hari tersebut (mungkin hujung minggu/cuti). Tiada guru ganti perlu ditugaskan.');
            }
            setShowForm(false);
            setFormData({ teacher_uid: '', date: getTodayDate(), reason: '', partialType: 'none', partialTime: '11:00' });
            loadAbsences();
        } catch (e) {
            alert('Ralat: ' + e.message);
        }
    };

    const deleteAbsence = async (id) => {
        if (!confirm('Padam rekod keberadaan ini?')) return;
        try {
            await api(`/absences/${id}`, { method: 'DELETE' });
            loadAbsences();
        } catch (e) { alert('Ralat: ' + e.message); }
    };

    const allAbsences = absences;

    return (
        <div className="space-y-6 animate-fade-in">
            <div className="flex justify-between items-center">
                <h2 className="text-2xl font-bold text-slate-800 flex items-center gap-2">
                    <CalendarCheck className="w-6 h-6 text-emerald-600"/> Keberadaan
                </h2>
                <button onClick={() => setShowForm(!showForm)} className="bg-emerald-600 text-white px-4 py-2 rounded-lg font-bold text-sm hover:bg-emerald-700 flex items-center gap-2">
                    <Plus className="w-4 h-4"/> Tambah Tidak Hadir
                </button>
            </div>

            {showForm && (
                <div className="bg-white p-6 rounded-xl border border-slate-200 shadow-sm">
                    <h3 className="font-bold text-slate-800 mb-4">Rekod Guru Tidak Hadir</h3>
                    <div className="space-y-4">
                        <div>
                            <label className="lbl">Pilih Guru</label>
                            <select className="inp" value={formData.teacher_uid} onChange={e => setFormData({...formData, teacher_uid: e.target.value})}>
                                <option value="">-- Pilih Guru --</option>
                                {teachers.filter(t => t.uid && t.role !== 'akp').map(t => <option key={t.id} value={t.uid}>{t.name}</option>)}
                            </select>
                        </div>
                        <div>
                            <label className="lbl">Tarikh Tidak Hadir</label>
                            <input type="date" className="inp" value={formData.date} onChange={e => setFormData({...formData, date: e.target.value})} />
                        </div>
                        <div>
                            <label className="lbl">Sebab (Pilihan)</label>
                            <input className="inp" placeholder="Cth: MC, Kursus, Cuti..." value={formData.reason} onChange={e => setFormData({...formData, reason: e.target.value})} />
                        </div>
                        <div className="bg-slate-50 p-3 rounded-lg border border-slate-200">
                            <label className="text-sm font-bold text-slate-700 block mb-2">Jenis Ketidakhadiran</label>
                            <div className="flex flex-wrap gap-2">
                                <label className={`flex items-center gap-1.5 cursor-pointer px-3 py-1.5 rounded-lg text-xs font-bold border-2 transition ${formData.partialType === 'none' ? 'border-emerald-600 bg-emerald-50 text-emerald-700' : 'border-slate-200 bg-white text-slate-500'}`}>
                                    <input type="radio" name="partialType" className="hidden" checked={formData.partialType === 'none'} onChange={() => setFormData({...formData, partialType: 'none'})} />
                                    Penuh Hari
                                </label>
                                <label className={`flex items-center gap-1.5 cursor-pointer px-3 py-1.5 rounded-lg text-xs font-bold border-2 transition ${formData.partialType === 'late_arrival' ? 'border-orange-600 bg-orange-50 text-orange-700' : 'border-slate-200 bg-white text-slate-500'}`}>
                                    <input type="radio" name="partialType" className="hidden" checked={formData.partialType === 'late_arrival'} onChange={() => setFormData({...formData, partialType: 'late_arrival'})} />
                                    Masuk Lewat
                                </label>
                                <label className={`flex items-center gap-1.5 cursor-pointer px-3 py-1.5 rounded-lg text-xs font-bold border-2 transition ${formData.partialType === 'early_leave' ? 'border-orange-600 bg-orange-50 text-orange-700' : 'border-slate-200 bg-white text-slate-500'}`}>
                                    <input type="radio" name="partialType" className="hidden" checked={formData.partialType === 'early_leave'} onChange={() => setFormData({...formData, partialType: 'early_leave'})} />
                                    Keluar Awal
                                </label>
                            </div>
                            {formData.partialType !== 'none' && (
                                <div className="mt-3">
                                    <label className="lbl">{formData.partialType === 'early_leave' ? 'Keluar Selepas Pukul' : 'Tiba Di Sekolah Pukul'}</label>
                                    <input type="time" className="inp" value={formData.partialTime} onChange={e => setFormData({...formData, partialTime: e.target.value})} />
                                </div>
                            )}
                        </div>
                        <div className="bg-blue-50 p-3 rounded-lg text-xs text-slate-600 border border-blue-100">
                            <Info className="w-4 h-4 inline mr-1 text-blue-500"/>
                            {formData.partialType === 'none'
                                ? 'Sistem akan jana cadangan slot guru ganti berdasarkan jadual waktu guru tersebut. Pentadbir perlu pilih guru ganti di tab Guru Ganti.'
                                : formData.partialType === 'early_leave'
                                ? `Sistem akan jana guru ganti untuk slot selepas ${formData.partialTime} sahaja. Slot sebelum itu cikgu masih mengajar.`
                                : `Sistem akan jana guru ganti untuk slot sebelum ${formData.partialTime} sahaja. Slot selepas itu cikgu sudah sampai dan akan mengajar.`}
                        </div>
                        <div className="flex gap-2">
                            <button onClick={() => setShowForm(false)} className="px-4 py-2 rounded bg-slate-100 font-bold text-slate-600 text-sm">Batal</button>
                            <button onClick={submitAbsence} className="px-4 py-2 rounded bg-emerald-600 text-white font-bold text-sm flex-1">Sahkan Tidak Hadir</button>
                        </div>
                    </div>
                </div>
            )}

            {/* All Absences */}
            <div className="bg-white rounded-xl border border-slate-200 p-6">
                <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-3 mb-4">
                    <h3 className="font-bold text-slate-800">Senarai Guru Tidak Hadir</h3>
                    <div className="flex items-center gap-2 text-xs">
                        <input type="date" className="inp py-1.5 px-2 text-xs w-36" value={filterFrom} onChange={e => setFilterFrom(e.target.value)} placeholder="Dari" />
                        <span className="text-slate-400">sampai</span>
                        <input type="date" className="inp py-1.5 px-2 text-xs w-36" value={filterTo} onChange={e => setFilterTo(e.target.value)} placeholder="Hingga" />
                        {(filterFrom || filterTo) && (
                            <button onClick={() => { setFilterFrom(''); setFilterTo(''); }} className="text-slate-400 hover:text-slate-600 text-xs px-2">× Kosong</button>
                        )}
                    </div>
                </div>
                {loading ? (
                    <div className="flex justify-center p-4"><Loader2 className="animate-spin w-6 h-6 text-emerald-600"/></div>
                ) : allAbsences.length === 0 ? (
                    <p className="text-slate-400 text-sm italic">Tiada rekod tidak hadir.</p>
                ) : (
                    <div className="overflow-x-auto">
                        <table className="w-full text-sm">
                            <thead className="bg-slate-50 border-b">
                                <tr>
                                    <th className="p-3 text-left font-bold text-slate-600">Guru</th>
                                    <th className="p-3 text-left font-bold text-slate-600">Tarikh</th>
                                    <th className="p-3 text-left font-bold text-slate-600">Sebab</th>
                                    <th className="p-3 text-left font-bold text-slate-600">Status</th>
                                    <th className="p-3 text-left font-bold text-slate-600"></th>
                                </tr>
                            </thead>
                            <tbody className="divide-y divide-slate-100">
                                {allAbsences.map(a => (
                                    <tr key={a.id} className="hover:bg-slate-50">
                                        <td className="p-3 font-bold text-slate-800">
                                            {a.teacher_name || 'Tidak diketahui'}
                                            {a.partial == 1 && (
                                                <span className="ml-2 text-xs font-bold px-2 py-0.5 rounded bg-orange-100 text-orange-700">
                                                    {a.partial_type === 'late_arrival' ? 'Masuk Lewat' : 'Keluar Awal'} {a.partial_time ? `(${a.partial_time})` : ''}
                                                </span>
                                            )}
                                        </td>
                                        <td className="p-3 text-slate-600">{formatDate(a.date)}</td>
                                        <td className="p-3 text-slate-500">{a.reason || '-'}</td>
                                        <td className="p-3">
                                            <span className={`text-xs font-bold px-2 py-0.5 rounded ${
                                                a.relief_status === 'completed' ? 'bg-emerald-100 text-emerald-700' :
                                                a.relief_status === 'pending' ? 'bg-amber-100 text-amber-700' :
                                                'bg-amber-100 text-amber-700'
                                            }`}>
                                                {a.relief_status === 'completed' ? 'Selesai' : 
                                                 a.relief_total > 0 ? `${a.relief_completed}/${a.relief_total} Ganti` : 'Menunggu Ganti'}
                                            </span>
                                        </td>
                                        <td className="p-3">
                                            <button onClick={() => deleteAbsence(a.id)} className="text-red-500 hover:text-red-700 text-xs font-bold">Padam</button>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                )}
            </div>
        </div>
    );
}

// --- GURU RELIEF VIEW (Guru nampak & terima/tolak tugasan ganti) ---

function GuruReliefView({ userData }) {
    const [reliefList, setReliefList] = useState([]);
    const [loading, setLoading] = useState(true);
    const [filterDate, setFilterDate] = useState(getTodayDate());

    const loadRelief = async () => {
        setLoading(true);
        try {
            const data = await api(`/relief?date=${filterDate}`);
            // Hanya tunjuk yang diassign ke guru ini
            const mine = data.filter(r => r.relief_teacher_uid === userData.uid);
            setReliefList(mine);
        } catch (e) { console.error(e); }
        setLoading(false);
    };

    useEffect(() => { loadRelief(); }, [filterDate]);

    const acceptRelief = async (id) => {
        try {
            await api(`/relief/${id}/accept`, { method: 'PUT' });
            loadRelief();
        } catch (e) { alert('Ralat: ' + e.message); }
    };

    const declineRelief = async (id) => {
        if (!confirm('Tolak tugasan guru ganti ini?')) return;
        try {
            await api(`/relief/${id}/decline`, { method: 'PUT' });
            loadRelief();
        } catch (e) { alert('Ralat: ' + e.message); }
    };

    const statusBadge = (status) => {
        const styles = {
            assigned: 'bg-blue-100 text-blue-700',
            accepted: 'bg-emerald-100 text-emerald-700',
            completed: 'bg-slate-100 text-slate-600',
            declined: 'bg-red-100 text-red-700',
        };
        const labels = { assigned: 'Menunggu Persetujuan', accepted: 'Diterima', completed: 'Selesai', declined: 'Ditolak' };
        return <span className={`text-xs font-bold px-2 py-0.5 rounded ${styles[status] || styles.assigned}`}>{labels[status] || status}</span>;
    };

    return (
        <div className="space-y-6 animate-fade-in">
            <div className="flex justify-between items-center">
                <h2 className="text-2xl font-bold text-slate-800 flex items-center gap-2">
                    <UserCheck className="w-6 h-6 text-emerald-600"/> Guru Ganti
                </h2>
            </div>

            <div className="bg-white p-4 rounded-xl border border-slate-200 flex gap-4 items-end">
                <div className="flex-1">
                    <label className="lbl">Tarikh</label>
                    <input type="date" className="inp" value={filterDate} onChange={e => setFilterDate(e.target.value)} />
                </div>
                <button onClick={loadRelief} className="bg-slate-100 px-4 py-2.5 rounded-lg font-bold text-sm text-slate-600 hover:bg-slate-200 flex items-center gap-2">
                    <RefreshCw className="w-4 h-4"/> Muat Semula
                </button>
            </div>

            {loading ? (
                <div className="flex justify-center p-10"><Loader2 className="animate-spin w-8 h-8 text-emerald-600"/></div>
            ) : reliefList.length === 0 ? (
                <div className="bg-white p-10 rounded-xl border border-slate-200 text-center">
                    <CalendarCheck className="w-12 h-12 mx-auto text-slate-300 mb-3"/>
                    <p className="text-slate-400 font-bold">Tiada tugasan guru ganti untuk tarikh ini.</p>
                </div>
            ) : (
                <div className="space-y-3">
                    {reliefList.map(slot => (
                        <div key={slot.id} className="bg-white p-4 rounded-xl border border-slate-200">
                            <div className="flex items-center justify-between">
                                <div className="flex items-center gap-3">
                                    <div className="w-10 h-10 rounded-full bg-emerald-100 flex items-center justify-center">
                                        <Clock className="w-5 h-5 text-emerald-600"/>
                                    </div>
                                    <div>
                                        <span className="text-xs font-bold text-slate-500">{slot.time_slot}</span>
                                        <p className="font-bold text-slate-800 text-sm">{slot.subject} {slot.class_name && `— ${slot.class_name}`}</p>
                                        <p className="text-xs text-slate-400">Guru Asal: {slot.teacher_name_absent}</p>
                                    </div>
                                </div>
                                <div className="flex items-center gap-2">
                                    {statusBadge(slot.status)}
                                    {slot.status === 'assigned' && (
                                        <>
                                            <button onClick={() => acceptRelief(slot.id)} className="text-xs bg-emerald-600 text-white px-3 py-1.5 rounded font-bold hover:bg-emerald-700">Terima</button>
                                            <button onClick={() => declineRelief(slot.id)} className="text-xs bg-red-50 text-red-600 px-3 py-1.5 rounded font-bold border border-red-200 hover:bg-red-100">Tolak</button>
                                        </>
                                    )}
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
}

// --- RELIEF MANAGER (Pentadbir urus guru ganti) ---

function ReliefManager({ userData, teachers }) {
    const [reliefList, setReliefList] = useState([]);
    const [loading, setLoading] = useState(true);
    const [filterDate, setFilterDate] = useState(getTodayDate());
    const [filterStatus, setFilterStatus] = useState('');
    const [filterTeacher, setFilterTeacher] = useState('');
    const [freeTeachers, setFreeTeachers] = useState({});
    const [expandedRow, setExpandedRow] = useState(null);
    const [pendingAssignments, setPendingAssignments] = useState({});
    const [submittingAssignments, setSubmittingAssignments] = useState(false);

    const loadRelief = async () => {
        setLoading(true);
        try {
            let url = '/relief?';
            if (filterDate) url += `date=${filterDate}&`;
            if (filterStatus) url += `status=${filterStatus}`;
            const data = await api(url);
            setReliefList(data);
            setPendingAssignments({});
        } catch (e) { console.error(e); }
        setLoading(false);
    };

    useEffect(() => { loadRelief(); }, [filterDate, filterStatus]);

    const selectPendingRelief = (id, teacher) => {
        setPendingAssignments(prev => ({
            ...prev,
            [id]: { id, relief_teacher_uid: teacher.uid, relief_teacher_name: teacher.name }
        }));
        setExpandedRow(null);
    };

    const clearPendingRelief = (id) => {
        setPendingAssignments(prev => {
            const next = { ...prev };
            delete next[id];
            return next;
        });
    };

    const submitPendingAssignments = async () => {
        const assignments = Object.values(pendingAssignments);
        if (assignments.length === 0) return;
        if (!confirm(`Hantar ${assignments.length} tugasan guru ganti ke Telegram dan notifikasi guru?`)) return;
        setSubmittingAssignments(true);
        try {
            await api('/relief/bulk-assign', {
                method: 'POST',
                body: JSON.stringify({ assignments })
            });
            alert(`${assignments.length} tugasan guru ganti berjaya dihantar.`);
            setPendingAssignments({});
            loadRelief();
        } catch (e) {
            alert('Ralat: ' + e.message);
        }
        setSubmittingAssignments(false);
    };

    const cancelRelief = async (id) => {
        try {
            await api(`/relief/${id}/cancel`, { method: 'PUT' });
            loadRelief();
        } catch (e) { alert('Ralat: ' + e.message); }
    };

    const completeRelief = async (id) => {
        try {
            await api(`/relief/${id}/complete`, { method: 'PUT' });
            loadRelief();
        } catch (e) { alert('Ralat: ' + e.message); }
    };

    const acceptRelief = async (id) => {
        try {
            await api(`/relief/${id}/accept`, { method: 'PUT' });
            loadRelief();
        } catch (e) { alert('Ralat: ' + e.message); }
    };

    const declineRelief = async (id) => {
        if (!confirm('Tolak tugasan guru ganti ini?')) return;
        try {
            await api(`/relief/${id}/decline`, { method: 'PUT' });
            loadRelief();
        } catch (e) { alert('Ralat: ' + e.message); }
    };

    const loadFreeTeachers = async (row) => {
        try {
            const data = await api(`/relief/free-teachers?date=${row.date}&time_slot=${encodeURIComponent(row.time_slot)}&exclude_uid=${row.teacher_uid_absent}`);
            setFreeTeachers(prev => ({ ...prev, [row.id]: data }));
            setExpandedRow(expandedRow === row.id ? null : row.id);
        } catch (e) { console.error(e); }
    };

    const downloadCSV = () => {
        let csv = 'Tarikh,Guru Tidak Hadir,Slot,Subjek,Kelas,Guru Ganti,Status\n';
        reliefList.forEach(r => {
            const row = [
                r.date || '',
                (r.teacher_name_absent || '').replace(/,/g, ';'),
                r.time_slot || '',
                (r.subject || '').replace(/,/g, ';'),
                (r.class_name || '').replace(/,/g, ';'),
                (r.relief_teacher_name || '-').replace(/,/g, ';'),
                r.status || ''
            ];
            csv += row.join(',') + '\n';
        });
        const blob = new Blob([csv], { type: 'text/csv;charset=utf-8' });
        const url = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = `guru_ganti_${filterDate || 'semua'}.csv`;
        a.click();
        URL.revokeObjectURL(url);
    };

    // Group by absent teacher, optionally filter by relief teacher
    const grouped = {};
    reliefList.forEach(r => {
        if (filterTeacher && r.relief_teacher_uid !== filterTeacher) return;
        const key = `${r.teacher_uid_absent}_${r.date}`;
        if (!grouped[key]) grouped[key] = { teacher: r.teacher_name_absent, date: r.date, slots: [] };
        grouped[key].slots.push(r);
    });

    const statusBadge = (status) => {
        const styles = {
            suggested: 'bg-amber-100 text-amber-700',
            assigned: 'bg-blue-100 text-blue-700',
            accepted: 'bg-emerald-100 text-emerald-700',
            completed: 'bg-slate-100 text-slate-600',
            declined: 'bg-red-100 text-red-700',
        };
        const labels = { suggested: 'Cadangan', assigned: 'Ditugaskan', accepted: 'Diterima', completed: 'Selesai', declined: 'Ditolak' };
        return <span className={`text-xs font-bold px-2 py-0.5 rounded ${styles[status] || styles.suggested}`}>{labels[status] || status}</span>;
    };

    const completedCount = reliefList.filter(r => r.status === 'completed').length;
    const assignedCount = reliefList.filter(r => r.status === 'assigned').length;
    const pendingCount = reliefList.filter(r => r.status === 'suggested').length;
    const pendingAssignmentCount = Object.keys(pendingAssignments).length;

    // Tugasan ganti untuk pentadbir sendiri (jika pentadbir juga ada jadual guru ganti)
    const myReliefAssignments = reliefList.filter(r => r.relief_teacher_uid === userData.uid && ['assigned', 'completed'].includes(r.status));

    return (
        <div className="space-y-6 animate-fade-in">
            {/* TUGASAN GANTI SAYA — untuk pentadbir yang juga ada jadual guru ganti */}
            {myReliefAssignments.length > 0 && (
                <div className="bg-amber-50 border-2 border-amber-200 rounded-xl overflow-hidden">
                    <div className="p-4 bg-amber-100/50 border-b border-amber-200">
                        <h3 className="font-bold text-amber-900 flex items-center gap-2">
                            <UserCheck className="w-5 h-5 text-amber-600"/> Tugasan Ganti Saya
                        </h3>
                        <p className="text-xs text-amber-700 mt-0.5">Anda ada {myReliefAssignments.length} tugasan guru ganti untuk tarikh ini.</p>
                    </div>
                    <div className="divide-y divide-amber-100">
                        {myReliefAssignments.map(slot => (
                            <div key={slot.id} className="p-4 flex items-center justify-between">
                                <div className="flex items-center gap-3">
                                    <div className="w-9 h-9 rounded-full bg-amber-200/50 flex items-center justify-center">
                                        <Clock className="w-4 h-4 text-amber-600"/>
                                    </div>
                                    <div>
                                        <span className="text-xs font-bold text-amber-600">{slot.time_slot}</span>
                                        <p className="font-bold text-slate-800 text-sm">{slot.subject} {slot.class_name && `— ${slot.class_name}`}</p>
                                        <p className="text-xs text-slate-500">Guru Asal: {slot.teacher_name_absent}</p>
                                    </div>
                                </div>
                                <div className="flex items-center gap-2">
                                    {slot.status === 'assigned' ? (
                                        <>
                                            <button onClick={() => acceptRelief(slot.id)} className="text-xs bg-emerald-600 text-white px-3 py-1.5 rounded font-bold hover:bg-emerald-700">Terima</button>
                                            <button onClick={() => declineRelief(slot.id)} className="text-xs bg-red-50 text-red-600 px-3 py-1.5 rounded font-bold border border-red-200 hover:bg-red-100">Tolak</button>
                                        </>
                                    ) : slot.status === 'completed' ? (
                                        <span className="text-xs font-bold px-2 py-1 rounded bg-slate-100 text-slate-600">Selesai</span>
                                    ) : null}
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            )}

            <div className="flex justify-between items-center">
                <h2 className="text-2xl font-bold text-slate-800 flex items-center gap-2">
                    <UserCheck className="w-6 h-6 text-emerald-600"/> Guru Ganti
                </h2>
                <div className="flex items-center gap-2">
                    <button onClick={submitPendingAssignments} disabled={pendingAssignmentCount === 0 || submittingAssignments} className="bg-emerald-600 text-white px-4 py-2 rounded-lg text-sm font-bold flex items-center gap-2 hover:bg-emerald-700 disabled:opacity-50 disabled:cursor-not-allowed transition-colors">
                        {submittingAssignments ? <Loader2 className="w-4 h-4 animate-spin"/> : <Send className="w-4 h-4"/>}
                        Hantar Pilihan ({pendingAssignmentCount})
                    </button>
                    <button onClick={downloadCSV} className="bg-emerald-50 text-emerald-600 px-4 py-2 rounded-lg text-sm font-bold border border-emerald-100 flex items-center gap-2 hover:bg-emerald-100 transition-colors">
                        <Download className="w-4 h-4"/> Muat Turun CSV
                    </button>
                </div>
            </div>

            {/* Summary cards */}
            <div className="grid grid-cols-3 gap-3">
                <div className="bg-amber-50 border border-amber-100 rounded-lg p-3 text-center">
                    <p className="text-2xl font-bold text-amber-600">{pendingCount}</p>
                    <p className="text-xs text-amber-700 font-bold">Cadangan</p>
                </div>
                <div className="bg-blue-50 border border-blue-100 rounded-lg p-3 text-center">
                    <p className="text-2xl font-bold text-blue-600">{assignedCount}</p>
                    <p className="text-xs text-blue-700 font-bold">Ditugaskan</p>
                </div>
                <div className="bg-emerald-50 border border-emerald-100 rounded-lg p-3 text-center">
                    <p className="text-2xl font-bold text-emerald-600">{completedCount}</p>
                    <p className="text-xs text-emerald-700 font-bold">Selesai</p>
                </div>
            </div>

            {/* Filters */}
            <div className="bg-white p-4 rounded-xl border border-slate-200 flex gap-4 items-end flex-wrap">
                <div className="flex-1 min-w-[120px]">
                    <label className="lbl">Tarikh</label>
                    <input type="date" className="inp" value={filterDate} onChange={e => setFilterDate(e.target.value)} />
                </div>
                <div className="flex-1 min-w-[120px]">
                    <label className="lbl">Status</label>
                    <select className="inp" value={filterStatus} onChange={e => setFilterStatus(e.target.value)}>
                        <option value="">Semua</option>
                        <option value="suggested">Cadangan</option>
                        <option value="assigned">Ditugaskan</option>
                        <option value="completed">Selesai</option>
                        <option value="declined">Ditolak</option>
                    </select>
                </div>
                <div className="flex-1 min-w-[120px]">
                    <label className="lbl">Guru Ganti</label>
                    <select className="inp" value={filterTeacher} onChange={e => setFilterTeacher(e.target.value)}>
                        <option value="">Semua</option>
                        {teachers.map(t => <option key={t.id} value={t.uid}>{t.name}</option>)}
                    </select>
                </div>
                <button onClick={loadRelief} className="bg-slate-100 px-4 py-2.5 rounded-lg font-bold text-sm text-slate-600 hover:bg-slate-200 flex items-center gap-2">
                    <RefreshCw className="w-4 h-4"/> Muat Semula
                </button>
                {pendingAssignmentCount > 0 && (
                    <button onClick={() => setPendingAssignments({})} className="bg-red-50 text-red-600 px-4 py-2.5 rounded-lg font-bold text-sm border border-red-100 hover:bg-red-100">
                        Kosongkan Pilihan
                    </button>
                )}
            </div>

            {loading ? (
                <div className="flex justify-center p-10"><Loader2 className="animate-spin w-8 h-8 text-emerald-600"/></div>
            ) : Object.keys(grouped).length === 0 ? (
                <div className="bg-white p-10 rounded-xl border border-slate-200 text-center">
                    <CalendarCheck className="w-12 h-12 mx-auto text-slate-300 mb-3"/>
                    <p className="text-slate-400 font-bold">Tiada rekod guru ganti untuk tarikh ini.</p>
                    <p className="text-slate-400 text-xs mt-1">Guru mesti rekod keberadaan di tab "Keberadaan" dahulu.</p>
                </div>
            ) : (
                <div className="space-y-4">
                    {Object.entries(grouped).map(([key, group]) => (
                        <div key={key} className="bg-white rounded-xl border border-slate-200 overflow-hidden">
                            {/* Header */}
                            <div className="p-4 bg-slate-50 border-b flex items-center justify-between">
                                <div className="flex items-center gap-3">
                                    <div className="w-10 h-10 rounded-full bg-emerald-100 flex items-center justify-center">
                                        <User className="w-5 h-5 text-emerald-600"/>
                                    </div>
                                    <div>
                                        <p className="font-bold text-slate-800">{group.teacher}</p>
                                        <p className="text-xs text-slate-500">{formatDate(group.date)} — {group.slots.length} slot perlu ganti</p>
                                    </div>
                                </div>
                            </div>
                            {/* Slots */}
                            <div className="divide-y divide-slate-100">
                                {group.slots.map(slot => (
                                    <div key={slot.id} className="p-4">
                                        <div className="flex items-center justify-between">
                                            <div className="flex items-center gap-3">
                                                <div className="flex flex-col">
                                                    <span className="text-xs font-bold text-slate-500">{slot.time_slot}</span>
                                                    <span className="font-bold text-slate-800 text-sm">{slot.subject} {slot.class_name && `— ${slot.class_name}`}</span>
                                                </div>
                                            </div>
                                            <div className="flex items-center gap-3">
                                                {pendingAssignments[slot.id] ? (
                                                    <span className="text-xs font-bold px-2 py-1 rounded bg-emerald-50 text-emerald-700 border border-emerald-100">
                                                        Pilihan: {pendingAssignments[slot.id].relief_teacher_name}
                                                    </span>
                                                ) : statusBadge(slot.status)}
                                                {slot.status === 'suggested' && (
                                                    <>
                                                        {pendingAssignments[slot.id] && (
                                                            <button onClick={() => clearPendingRelief(slot.id)} className="text-xs text-red-500 font-bold hover:text-red-700">Buang Pilihan</button>
                                                        )}
                                                        <button onClick={() => loadFreeTeachers(slot)} className="text-xs bg-emerald-600 text-white px-3 py-1.5 rounded font-bold hover:bg-emerald-700">
                                                            {pendingAssignments[slot.id] ? 'Tukar Guru' : 'Pilih Guru'}
                                                        </button>
                                                    </>
                                                )}
                                                {(slot.status === 'assigned' || slot.status === 'completed') && (
                                                    <>
                                                        <span className="text-xs font-bold text-slate-700">{slot.relief_teacher_name}</span>
                                                        {slot.status === 'assigned' && (
                                                            <button onClick={() => acceptRelief(slot.id)} className="text-xs bg-emerald-600 text-white px-2 py-1 rounded font-bold hover:bg-emerald-700">Terima</button>
                                                        )}
                                                        <button onClick={() => cancelRelief(slot.id)} className="text-xs text-red-500 font-bold hover:text-red-700">Batal</button>
                                                    </>
                                                )}
                                                {slot.status === 'completed' && (
                                                    <span className="text-xs font-bold text-slate-600">{slot.relief_teacher_name}</span>
                                                )}
                                                {slot.status === 'declined' && (
                                                    <span className="text-xs text-slate-400 italic">{slot.relief_teacher_name || 'Ditolak'}</span>
                                                )}
                                            </div>
                                        </div>
                                        {/* Free teachers dropdown */}
                                        {expandedRow === slot.id && (
                                            <div className="mt-3 p-3 bg-slate-50 rounded-lg border border-slate-100">
                                                <p className="text-xs font-bold text-slate-500 mb-2">Guru Free Pada Slot Ini:</p>
                                                {freeTeachers[slot.id] && freeTeachers[slot.id].length > 0 ? (
                                                    <div className="grid grid-cols-2 md:grid-cols-3 gap-2">
                                                        {freeTeachers[slot.id].map(t => {
                                                            const loadCount = Number(t.total_slot_count ?? t.daily_slot_count ?? 0);
                                                            const regularCount = Number(t.daily_slot_count ?? loadCount);
                                                            const reliefCount = Number(t.relief_slot_count ?? 0);
                                                            const isHeavyLoad = loadCount >= 5;
                                                            return (
                                                                <button key={t.uid} onClick={() => selectPendingRelief(slot.id, t)} className={`p-2 rounded-lg border transition-all text-sm font-bold flex items-start gap-2 text-left ${pendingAssignments[slot.id]?.relief_teacher_uid === t.uid ? 'border-emerald-500 bg-emerald-50 text-emerald-700' : isHeavyLoad ? 'border-amber-200 bg-amber-50 hover:border-amber-400 text-slate-700' : 'border-slate-200 bg-white hover:border-emerald-500 hover:bg-emerald-50 text-slate-700'}`}>
                                                                    <div className={`w-6 h-6 rounded-full flex items-center justify-center text-xs shrink-0 ${isHeavyLoad ? 'bg-amber-200 text-amber-800' : 'bg-slate-200 text-slate-700'}`}>{t.name?.charAt(0) || '?'}</div>
                                                                    <div className="min-w-0 leading-tight">
                                                                        <div className="truncate">{t.name}</div>
                                                                        <div className={`text-[10px] font-bold mt-0.5 ${isHeavyLoad ? 'text-amber-700' : 'text-slate-400'}`}>
                                                                            {loadCount} slot hari ini{reliefCount > 0 ? ` (${regularCount} jadual + ${reliefCount} ganti)` : ''}{isHeavyLoad ? ' — penuh' : ''}
                                                                        </div>
                                                                    </div>
                                                                </button>
                                                            );
                                                        })}
                                                    </div>
                                                ) : (
                                                    <p className="text-xs text-slate-400 italic">Tiada guru free pada slot ini.</p>
                                                )}
                                            </div>
                                        )}
                                    </div>
                                ))}
                            </div>
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
}

// --- MAIN APP COMPONENT (DITAMBAH UNTUK MEMBETULKAN RALAT REFERENCE) ---
function MainApp() {
    const [user, setUser] = useState(null);
    const [view, setView] = useState('dashboard');
    const [students, setStudents] = useState([]);
    const [teachers, setTeachers] = useState([]);
    const [apps, setApps] = useState([]);
    const [tasks, setTasks] = useState([]);
    const [reports, setReports] = useState([]);
    const [loading, setLoading] = useState(true);
    const [loginLoading, setLoginLoading] = useState(false);
    const [targetClass, setTargetClass] = useState(null); // State baru untuk pilihan kelas automatik

    // --- NOTIFICATION BADGES (relief + attendance) ---
    const [badges, setBadges] = useState({});
    const today = getTodayDate();

    // --- QUICK ACTION FAB ---
    const [fabOpen, setFabOpen] = useState(false);

    // --- PWA AUTO-PROMPT STATES ---
    const [pwaEvent, setPwaEvent] = useState(null);
    const [showPwaNoti, setShowPwaNoti] = useState(false);
    const [isIOS, setIsIOS] = useState(false);

    // --- AUTH: Handle Firebase redirect result (returns from Google OAuth) ---
    useEffect(() => {
        getRedirectResult(auth).then(async (result) => {
            if (result && result.user) {
                console.log('[auth] Redirect result received');
                setLoginLoading(true);
                const idToken = await getIdToken(result.user);
                // Send to backend
                try {
                    const resp = await fetch('/api/auth/google', {
                        method: 'POST',
                        headers: { 'Content-Type': 'application/json' },
                        body: JSON.stringify({ token: idToken })
                    });
                    const result2 = await resp.json();
                    if (result2.token) {
                        console.log('[auth] Redirect login successful:', result2.user);
                        localStorage.setItem('skolahub_jwt', result2.token);
                        setToken(result2.token);
                        setUser(result2.user);
                    }
                } catch (e) {
                    console.error('[auth] Redirect backend error:', e);
                    alert('Log masuk gagal: ' + (e.message || 'Ralat tidak diketahui'));
                } finally {
                    setLoginLoading(false);
                    setLoading(false);
                }
            } else {
                // No redirect result — check stored JWT
                const token = localStorage.getItem('skolahub_jwt');
                if (token) {
                    setToken(token);
                    api('/auth/me').then(u => {
                        console.log('[auth] Session restored:', u.user || u);
                        setUser(u.user || u);
                        setLoading(false);
                    }).catch(() => {
                        console.log('[auth] Stored JWT invalid, clearing');
                        localStorage.removeItem('skolahub_jwt');
                        setToken(null);
                        setLoading(false);
                    });
                } else {
                    setLoading(false);
                }
            }
        }).catch(err => {
            console.error('[auth] getRedirectResult error:', err);
            setLoading(false);
        });
    }, []);

    useEffect(() => {
        if (!user) return;
        const loadData = async () => {
            try {
                const [s, t, a, tk, r] = await Promise.all([
                    api('/students'), api('/teachers'), api('/apps'), api('/tasks'), api('/reports')
                ]);
                // Normalize legacy Firestore reports to new format
                const normalizedReports = r.map(rep => {
                    return {
                        ...rep,
                        // Date: use date field, fallback to created_at
                        date: rep.date || (rep.created_at ? rep.created_at.split(' ')[0] : ''),
                        day: rep.day || (rep.date || rep.created_at ? ['Ahad','Isnin','Selasa','Rabu','Khamis','Jumaat','Sabtu'][new Date(rep.date || rep.created_at).getDay()] : ''),
                        week: rep.week || '',
                        // teachersOnDuty: build from teacher_name if not array
                        teachersOnDuty: Array.isArray(rep.teachersOnDuty) ? rep.teachersOnDuty 
                            : (rep.teachers_on_duty ? (typeof rep.teachers_on_duty === 'string' ? (()=>{try{return JSON.parse(rep.teachers_on_duty)}catch(e){return []}})() : rep.teachers_on_duty) : (rep.teacher_name ? [{ name: rep.teacher_name, note: '' }] : [{ name: '', note: '' }])),
                        // teachersAbsent: ensure array
                        teachersAbsent: Array.isArray(rep.teachersAbsent) ? rep.teachersAbsent 
                            : (rep.teachers_absent ? (typeof rep.teachers_absent === 'string' ? (()=>{try{return JSON.parse(rep.teachers_absent)}catch(e){return []}})() : rep.teachers_absent) : []),
                        // attendance: build from flat fields if not object
                        attendance: (rep.attendance && typeof rep.attendance === 'object') ? rep.attendance 
                            : { d1: rep.d1||'', d2: rep.d2||'', d3: rep.d3||'', d4: rep.d4||'', d5: rep.d5||'', d6: rep.d6||'', pk: rep.pk||'', ppki: rep.ppki||rep.pk||'', pra: rep.pra||'' },
                        // checks: build from flat fields if not object
                        checks: (rep.checks && typeof rep.checks === 'object') ? rep.checks
                            : { kantin: { level: rep.kantin||'Baik', comment: '' }, makanan: { level: rep.makanan||'Baik', comment: '' }, sekolah: { level: rep.level||'Baik', comment: rep.comment||'' }, tandas: { level: rep.tandas||'Baik', comment: '' } },
                        // verification: map legacy fields
                        verifiedBy: rep.verifiedBy || rep.verified_by || '',
                        verifiedAt: rep.verifiedAt || rep.verified_at || null,
                        verifiedId: rep.verifiedId || rep.verified_id || null,
                        adminRemarks: rep.adminRemarks || rep.admin_remarks || '',
                        createdBy: rep.createdBy || rep.created_by || '',
                        createdAt: rep.createdAt || rep.created_at || '',
                        activities: rep.activities || rep.other || rep.note || '',
                        health: rep.health || '',
                        other: rep.other || '',
                        preparedBy: rep.preparedBy || rep.prepared_by || rep.teacher_name || '',
                    };
                });
                setStudents(s); setTeachers(t); setApps(a); setTasks(tk); setReports(normalizedReports);
            } catch (e) { console.error('Data load error:', e); }
        };
        loadData();
        const interval = setInterval(loadData, 5000); // Poll every 5 seconds for "real-time" feel
        return () => clearInterval(interval);
    }, [user]);

    // --- NOTIFICATION BADGES: fetch pending relief count + today's attendance count ---
    useEffect(() => {
        if (!user) return;
        const loadBadges = async () => {
            try {
                const [reliefData, attData] = await Promise.all([
                    api('/relief').catch(() => []),
                    api(`/attendance?date=${today}`).catch(() => [])
                ]);
                // Pending relief = items with status 'suggested' (not yet assigned)
                const reliefCount = Array.isArray(reliefData) ? reliefData.filter(r => r.status === 'suggested').length : 0;
                // Attendance badge = number of classes that haven't submitted attendance today
                const attCount = Array.isArray(attData) ? attData.length : 0;
                setBadges({ relief: reliefCount, attendance: attCount });
            } catch (e) { console.error('Badge load error:', e); }
        };
        loadBadges();
        const badgeInterval = setInterval(loadBadges, 30000); // refresh every 30s
        return () => clearInterval(badgeInterval);
    }, [user, today]);

    // --- PWA AUTO DETECTION LOGIC ---
    useEffect(() => {
        // 1. Android / Desktop Chrome Handler
        const handler = (e) => {
            e.preventDefault();
            setPwaEvent(e);
            setShowPwaNoti(true);
        };
        window.addEventListener('beforeinstallprompt', handler);

        // 2. iOS Safari Handler
        const isIosDevice = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
        const isStandalone = window.matchMedia('(display-mode: standalone)').matches || window.navigator.standalone;
        
        if (isIosDevice && !isStandalone) {
            setIsIOS(true);
            setShowPwaNoti(true);
        }

        return () => window.removeEventListener('beforeinstallprompt', handler);
    }, []);

    const installPwa = async () => {
        if (!pwaEvent) return;
        pwaEvent.prompt();
        const { outcome } = await pwaEvent.userChoice;
        if (outcome === 'accepted') {
            setShowPwaNoti(false);
        }
        setPwaEvent(null);
    };

    const handleLogin = async (idToken) => {
        // Firebase popup gives us the ID token — send to backend
        setLoginLoading(true);
        try {
            console.log('[auth] Sending token to backend...');
            const result = await api('/auth/google', {
                method: 'POST',
                body: JSON.stringify({ token: idToken })
            });
            if (result.token) {
                console.log('[auth] Login successful:', result.user);
                localStorage.setItem('skolahub_jwt', result.token);
                setToken(result.token);
                setUser(result.user);
                setLoading(false);
            }
        } catch (e) {
            console.error('[auth] Backend error:', e.message || e);
            alert('Log masuk gagal: ' + (e.message || 'Ralat tidak diketahui'));
            setLoading(false);
        } finally {
            setLoginLoading(false);
        }
    };

    const handleLogout = async () => {
        localStorage.removeItem('skolahub_jwt');
        setToken(null);
        setUser(null);
        window.location.reload();
    };

    if (loading) return <div className="h-screen flex items-center justify-center"><Loader2 className="w-10 h-10 animate-spin text-emerald-600"/></div>;

    if (!user) return <LoginScreen onGoogleLogin={handleLogin} loginLoading={loginLoading} />;

    return (
        <div className="flex md:flex-row h-screen bg-slate-50 overflow-hidden">
            <Sidebar userData={user} view={view} setView={setView} logout={handleLogout} badges={badges} />
            <div className="flex-1 flex flex-col min-w-0 overflow-hidden">
                <Header userData={user} view={view} />
                <main className="flex-1 overflow-y-auto p-4 md:p-6 no-scrollbar">
                    {view === 'dashboard' && <Dashboard 
                        userData={user} apps={apps} students={students} teachers={teachers} tasks={tasks} 
                        setView={setView} 
                        setTargetClass={setTargetClass} // Pass setter ke Dashboard
                    />}
                    {view === 'mmi' && <MMIManager userData={user} currentUid={user.uid} students={students} teachers={teachers} />}
                    {view === 'timetable' && <TimetableManager userData={user} currentUid={user.uid} students={students} teachers={teachers} />}
                    {view === 'apps' && <AppGallery apps={apps} />}
                    {/* UBAH: SEMUA GURU BOLEH EDIT TAKWIM (canEdit sentiasa true) */}
                    {view === 'takwim' && <TakwimManager canEdit={true} role={user.role} currentUid={user.uid} />}
                    {view === 'attendance' && <AttendanceManager 
                        students={students} userData={user} 
                        preSelectedClass={targetClass} // Pass getter ke AttendanceManager
                    />}
                    {view === 'tasks' && <TaskManager userData={user} tasks={tasks} currentUid={user.uid} />}
                    {view === 'reports' && <WeeklyReportManager userData={user} reports={reports} teachers={teachers} currentUid={user.uid} />}
                    {view === 'agihan' && <AgihanTugasManager teachers={teachers} canEdit={user.role === 'admin'} />}
                    {view === 'builder' && <AppBuilder apps={apps} userData={user} />}
                    {view === 'keberadaan' && (['admin', 'pentadbir'].includes(user.role) ? <KeberadaanManager userData={user} teachers={teachers} /> : <AccessDenied />)}
                    {view === 'relief' && (
                      ['admin', 'pentadbir'].includes(user.role)
                        ? <ReliefManager userData={user} teachers={teachers} />
                        : user.role === 'guru'
                          ? <GuruReliefView userData={user} />
                          : <AccessDenied />
                    )}
                    {view === 'students' && (['admin', 'pentadbir'].includes(user.role) ? <DataTable type="student" data={students} currentUserRole={user.role} /> : <AccessDenied />)}
                    {view === 'teachers' && (['admin', 'pentadbir'].includes(user.role) ? <DataTable type="teacher" data={teachers} currentUserRole={user.role} /> : <AccessDenied />)}
                    {view === 'logs' && (user.role === 'admin' ? <SystemLogs /> : <AccessDenied />)}
                    {view === 'stats' && (user.role === 'admin' ? <UsageStats /> : <AccessDenied />)}
                    {view === 'settings' && (user.role === 'admin' ? <SettingsManager /> : <AccessDenied />)}
                </main>
            </div>

            {/* --- QUICK ACTION FAB (Desktop Only, when logged in) --- */}
            <div className="hidden md:flex fixed bottom-6 right-6 z-40 flex-col items-end gap-3 no-print">
                {fabOpen && (
                    <>
                        <button onClick={() => { setView('reports'); setFabOpen(false); }} className="group flex items-center gap-2 bg-white border border-slate-200 shadow-lg rounded-full pl-4 pr-5 py-2.5 hover:bg-emerald-50 hover:border-emerald-200 transition-all animate-fade-in">
                            <FileText className="w-4 h-4 text-emerald-600"/>
                            <span className="text-sm font-bold text-slate-700 group-hover:text-emerald-700">Buat Laporan</span>
                        </button>
                        <button onClick={() => { setView('mmi'); setFabOpen(false); }} className="group flex items-center gap-2 bg-white border border-slate-200 shadow-lg rounded-full pl-4 pr-5 py-2.5 hover:bg-emerald-50 hover:border-emerald-200 transition-all animate-fade-in">
                            <QrCode className="w-4 h-4 text-emerald-600"/>
                            <span className="text-sm font-bold text-slate-700 group-hover:text-emerald-700">Rekod MMI</span>
                        </button>
                        <button onClick={() => { setView('attendance'); setFabOpen(false); }} className="group flex items-center gap-2 bg-white border border-slate-200 shadow-lg rounded-full pl-4 pr-5 py-2.5 hover:bg-emerald-50 hover:border-emerald-200 transition-all animate-fade-in">
                            <UserCheck className="w-4 h-4 text-emerald-600"/>
                            <span className="text-sm font-bold text-slate-700 group-hover:text-emerald-700">Tandai Kehadiran</span>
                        </button>
                    </>
                )}
                <button onClick={() => setFabOpen(!fabOpen)} className={`w-14 h-14 rounded-full shadow-xl flex items-center justify-center text-white transition-all ${fabOpen ? 'bg-emerald-700 rotate-45' : 'bg-emerald-600 hover:bg-emerald-700 hover:scale-105'}`}>
                    <Plus className="w-6 h-6"/>
                </button>
            </div>

            {/* --- PWA AUTO NOTIFICATION POPUP --- */}
            {showPwaNoti && (
                <div className="fixed inset-0 bg-black/60 z-[100] flex items-end md:items-center justify-center p-4 animate-fade-in">
                    <div className="bg-white rounded-2xl w-full max-w-sm p-6 shadow-2xl relative">
                        <button onClick={() => setShowPwaNoti(false)} className="absolute top-4 right-4 text-slate-400 hover:text-slate-600"><X /></button>
                        
                        <div className="flex flex-col items-center text-center">
                            <div className="w-20 h-20 bg-white rounded-2xl shadow-lg border border-slate-100 flex items-center justify-center mb-4">
                                <img src="/assets/img/school-logo.png" className="w-14 h-14 object-contain" />
                            </div>
                            <h3 className="text-xl font-bold text-slate-800 mb-2">Pasang Aplikasi SkolaHub</h3>
                            <p className="text-slate-500 text-sm mb-6">Akses sistem SK Masjid Tanah dengan lebih pantas terus dari Home Screen anda.</p>
                            
                            {isIOS ? (
                                <div className="w-full bg-slate-50 p-4 rounded-xl text-left text-sm border border-slate-200">
                                    <p className="font-bold text-slate-700 mb-2 flex items-center gap-2"><div className="w-2 h-2 bg-emerald-500 rounded-full"></div> Pengguna iPhone / iPad:</p>
                                    <ol className="list-decimal pl-4 space-y-2 text-slate-600 text-xs">
                                        <li>Tekan butang <span className="font-bold"><Share className="inline w-3 h-3"/> Share</span> di bahagian bawah browser.</li>
                                        <li>Skrol ke bawah & pilih <span className="font-bold">Add to Home Screen</span>.</li>
                                        <li>Tekan <span className="font-bold">Add</span> di penjuru atas.</li>
                                    </ol>
                                </div>
                            ) : (
                                <button onClick={installPwa} className="w-full bg-emerald-600 hover:bg-emerald-700 text-white font-bold py-3 rounded-xl shadow-lg flex items-center justify-center gap-2 transform active:scale-95 transition-all">
                                    <Download size={20} />
                                    Pasang Sekarang
                                </button>
                            )}
                            
                            <button onClick={() => setShowPwaNoti(false)} className="mt-4 text-xs text-slate-400 font-bold hover:text-slate-600 uppercase tracking-wider">Nanti Dulu</button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}

export default MainApp;
